/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost:8080".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = isomorphicFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AccountBean
 */
export interface AccountBean {
    /**
     * 
     * @type {number}
     * @memberof AccountBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    timezoneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    role?: AccountBean.RoleEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    passwordConfirm?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    currentPassword?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountBean
     */
    agencyId?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    agencyPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    agencyName?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    advertiserName?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountBean
     */
    publisherId?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    apiToken?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountBean
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AccountBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace AccountBean
 */
export namespace AccountBean {
    /**
     * @export
     * @enum {string}
     */
    export enum RoleEnum {
        SuperAdmin = <any> 'Super Admin',
        Admin = <any> 'Admin',
        Advertiser = <any> 'Advertiser',
        Publisher = <any> 'Publisher'
    }
}
/**
 * 
 * @export
 * @interface AccountListItemBean
 */
export interface AccountListItemBean {
    /**
     * 
     * @type {number}
     * @memberof AccountListItemBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountListItemBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountListItemBean
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountListItemBean
     */
    timezoneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountListItemBean
     */
    role?: AccountListItemBean.RoleEnum;
    /**
     * 
     * @type {number}
     * @memberof AccountListItemBean
     */
    agencyId?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountListItemBean
     */
    agencyName?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountListItemBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountListItemBean
     */
    advertiserName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountListItemBean
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AccountListItemBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace AccountListItemBean
 */
export namespace AccountListItemBean {
    /**
     * @export
     * @enum {string}
     */
    export enum RoleEnum {
        SuperAdmin = <any> 'Super Admin',
        Admin = <any> 'Admin',
        Advertiser = <any> 'Advertiser',
        Publisher = <any> 'Publisher'
    }
}
/**
 * 
 * @export
 * @interface AdGroupBean
 */
export interface AdGroupBean {
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdGroupBean
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    advertiserId: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    campaignId: number;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    priority: AdGroupBean.PriorityEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    iabCategoriesIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    endDate?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    creativeIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    budgetType: AdGroupBean.BudgetTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    totalBudget?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    dailyBudget?: number;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    deliveryType: AdGroupBean.DeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    pricingType: AdGroupBean.PricingTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    cost?: number;
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof AdGroupBean
     */
    dayParting?: Array<Array<number>>;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    totalFC?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    dailyFC?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    totalFCBySource?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    dailyFCBySource?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    sspIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    mediaType: AdGroupBean.MediaTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    userLanguages?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    countriesIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    regionIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    cityIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    companyNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    deviceTypes?: Array<AdGroupBean.DeviceTypesEnum>;
    /**
     * 
     * @type {Array<OperatingSystem>}
     * @memberof AdGroupBean
     */
    operatingSystems?: Array<OperatingSystem>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    browsers?: Array<AdGroupBean.BrowsersEnum>;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    bidswitchSspListMode?: AdGroupBean.BidswitchSspListModeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    bidswitchSspList?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    dealIdListMode?: AdGroupBean.DealIdListModeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    dealIdList?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    adUnitIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    domainListMode?: AdGroupBean.DomainListModeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    domainList?: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    appListMode?: AdGroupBean.AppListModeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    appList?: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    ipV4ListMode?: AdGroupBean.IpV4ListModeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    ipV4List?: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    ipV6ListMode?: AdGroupBean.IpV6ListModeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    ipV6List?: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    userIdListMode?: AdGroupBean.UserIdListModeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    userIdList?: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    idfaListMode?: AdGroupBean.IdfaListModeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    idfaList?: string;
    /**
     * 
     * @type {Array<FilterListLinkBean>}
     * @memberof AdGroupBean
     */
    filterListLinks?: Array<FilterListLinkBean>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    retargetingListIds?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    costTarget?: number;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    optimizationType?: AdGroupBean.OptimizationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    minBidCpm?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    maxBidCpm?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    optimizationPeriod?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    acceptanceRate?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupBean
     */
    revShare?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdGroupBean
     */
    publisherIabCategoriesIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    connectionTypes?: Array<AdGroupBean.ConnectionTypesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof AdGroupBean
     */
    adFraudStatus?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    adFraudProtectionType?: AdGroupBean.AdFraudProtectionTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    adFraudTypes?: Array<AdGroupBean.AdFraudTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    visibilityType?: AdGroupBean.VisibilityTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    visibilityGroups?: Array<AdGroupBean.VisibilityGroupsEnum>;
    /**
     * 
     * @type {Array<IasBrandSafetyCodeBean>}
     * @memberof AdGroupBean
     */
    brandSafetyTypes?: Array<IasBrandSafetyCodeBean>;
    /**
     * 
     * @type {Date}
     * @memberof AdGroupBean
     */
    modified?: Date;
    /**
     * Keywords for contextual targeting
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    keywords?: Array<string>;
    /**
     * Brand safety categories to be targeted
     * @type {Array<string>}
     * @memberof AdGroupBean
     */
    brandSafety?: Array<AdGroupBean.BrandSafetyEnum>;
    /**
     * 
     * @type {string}
     * @memberof AdGroupBean
     */
    coppa: AdGroupBean.CoppaEnum;
}

/**
 * @export
 * @namespace AdGroupBean
 */
export namespace AdGroupBean {
    /**
     * @export
     * @enum {string}
     */
    export enum PriorityEnum {
        High = <any> 'High',
        Medium = <any> 'Medium',
        Low = <any> 'Low'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BudgetTypeEnum {
        Total = <any> 'Total',
        Daily = <any> 'Daily',
        TotalDaily = <any> 'Total & Daily'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DeliveryTypeEnum {
        AsSoonAsPossible = <any> 'As soon as possible',
        Distributed = <any> 'Distributed'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PricingTypeEnum {
        CPM = <any> 'CPM',
        CPC = <any> 'CPC',
        CPI = <any> 'CPI',
        CPA = <any> 'CPA'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MediaTypeEnum {
        All = <any> 'All',
        Sites = <any> 'Sites',
        Apps = <any> 'Apps'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DeviceTypesEnum {
        Desktop = <any> 'Desktop',
        Tablet = <any> 'Tablet',
        Mobile = <any> 'Mobile',
        ConnectedTV = <any> 'ConnectedTV',
        ConnectedDevice = <any> 'ConnectedDevice',
        SetTopBox = <any> 'SetTopBox',
        OOHDevice = <any> 'OOHDevice',
        Other = <any> 'Other',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BrowsersEnum {
        Chrome = <any> 'Chrome',
        Firefox = <any> 'Firefox',
        Safari = <any> 'Safari',
        Opera = <any> 'Opera',
        WebView = <any> 'WebView',
        InternetExplorer = <any> 'Internet Explorer',
        Edge = <any> 'Edge'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BidswitchSspListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DealIdListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DomainListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AppListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum IpV4ListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum IpV6ListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum UserIdListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum IdfaListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OptimizationTypeEnum {
        None = <any> 'None',
        CTR = <any> 'CTR',
        CPA = <any> 'CPA',
        CVR = <any> 'CVR'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ConnectionTypesEnum {
        Wifi = <any> 'Wifi',
        Ethernet = <any> 'Ethernet',
        Cellular = <any> 'Cellular',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AdFraudProtectionTypeEnum {
        LowProtection = <any> 'LowProtection',
        ModerateProtection = <any> 'ModerateProtection',
        HighProtection = <any> 'HighProtection'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AdFraudTypesEnum {
        HighRisk = <any> 'Avoid_High_Risk',
        HighAndModerateRisk = <any> 'Avoid_High_And_Moderate_Risk',
        PagesNotRatedForBrandSafety = <any> 'Avoid_Pages_Not_Rated_For_Brand_Safety'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum VisibilityTypeEnum {
        _50 = <any> 'HIGHER_THAN_50',
        _60 = <any> 'HIGHER_THAN_60',
        _70 = <any> 'HIGHER_THAN_70'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum VisibilityGroupsEnum {
        GroupM = <any> 'GroupM',
        MRC = <any> 'MRC',
        Publicis = <any> 'Publicis'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BrandSafetyEnum {
        Adult = <any> 'Adult',
        ArmsAmmunition = <any> 'ArmsAmmunition',
        CrimeHarmfulActs = <any> 'CrimeHarmfulActs',
        DeathInjuryConflict = <any> 'DeathInjuryConflict',
        OnlinePiracy = <any> 'OnlinePiracy',
        HateSpeech = <any> 'HateSpeech',
        ObscenityProfanity = <any> 'ObscenityProfanity',
        DrugsAlcohol = <any> 'DrugsAlcohol',
        SpamHarmful = <any> 'SpamHarmful',
        Terrorism = <any> 'Terrorism',
        SensitiveSocialIssue = <any> 'SensitiveSocialIssue'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CoppaEnum {
        Include = <any> 'Include',
        Exclude = <any> 'Exclude',
        Only = <any> 'Only'
    }
}
/**
 * 
 * @export
 * @interface AdGroupListItemBean
 */
export interface AdGroupListItemBean {
    /**
     * 
     * @type {number}
     * @memberof AdGroupListItemBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupListItemBean
     */
    campaignId?: number;
    /**
     * 
     * @type {string}
     * @memberof AdGroupListItemBean
     */
    campaignName?: string;
    /**
     * 
     * @type {number}
     * @memberof AdGroupListItemBean
     */
    creatives?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupListItemBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof AdGroupListItemBean
     */
    advertiserName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupListItemBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupListItemBean
     */
    priority?: AdGroupListItemBean.PriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof AdGroupListItemBean
     */
    status?: AdGroupListItemBean.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdGroupListItemBean
     */
    lifeStatus?: AdGroupListItemBean.LifeStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdGroupListItemBean
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdGroupListItemBean
     */
    budgetRatio?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupListItemBean
     */
    dailyCost?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupListItemBean
     */
    totalCost?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupListItemBean
     */
    dailyBudget?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupListItemBean
     */
    totalBudget?: number;
    /**
     * 
     * @type {string}
     * @memberof AdGroupListItemBean
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupListItemBean
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AdGroupListItemBean
     */
    endDate?: string;
    /**
     * 
     * @type {Date}
     * @memberof AdGroupListItemBean
     */
    modified?: Date;
    /**
     * 
     * @type {number}
     * @memberof AdGroupListItemBean
     */
    daysLeft?: number;
    /**
     * 
     * @type {AdGroupStatsBean}
     * @memberof AdGroupListItemBean
     */
    adGroupStats?: AdGroupStatsBean;
}

/**
 * @export
 * @namespace AdGroupListItemBean
 */
export namespace AdGroupListItemBean {
    /**
     * @export
     * @enum {string}
     */
    export enum PriorityEnum {
        High = <any> 'High',
        Medium = <any> 'Medium',
        Low = <any> 'Low'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Pending = <any> 'Pending',
        Approved = <any> 'Approved',
        Refused = <any> 'Refused'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LifeStatusEnum {
        Running = <any> 'Running',
        Completed = <any> 'Completed'
    }
}
/**
 * 
 * @export
 * @interface AdGroupStatsBean
 */
export interface AdGroupStatsBean {
    /**
     * 
     * @type {number}
     * @memberof AdGroupStatsBean
     */
    impressions?: number;
    /**
     * 
     * @type {number}
     * @memberof AdGroupStatsBean
     */
    clicks?: number;
}
/**
 * 
 * @export
 * @interface AdUnitBean
 */
export interface AdUnitBean {
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    publisherId: number;
    /**
     * 
     * @type {string}
     * @memberof AdUnitBean
     */
    publisherName?: string;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    publisherRevShare?: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    siteId: number;
    /**
     * 
     * @type {string}
     * @memberof AdUnitBean
     */
    siteName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdUnitBean
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    height: number;
    /**
     * 
     * @type {string}
     * @memberof AdUnitBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdUnitBean
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof AdUnitBean
     */
    defaultAdTag: string;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    fixedCpmPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    bidFloor?: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    revShare?: number;
    /**
     * 
     * @type {string}
     * @memberof AdUnitBean
     */
    revenueType: AdUnitBean.RevenueTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdUnitBean
     */
    deviceTypes?: Array<AdUnitBean.DeviceTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof AdUnitBean
     */
    position?: AdUnitBean.PositionEnum;
    /**
     * 
     * @type {Array<DspAdUnitBean>}
     * @memberof AdUnitBean
     */
    dspAdUnitBeans?: Array<DspAdUnitBean>;
    /**
     * 
     * @type {string}
     * @memberof AdUnitBean
     */
    formatType?: AdUnitBean.FormatTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    startDelay?: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    placement?: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    linearity?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdUnitBean
     */
    mimeTypes?: Array<AdUnitBean.MimeTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    minDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitBean
     */
    maxDuration?: number;
    /**
     * 
     * @type {Date}
     * @memberof AdUnitBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace AdUnitBean
 */
export namespace AdUnitBean {
    /**
     * @export
     * @enum {string}
     */
    export enum RevenueTypeEnum {
        FixedCPM = <any> 'FixedCPM',
        RevShare = <any> 'RevShare',
        CPC = <any> 'CPC'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DeviceTypesEnum {
        Desktop = <any> 'Desktop',
        Tablet = <any> 'Tablet',
        Mobile = <any> 'Mobile',
        ConnectedTV = <any> 'ConnectedTV',
        ConnectedDevice = <any> 'ConnectedDevice',
        SetTopBox = <any> 'SetTopBox',
        OOHDevice = <any> 'OOHDevice',
        Other = <any> 'Other',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionEnum {
        Above = <any> 'Above',
        Below = <any> 'Below',
        Fullscreen = <any> 'Fullscreen'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FormatTypeEnum {
        Banner = <any> 'Banner',
        Native = <any> 'Native',
        Video = <any> 'Video'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MimeTypesEnum {
        Mpeg = <any> 'video/mpeg',
        Mp4 = <any> 'video/mp4',
        Ogg = <any> 'video/ogg',
        Quicktime = <any> 'video/quicktime',
        Webm = <any> 'video/webm',
        XMsWmv = <any> 'video/x-ms-wmv',
        XFlv = <any> 'video/x-flv',
        _3gpp = <any> 'video/3gpp',
        _3gpp2 = <any> 'video/3gpp2'
    }
}
/**
 * 
 * @export
 * @interface AdUnitIdResultBean
 */
export interface AdUnitIdResultBean {
    /**
     * 
     * @type {number}
     * @memberof AdUnitIdResultBean
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitIdResultBean
     */
    updated?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AdUnitIdResultBean
     */
    errorMap?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface AdvertiserBalanceBean
 */
export interface AdvertiserBalanceBean {
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBalanceBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBalanceBean
     */
    advertiserId: number;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserBalanceBean
     */
    advertiserName: string;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBalanceBean
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBalanceBean
     */
    available: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBalanceBean
     */
    runtimeAvailable: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdvertiserBalanceBean
     */
    stripePaymentsEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBalanceBean
     */
    impressionsPerSecond?: number;
}
/**
 * 
 * @export
 * @interface AdvertiserBean
 */
export interface AdvertiserBean {
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBean
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdvertiserBean
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserBean
     */
    timezoneId: string;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserBean
     */
    revShare?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdvertiserBean
     */
    trusted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdvertiserBean
     */
    paymentBlocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserBean
     */
    paymentBlockedReason?: string;
    /**
     * 
     * @type {Date}
     * @memberof AdvertiserBean
     */
    paymentBlockedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AdvertiserBean
     */
    modified?: Date;
}
/**
 * 
 * @export
 * @interface AdvertiserListItemBean
 */
export interface AdvertiserListItemBean {
    /**
     * 
     * @type {number}
     * @memberof AdvertiserListItemBean
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdvertiserListItemBean
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserListItemBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserListItemBean
     */
    timezone?: string;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserListItemBean
     */
    revShare?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserListItemBean
     */
    accounts?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdvertiserListItemBean
     */
    trusted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdvertiserListItemBean
     */
    paymentBlocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdvertiserListItemBean
     */
    paymentBlockedReason?: string;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserListItemBean
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserListItemBean
     */
    available: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertiserListItemBean
     */
    runtimeAvailable: number;
    /**
     * 
     * @type {Date}
     * @memberof AdvertiserListItemBean
     */
    modified?: Date;
}
/**
 * 
 * @export
 * @interface AgencyBalanceBean
 */
export interface AgencyBalanceBean {
    /**
     * 
     * @type {number}
     * @memberof AgencyBalanceBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyBalanceBean
     */
    agencyId?: number;
    /**
     * 
     * @type {string}
     * @memberof AgencyBalanceBean
     */
    agencyName?: string;
    /**
     * 
     * @type {number}
     * @memberof AgencyBalanceBean
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyBalanceBean
     */
    available?: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyBalanceBean
     */
    runtimeAvailable?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyBalanceBean
     */
    stripePaymentsEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface AgencyBean
 */
export interface AgencyBean {
    /**
     * 
     * @type {number}
     * @memberof AgencyBean
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyBean
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyBean
     */
    paymentBlocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    paymentBlockedReason?: string;
    /**
     * 
     * @type {Date}
     * @memberof AgencyBean
     */
    paymentBlockedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyBean
     */
    uiAccess: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyBean
     */
    advertiserSelfRegistration?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    publicId: string;
    /**
     * 
     * @type {number}
     * @memberof AgencyBean
     */
    accounts?: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyBean
     */
    revShare?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AgencyBean
     */
    sspIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AgencyBean
     */
    publisherIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    cdnDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    agencyDomains?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    advertiserDomains?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    endpointDomains?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencyBean
     */
    featureAccess: Array<AgencyBean.FeatureAccessEnum>;
    /**
     * 
     * @type {number}
     * @memberof AgencyBean
     */
    systemSspTotalBudget?: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyBean
     */
    systemSspBudgetAvailable?: number;
    /**
     * 
     * @type {Date}
     * @memberof AgencyBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace AgencyBean
 */
export namespace AgencyBean {
    /**
     * @export
     * @enum {string}
     */
    export enum FeatureAccessEnum {
        Advertiser = <any> 'Advertiser',
        DSP = <any> 'DSP',
        Publisher = <any> 'Publisher',
        SSP = <any> 'SSP'
    }
}
/**
 * 
 * @export
 * @interface AgencyOperationBean
 */
export interface AgencyOperationBean {
    /**
     * 
     * @type {number}
     * @memberof AgencyOperationBean
     */
    agencyId: number;
    /**
     * 
     * @type {string}
     * @memberof AgencyOperationBean
     */
    operationType: AgencyOperationBean.OperationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AgencyOperationBean
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof AgencyOperationBean
     */
    note?: string;
}

/**
 * @export
 * @namespace AgencyOperationBean
 */
export namespace AgencyOperationBean {
    /**
     * @export
     * @enum {string}
     */
    export enum OperationTypeEnum {
        ADD = <any> 'ADD',
        SUBTRACT = <any> 'SUBTRACT'
    }
}
/**
 * 
 * @export
 * @interface AgencyTransactionBean
 */
export interface AgencyTransactionBean {
    /**
     * 
     * @type {number}
     * @memberof AgencyTransactionBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyTransactionBean
     */
    agencyId?: number;
    /**
     * 
     * @type {string}
     * @memberof AgencyTransactionBean
     */
    agencyName?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyTransactionBean
     */
    transactionType?: AgencyTransactionBean.TransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AgencyTransactionBean
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyTransactionBean
     */
    amountBefore?: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyTransactionBean
     */
    amountAfter?: number;
    /**
     * 
     * @type {number}
     * @memberof AgencyTransactionBean
     */
    totalSpends?: number;
    /**
     * 
     * @type {string}
     * @memberof AgencyTransactionBean
     */
    paySystem?: AgencyTransactionBean.PaySystemEnum;
    /**
     * 
     * @type {string}
     * @memberof AgencyTransactionBean
     */
    note?: string;
    /**
     * 
     * @type {Date}
     * @memberof AgencyTransactionBean
     */
    created?: Date;
}

/**
 * @export
 * @namespace AgencyTransactionBean
 */
export namespace AgencyTransactionBean {
    /**
     * @export
     * @enum {string}
     */
    export enum TransactionTypeEnum {
        AGENCYPAY = <any> 'AGENCY_PAY',
        ADVERTISERPAY = <any> 'ADVERTISER_PAY',
        BIDDINGSPENDS = <any> 'BIDDING_SPENDS',
        ANTIFRAUDSPENDS = <any> 'ANTI_FRAUD_SPENDS',
        ADMINADDING = <any> 'ADMIN_ADDING',
        ADMINSUBTRACTION = <any> 'ADMIN_SUBTRACTION'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PaySystemEnum {
        MONEY = <any> 'MONEY',
        STRIPE = <any> 'STRIPE'
    }
}
/**
 * 
 * @export
 * @interface ApiCreativeBody
 */
export interface ApiCreativeBody {
    /**
     * 
     * @type {Blob}
     * @memberof ApiCreativeBody
     */
    icon?: Blob;
    /**
     * 
     * @type {Blob}
     * @memberof ApiCreativeBody
     */
    media?: Blob;
    /**
     * 
     * @type {Array<Blob>}
     * @memberof ApiCreativeBody
     */
    nativeImages?: Array<Blob>;
    /**
     * 
     * @type {Array<Blob>}
     * @memberof ApiCreativeBody
     */
    nativeVideos?: Array<Blob>;
}
/**
 * 
 * @export
 * @interface ApiReportBody
 */
export interface ApiReportBody {
}
/**
 * 
 * @export
 * @interface AuthLog
 */
export interface AuthLog {
    /**
     * 
     * @type {number}
     * @memberof AuthLog
     */
    time?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    eventType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthLog
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    failureReason?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    interfaceId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    login?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthLog
     */
    agencyId?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    agencyName?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthLog
     */
    accountId?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    accountName?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthLog
     */
    actorAccountId?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    actorAccountName?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    clientIp?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    xffRaw?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    host?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    origin?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLog
     */
    referer?: string;
}
/**
 * 
 * @export
 * @interface Breakdown
 */
export interface Breakdown {
    /**
     * 
     * @type {Array<SspReportLine>}
     * @memberof Breakdown
     */
    breakdown?: Array<SspReportLine>;
}
/**
 * 
 * @export
 * @interface BulkResultBean
 */
export interface BulkResultBean {
    /**
     * 
     * @type {number}
     * @memberof BulkResultBean
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkResultBean
     */
    created?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BulkResultBean
     */
    errorMap?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CampaignBean
 */
export interface CampaignBean {
    /**
     * 
     * @type {number}
     * @memberof CampaignBean
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignBean
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof CampaignBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignBean
     */
    totalBudget?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignBean
     */
    dailyBudget?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignBean
     */
    currency?: CampaignBean.CurrencyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignBean
     */
    currencyLocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CampaignBean
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignBean
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignBean
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignBean
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignBean
     */
    budgetRatio?: number;
    /**
     * 
     * @type {Date}
     * @memberof CampaignBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace CampaignBean
 */
export namespace CampaignBean {
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        EUR = <any> 'EUR'
    }
}
/**
 * 
 * @export
 * @interface CampaignListItemBean
 */
export interface CampaignListItemBean {
    /**
     * 
     * @type {number}
     * @memberof CampaignListItemBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItemBean
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignListItemBean
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItemBean
     */
    adGroups?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItemBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItemBean
     */
    advertiserName?: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItemBean
     */
    dailyCost?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItemBean
     */
    totalCost?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItemBean
     */
    dailyBudget?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItemBean
     */
    totalBudget?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItemBean
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItemBean
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItemBean
     */
    endDate?: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItemBean
     */
    daysLeft?: number;
    /**
     * 
     * @type {Date}
     * @memberof CampaignListItemBean
     */
    modified?: Date;
}
/**
 * 
 * @export
 * @interface CityBean
 */
export interface CityBean {
    /**
     * 
     * @type {number}
     * @memberof CityBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CityBean
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CityBean
     */
    regionId?: number;
    /**
     * 
     * @type {string}
     * @memberof CityBean
     */
    regionName?: string;
    /**
     * 
     * @type {number}
     * @memberof CityBean
     */
    countryId?: number;
    /**
     * 
     * @type {string}
     * @memberof CityBean
     */
    countryName?: string;
}
/**
 * 
 * @export
 * @interface CompanyBean
 */
export interface CompanyBean {
    /**
     * 
     * @type {string}
     * @memberof CompanyBean
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface CountryBean
 */
export interface CountryBean {
    /**
     * 
     * @type {number}
     * @memberof CountryBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CountryBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CountryBean
     */
    iso3: string;
}
/**
 * 
 * @export
 * @interface CreativeBean
 */
export interface CreativeBean {
    /**
     * 
     * @type {number}
     * @memberof CreativeBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    status?: CreativeBean.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    refusedReason?: CreativeBean.RefusedReasonEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreativeBean
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    format: CreativeBean.FormatEnum;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    adCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    site?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    media?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    redirectUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    finalUrl: string;
    /**
     * 
     * @type {number}
     * @memberof CreativeBean
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeBean
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    aspectRatio?: CreativeBean.AspectRatioEnum;
    /**
     * 
     * @type {number}
     * @memberof CreativeBean
     */
    mediaDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeBean
     */
    iconWidth?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeBean
     */
    iconHeight?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreativeBean
     */
    secure?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreativeBean
     */
    mraid?: Array<CreativeBean.MraidEnum>;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    thirdPartyTracking?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreativeBean
     */
    position?: Array<CreativeBean.PositionEnum>;
    /**
     * 
     * @type {string}
     * @memberof CreativeBean
     */
    impressionPixel?: string;
    /**
     * 
     * @type {number}
     * @memberof CreativeBean
     */
    totalImpressionCapping?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeBean
     */
    dailyImpressionCapping?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreativeBean
     */
    adGroupIds?: Array<number>;
    /**
     * 
     * @type {NativeDataBean}
     * @memberof CreativeBean
     */
    nativeData?: NativeDataBean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreativeBean
     */
    videoPlacementTypes?: Array<CreativeBean.VideoPlacementTypesEnum>;
    /**
     * 
     * @type {Date}
     * @memberof CreativeBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace CreativeBean
 */
export namespace CreativeBean {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Pending = <any> 'Pending',
        Approved = <any> 'Approved',
        Refused = <any> 'Refused'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum RefusedReasonEnum {
        MisleadingClaims = <any> 'MisleadingClaims',
        ProhibitedContent = <any> 'ProhibitedContent',
        ViolationOfPlatformRules = <any> 'ViolationOfPlatformRules',
        OffensiveOrShockingImagery = <any> 'OffensiveOrShockingImagery',
        LocalRegulations = <any> 'LocalRegulations',
        TrademarkCopyrightIssues = <any> 'TrademarkCopyrightIssues',
        LandingUrlRedirect = <any> 'LandingUrlRedirect',
        LandingUrlUnavailable = <any> 'LandingUrlUnavailable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FormatEnum {
        Audio = <any> 'Audio',
        ImageLink = <any> 'ImageLink',
        HTML = <any> 'HTML',
        HTML5 = <any> 'HTML5',
        SimpleNativeAds = <any> 'SimpleNativeAds',
        NativeAds = <any> 'NativeAds',
        Pop = <any> 'Pop',
        Push = <any> 'Push',
        Video = <any> 'Video',
        VideoVast = <any> 'VideoVast'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AspectRatioEnum {
        Ratio1x1 = <any> 'Ratio1x1',
        Ratio16x9 = <any> 'Ratio16x9',
        Ratio9x16 = <any> 'Ratio9x16',
        Ratio16x10 = <any> 'Ratio16x10',
        Ratio10x16 = <any> 'Ratio10x16',
        Ratio4x3 = <any> 'Ratio4x3',
        Ratio3x4 = <any> 'Ratio3x4',
        Ratio3x2 = <any> 'Ratio3x2',
        Ratio2x3 = <any> 'Ratio2x3'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MraidEnum {
        MRAID2 = <any> 'MRAID2',
        MRAID3 = <any> 'MRAID3'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionEnum {
        Above = <any> 'Above',
        Below = <any> 'Below',
        Fullscreen = <any> 'Fullscreen'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum VideoPlacementTypesEnum {
        InStream = <any> 'InStream',
        InBanner = <any> 'InBanner',
        InArticle = <any> 'InArticle',
        InFeed = <any> 'InFeed',
        InterstitialSliderFloating = <any> 'InterstitialSliderFloating'
    }
}
/**
 * 
 * @export
 * @interface CreativeIdBody
 */
export interface CreativeIdBody {
    /**
     * 
     * @type {Blob}
     * @memberof CreativeIdBody
     */
    icon?: Blob;
    /**
     * 
     * @type {Blob}
     * @memberof CreativeIdBody
     */
    media?: Blob;
    /**
     * 
     * @type {Array<Blob>}
     * @memberof CreativeIdBody
     */
    nativeImages?: Array<Blob>;
    /**
     * 
     * @type {Array<Blob>}
     * @memberof CreativeIdBody
     */
    nativeVideos?: Array<Blob>;
}
/**
 * 
 * @export
 * @interface CreativeListItemBean
 */
export interface CreativeListItemBean {
    /**
     * 
     * @type {number}
     * @memberof CreativeListItemBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeListItemBean
     */
    adGroups?: number;
    /**
     * 
     * @type {string}
     * @memberof CreativeListItemBean
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CreativeListItemBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreativeListItemBean
     */
    advertiserName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreativeListItemBean
     */
    status?: CreativeListItemBean.StatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreativeListItemBean
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreativeListItemBean
     */
    format?: CreativeListItemBean.FormatEnum;
    /**
     * 
     * @type {number}
     * @memberof CreativeListItemBean
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeListItemBean
     */
    height?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreativeListItemBean
     */
    secure?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreativeListItemBean
     */
    indicator?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreativeListItemBean
     */
    position?: Array<CreativeListItemBean.PositionEnum>;
    /**
     * 
     * @type {number}
     * @memberof CreativeListItemBean
     */
    totalImpressionCapping?: number;
    /**
     * 
     * @type {number}
     * @memberof CreativeListItemBean
     */
    dailyImpressionCapping?: number;
    /**
     * 
     * @type {Date}
     * @memberof CreativeListItemBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace CreativeListItemBean
 */
export namespace CreativeListItemBean {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Pending = <any> 'Pending',
        Approved = <any> 'Approved',
        Refused = <any> 'Refused'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FormatEnum {
        Audio = <any> 'Audio',
        ImageLink = <any> 'ImageLink',
        HTML = <any> 'HTML',
        HTML5 = <any> 'HTML5',
        SimpleNativeAds = <any> 'SimpleNativeAds',
        NativeAds = <any> 'NativeAds',
        Pop = <any> 'Pop',
        Push = <any> 'Push',
        Video = <any> 'Video',
        VideoVast = <any> 'VideoVast'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionEnum {
        Above = <any> 'Above',
        Below = <any> 'Below',
        Fullscreen = <any> 'Fullscreen'
    }
}
/**
 * 
 * @export
 * @interface CreativeUploadBody
 */
export interface CreativeUploadBody {
    /**
     * 
     * @type {Blob}
     * @memberof CreativeUploadBody
     */
    file?: Blob;
}
/**
 * 
 * @export
 * @interface CustomFaviconBody
 */
export interface CustomFaviconBody {
    /**
     * 
     * @type {Blob}
     * @memberof CustomFaviconBody
     */
    file: Blob;
}
/**
 * 
 * @export
 * @interface CustomLogoBody
 */
export interface CustomLogoBody {
    /**
     * 
     * @type {Blob}
     * @memberof CustomLogoBody
     */
    file: Blob;
}
/**
 *
 * @export
 * @interface BuildInfoBean
 */
export interface BuildInfoBean {
    /**
     *
     * @type {string}
     * @memberof BuildInfoBean
     */
    version?: string;
}
/**
 *
 * @export
 * @interface CustomizationBean
 */
export interface CustomizationBean {
    /**
     * 
     * @type {string}
     * @memberof CustomizationBean
     */
    title?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomizationBean
     */
    favicon?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomizationBean
     */
    logo?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CustomizationBean
     */
    settings?: { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomizationBean
     */
    featureAccess?: Array<CustomizationBean.FeatureAccessEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof CustomizationBean
     */
    hasLinkedSystemSsps?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomizationBean
     */
    agencyRecognized?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomizationBean
     */
    advertiserSelfRegistration?: boolean;
}

/**
 * @export
 * @namespace CustomizationBean
 */
export namespace CustomizationBean {
    /**
     * @export
     * @enum {string}
     */
    export enum FeatureAccessEnum {
        Advertiser = <any> 'Advertiser',
        DSP = <any> 'DSP',
        Publisher = <any> 'Publisher',
        SSP = <any> 'SSP'
    }
}
/**
 * 
 * @export
 * @interface DealBean
 */
export interface DealBean {
    /**
     * 
     * @type {number}
     * @memberof DealBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DealBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DealBean
     */
    dealId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DealBean
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DealBean
     */
    bidFloor: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DealBean
     */
    deviceTypes?: Array<DealBean.DeviceTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DealBean
     */
    formatTypes?: Array<DealBean.FormatTypesEnum>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DealBean
     */
    domainList?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DealBean
     */
    adSizeList?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DealBean
     */
    auctionType: DealBean.AuctionTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof DealBean
     */
    publishers?: Array<number>;
    /**
     * 
     * @type {Array<DealDspSeatBean>}
     * @memberof DealBean
     */
    dealDspSeatList?: Array<DealDspSeatBean>;
    /**
     * 
     * @type {Date}
     * @memberof DealBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace DealBean
 */
export namespace DealBean {
    /**
     * @export
     * @enum {string}
     */
    export enum DeviceTypesEnum {
        Desktop = <any> 'Desktop',
        Tablet = <any> 'Tablet',
        Mobile = <any> 'Mobile',
        ConnectedTV = <any> 'ConnectedTV',
        ConnectedDevice = <any> 'ConnectedDevice',
        SetTopBox = <any> 'SetTopBox',
        OOHDevice = <any> 'OOHDevice',
        Other = <any> 'Other',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FormatTypesEnum {
        Audio = <any> 'Audio',
        Banner = <any> 'Banner',
        Native = <any> 'Native',
        Pop = <any> 'Pop',
        Push = <any> 'Push',
        Video = <any> 'Video'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AuctionTypeEnum {
        PG = <any> 'PG',
        PreferredDeal = <any> 'Preferred Deal',
        PrivateAuction = <any> 'Private Auction'
    }
}
/**
 * 
 * @export
 * @interface DealDspBean
 */
export interface DealDspBean {
    /**
     * 
     * @type {number}
     * @memberof DealDspBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DealDspBean
     */
    name: string;
}
/**
 * 
 * @export
 * @interface DealDspSeatBean
 */
export interface DealDspSeatBean {
    /**
     * 
     * @type {number}
     * @memberof DealDspSeatBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof DealDspSeatBean
     */
    dealDspId: number;
    /**
     * 
     * @type {number}
     * @memberof DealDspSeatBean
     */
    seatId: number;
}
/**
 * 
 * @export
 * @interface DspAdUnitBean
 */
export interface DspAdUnitBean {
    /**
     * 
     * @type {number}
     * @memberof DspAdUnitBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof DspAdUnitBean
     */
    adUnitId: number;
    /**
     * 
     * @type {number}
     * @memberof DspAdUnitBean
     */
    dspId: number;
    /**
     * 
     * @type {number}
     * @memberof DspAdUnitBean
     */
    adUnit?: number;
}
/**
 * 
 * @export
 * @interface DspBean
 */
export interface DspBean {
    /**
     * 
     * @type {number}
     * @memberof DspBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof DspBean
     */
    revShare: number;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    auctionType: DspBean.AuctionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DspBean
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    endpointUrl: string;
    /**
     * 
     * @type {number}
     * @memberof DspBean
     */
    tmax: number;
    /**
     * 
     * @type {number}
     * @memberof DspBean
     */
    minBidFloor?: number;
    /**
     * 
     * @type {number}
     * @memberof DspBean
     */
    maxQps?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DspBean
     */
    sspIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    publisherListMode?: DspBean.PublisherListModeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof DspBean
     */
    publisherList?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    bidswitchSspList?: string;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    mediaType: DspBean.MediaTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof DspBean
     */
    countriesIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DspBean
     */
    deviceTypes?: Array<DspBean.DeviceTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    domainsListMode?: DspBean.DomainsListModeEnum;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    domainList?: string;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    appsListMode?: DspBean.AppsListModeEnum;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    appList?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DspBean
     */
    gzipCompression: boolean;
    /**
     * 
     * @type {string}
     * @memberof DspBean
     */
    mappingVariable?: string;
    /**
     * 
     * @type {Date}
     * @memberof DspBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace DspBean
 */
export namespace DspBean {
    /**
     * @export
     * @enum {string}
     */
    export enum AuctionTypeEnum {
        All = <any> 'All',
        First = <any> 'First',
        Second = <any> 'Second',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PublisherListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MediaTypeEnum {
        All = <any> 'All',
        Sites = <any> 'Sites',
        Apps = <any> 'Apps'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DeviceTypesEnum {
        Desktop = <any> 'Desktop',
        Tablet = <any> 'Tablet',
        Mobile = <any> 'Mobile',
        ConnectedTV = <any> 'ConnectedTV',
        ConnectedDevice = <any> 'ConnectedDevice',
        SetTopBox = <any> 'SetTopBox',
        OOHDevice = <any> 'OOHDevice',
        Other = <any> 'Other',
        Unknown = <any> 'Unknown'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DomainsListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AppsListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
}
/**
 * 
 * @export
 * @interface DspIdAdUnitIdBody
 */
export interface DspIdAdUnitIdBody {
    /**
     * 
     * @type {Blob}
     * @memberof DspIdAdUnitIdBody
     */
    csv?: Blob;
}
/**
 * 
 * @export
 * @interface DspListItemBean
 */
export interface DspListItemBean {
    /**
     * 
     * @type {number}
     * @memberof DspListItemBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DspListItemBean
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DspListItemBean
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DspListItemBean
     */
    endpointUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof DspListItemBean
     */
    modified?: Date;
}
/**
 * 
 * @export
 * @interface EventReportRequestParameters
 */
export interface EventReportRequestParameters extends ReportRequestParametersObjectObject {
    /**
     * 
     * @type {Array<EventStatKeyColumnDescription>}
     * @memberof EventReportRequestParameters
     */
    keyColumns?: Array<EventStatKeyColumnDescription>;
    /**
     * 
     * @type {Array<EventStatValueColumnDescription>}
     * @memberof EventReportRequestParameters
     */
    valueColumns?: Array<EventStatValueColumnDescription>;
}

/**
 * @export
 * @namespace EventReportRequestParameters
 */
export namespace EventReportRequestParameters {
}
/**
 * 
 * @export
 * @interface EventStatKeyColumnDescription
 */
export interface EventStatKeyColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof EventStatKeyColumnDescription
     */
    column?: EventStatKeyColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof EventStatKeyColumnDescription
     */
    order?: EventStatKeyColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EventStatKeyColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {KeyFilterClause}
     * @memberof EventStatKeyColumnDescription
     */
    where?: KeyFilterClause;
    /**
     * 
     * @type {any}
     * @memberof EventStatKeyColumnDescription
     */
    param?: any;
    /**
     * 
     * @type {string}
     * @memberof EventStatKeyColumnDescription
     */
    alias?: string;
}

/**
 * @export
 * @namespace EventStatKeyColumnDescription
 */
export namespace EventStatKeyColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        Date = <any> 'Date',
        Hour = <any> 'Hour',
        Agency = <any> 'Agency',
        AgencyId = <any> 'AgencyId',
        Ssp = <any> 'Ssp',
        SspId = <any> 'SspId',
        SubSsp = <any> 'SubSsp',
        RequestType = <any> 'RequestType',
        SspReqType = <any> 'SspReqType',
        Publisher = <any> 'Publisher',
        Site = <any> 'Site',
        AdUnit = <any> 'AdUnit',
        Deal = <any> 'Deal',
        PublisherId = <any> 'PublisherId',
        SiteId = <any> 'SiteId',
        AdUnitId = <any> 'AdUnitId',
        DealId = <any> 'DealId',
        SiteType = <any> 'SiteType',
        ReqFormatTypes = <any> 'ReqFormatTypes',
        ReqAdSizes = <any> 'ReqAdSizes',
        Domain = <any> 'Domain',
        Bundle = <any> 'Bundle',
        Company = <any> 'Company',
        Country = <any> 'Country',
        CountryIso3 = <any> 'CountryIso3',
        DeviceType = <any> 'DeviceType',
        Os = <any> 'Os',
        ConnectionType = <any> 'ConnectionType',
        Browser = <any> 'Browser',
        Dsp = <any> 'Dsp',
        DspId = <any> 'DspId',
        Advertiser = <any> 'Advertiser',
        Campaign = <any> 'Campaign',
        AdGroup = <any> 'AdGroup',
        Creative = <any> 'Creative',
        AdvertiserId = <any> 'AdvertiserId',
        CampaignId = <any> 'CampaignId',
        AdGroupId = <any> 'AdGroupId',
        CreativeId = <any> 'CreativeId',
        CampaignDealId = <any> 'CampaignDealId',
        FormatType = <any> 'FormatType',
        SubFormatType = <any> 'SubFormatType',
        AdSize = <any> 'AdSize',
        Tracker = <any> 'Tracker',
        TrackerId = <any> 'TrackerId',
        TrackerEventId = <any> 'TrackerEventId',
        ErrorReason = <any> 'ErrorReason'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface EventStatValueColumnDescription
 */
export interface EventStatValueColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof EventStatValueColumnDescription
     */
    column?: EventStatValueColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof EventStatValueColumnDescription
     */
    order?: EventStatValueColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EventStatValueColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {ValueFilterClause}
     * @memberof EventStatValueColumnDescription
     */
    where?: ValueFilterClause;
    /**
     * 
     * @type {any}
     * @memberof EventStatValueColumnDescription
     */
    param?: any;
    /**
     * 
     * @type {string}
     * @memberof EventStatValueColumnDescription
     */
    alias?: string;
}

/**
 * @export
 * @namespace EventStatValueColumnDescription
 */
export namespace EventStatValueColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        BidRequest = <any> 'BidRequest',
        Request = <any> 'Request',
        DspRequest = <any> 'DspRequest',
        DspBid = <any> 'DspBid',
        Bid = <any> 'Bid',
        Win = <any> 'Win',
        Impression = <any> 'Impression',
        View = <any> 'View',
        Burl = <any> 'Burl',
        Click = <any> 'Click',
        Event = <any> 'Event',
        TrackerEvent = <any> 'TrackerEvent',
        TrackerEventAmount = <any> 'TrackerEventAmount',
        ErrorDspResponse = <any> 'ErrorDspResponse',
        ErrorWin = <any> 'ErrorWin',
        ErrorImpression = <any> 'ErrorImpression',
        ErrorView = <any> 'ErrorView',
        ErrorBurl = <any> 'ErrorBurl',
        ErrorClick = <any> 'ErrorClick',
        ErrorEvent = <any> 'ErrorEvent',
        DspBidPrice = <any> 'DspBidPrice',
        DspBidPriceAvg = <any> 'DspBidPriceAvg',
        BidPriceSystem = <any> 'BidPriceSystem',
        BidPriceNet = <any> 'BidPriceNet',
        BidPriceGross = <any> 'BidPriceGross',
        BidFloor = <any> 'BidFloor',
        BidFloorAvg = <any> 'BidFloorAvg',
        BidPriceSystemAvg = <any> 'BidPriceSystemAvg',
        BidPriceNetAvg = <any> 'BidPriceNetAvg',
        BidPriceGrossAvg = <any> 'BidPriceGrossAvg',
        ClickPriceTargetGross = <any> 'ClickPriceTargetGross',
        ClickPriceTargetGrossAvg = <any> 'ClickPriceTargetGrossAvg',
        WinPriceSystem = <any> 'WinPriceSystem',
        WinPriceNet = <any> 'WinPriceNet',
        WinPriceGross = <any> 'WinPriceGross',
        WinPriceSystemAvg = <any> 'WinPriceSystemAvg',
        WinPriceNetAvg = <any> 'WinPriceNetAvg',
        WinPriceGrossAvg = <any> 'WinPriceGrossAvg',
        ImprPriceSystem = <any> 'ImprPriceSystem',
        ImprPriceNet = <any> 'ImprPriceNet',
        ImprPriceGross = <any> 'ImprPriceGross',
        ViewPriceSystem = <any> 'ViewPriceSystem',
        ViewPriceSystemAvg = <any> 'ViewPriceSystemAvg',
        BurlPriceSystem = <any> 'BurlPriceSystem',
        BurlPriceSystemAvg = <any> 'BurlPriceSystemAvg',
        ImprPriceSystemAvg = <any> 'ImprPriceSystemAvg',
        ImprPriceNetAvg = <any> 'ImprPriceNetAvg',
        ImprPriceGrossAvg = <any> 'ImprPriceGrossAvg',
        ClickPriceSystem = <any> 'ClickPriceSystem',
        ClickPriceNet = <any> 'ClickPriceNet',
        ClickPriceGross = <any> 'ClickPriceGross',
        ClickPriceSystemAvg = <any> 'ClickPriceSystemAvg',
        ClickPriceNetAvg = <any> 'ClickPriceNetAvg',
        ClickPriceGrossAvg = <any> 'ClickPriceGrossAvg',
        CostSystem = <any> 'CostSystem',
        CostNet = <any> 'CostNet',
        CostGross = <any> 'CostGross',
        ErrorCostSystem = <any> 'ErrorCostSystem',
        ErrorCostNet = <any> 'ErrorCostNet',
        ErrorCostGross = <any> 'ErrorCostGross',
        EventPrice = <any> 'EventPrice',
        ErrorEventPrice = <any> 'ErrorEventPrice',
        Profit = <any> 'Profit',
        ProfitAgency = <any> 'ProfitAgency',
        ProfitSystem = <any> 'ProfitSystem',
        CTR = <any> 'CTR',
        CVR = <any> 'CVR',
        BidRate = <any> 'BidRate',
        WinRate = <any> 'WinRate',
        ImpRate = <any> 'ImpRate',
        CostOfImprSystem = <any> 'CostOfImprSystem',
        CostOfImprNet = <any> 'CostOfImprNet',
        CostOfImprGross = <any> 'CostOfImprGross',
        CostOfClickSystem = <any> 'CostOfClickSystem',
        CostOfClickNet = <any> 'CostOfClickNet',
        CostOfClickGross = <any> 'CostOfClickGross',
        VastStarted = <any> 'VastStarted',
        VastFirstQs = <any> 'VastFirstQs',
        VastMidpoints = <any> 'VastMidpoints',
        VastThirdQs = <any> 'VastThirdQs',
        VastCompleted = <any> 'VastCompleted',
        VastSkip = <any> 'VastSkip',
        VastMute = <any> 'VastMute',
        VastUnmute = <any> 'VastUnmute',
        VastPause = <any> 'VastPause',
        VastResume = <any> 'VastResume',
        VastError = <any> 'VastError',
        ErrorVastEvent = <any> 'ErrorVastEvent'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface ExportCsvBody
 */
export interface ExportCsvBody {
}
/**
 * 
 * @export
 * @interface ExportXlsxBody
 */
export interface ExportXlsxBody {
}
/**
 * 
 * @export
 * @interface FilterListBean
 */
export interface FilterListBean {
    /**
     * 
     * @type {number}
     * @memberof FilterListBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FilterListBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterListBean
     */
    type?: FilterListBean.TypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FilterListBean
     */
    processed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FilterListBean
     */
    data?: string;
    /**
     * 
     * @type {Array<FilterListFileBean>}
     * @memberof FilterListBean
     */
    files?: Array<FilterListFileBean>;
    /**
     * 
     * @type {number}
     * @memberof FilterListBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof FilterListBean
     */
    advertiserName?: string;
    /**
     * 
     * @type {number}
     * @memberof FilterListBean
     */
    agencyId?: number;
    /**
     * 
     * @type {string}
     * @memberof FilterListBean
     */
    agencyName?: string;
    /**
     * 
     * @type {Date}
     * @memberof FilterListBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace FilterListBean
 */
export namespace FilterListBean {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        DOMAIN = <any> 'DOMAIN',
        APPID = <any> 'APP_ID',
        IPV4 = <any> 'IP_V4',
        IPV6 = <any> 'IP_V6',
        USERIDIPUA = <any> 'USER_ID_IP_UA',
        USERIDIFA = <any> 'USER_ID_IFA'
    }
}
/**
 * 
 * @export
 * @interface FilterListFileBean
 */
export interface FilterListFileBean {
    /**
     * 
     * @type {number}
     * @memberof FilterListFileBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FilterListFileBean
     */
    uid?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterListFileBean
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof FilterListFileBean
     */
    size?: number;
    /**
     * 
     * @type {Date}
     * @memberof FilterListFileBean
     */
    modified?: Date;
}
/**
 * 
 * @export
 * @interface FilterListGlobalBean
 */
export interface FilterListGlobalBean {
    /**
     * 
     * @type {number}
     * @memberof FilterListGlobalBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof FilterListGlobalBean
     */
    filterListId: number;
    /**
     * 
     * @type {number}
     * @memberof FilterListGlobalBean
     */
    agencyId?: number;
    /**
     * 
     * @type {number}
     * @memberof FilterListGlobalBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof FilterListGlobalBean
     */
    mode: FilterListGlobalBean.ModeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FilterListGlobalBean
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof FilterListGlobalBean
     */
    filterListName?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterListGlobalBean
     */
    filterListType?: FilterListGlobalBean.FilterListTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof FilterListGlobalBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace FilterListGlobalBean
 */
export namespace FilterListGlobalBean {
    /**
     * @export
     * @enum {string}
     */
    export enum ModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum FilterListTypeEnum {
        DOMAIN = <any> 'DOMAIN',
        APPID = <any> 'APP_ID',
        IPV4 = <any> 'IP_V4',
        IPV6 = <any> 'IP_V6',
        USERIDIPUA = <any> 'USER_ID_IP_UA',
        USERIDIFA = <any> 'USER_ID_IFA'
    }
}
/**
 * 
 * @export
 * @interface FilterListLinkBean
 */
export interface FilterListLinkBean {
    /**
     * 
     * @type {number}
     * @memberof FilterListLinkBean
     */
    filterListId?: number;
    /**
     * 
     * @type {string}
     * @memberof FilterListLinkBean
     */
    filterListMode?: FilterListLinkBean.FilterListModeEnum;
}

/**
 * @export
 * @namespace FilterListLinkBean
 */
export namespace FilterListLinkBean {
    /**
     * @export
     * @enum {string}
     */
    export enum FilterListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
}
/**
 * 
 * @export
 * @interface GlobalPropsBean
 */
export interface GlobalPropsBean {
    /**
     * 
     * @type {number}
     * @memberof GlobalPropsBean
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface IabCategoryBean
 */
export interface IabCategoryBean {
    /**
     * 
     * @type {number}
     * @memberof IabCategoryBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IabCategoryBean
     */
    parentId?: number;
    /**
     * 
     * @type {string}
     * @memberof IabCategoryBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IabCategoryBean
     */
    code?: string;
}
/**
 * 
 * @export
 * @interface IasBrandSafetyCodeBean
 */
export interface IasBrandSafetyCodeBean {
    /**
     * 
     * @type {number}
     * @memberof IasBrandSafetyCodeBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IasBrandSafetyCodeBean
     */
    brandSafetyType?: IasBrandSafetyCodeBean.BrandSafetyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IasBrandSafetyCodeBean
     */
    adFraudProtectionType?: IasBrandSafetyCodeBean.AdFraudProtectionTypeEnum;
}

/**
 * @export
 * @namespace IasBrandSafetyCodeBean
 */
export namespace IasBrandSafetyCodeBean {
    /**
     * @export
     * @enum {string}
     */
    export enum BrandSafetyTypeEnum {
        AdultContent = <any> 'Adult_Content',
        Alcohol = <any> 'Alcohol',
        Drug = <any> 'Drug',
        IllegalDownload = <any> 'Illegal_Download',
        HateSpeech = <any> 'Hate_Speech',
        OffensiveLanguage = <any> 'Offensive_language',
        Violence = <any> 'Violence',
        All = <any> 'All'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AdFraudProtectionTypeEnum {
        LowProtection = <any> 'LowProtection',
        ModerateProtection = <any> 'ModerateProtection',
        HighProtection = <any> 'HighProtection'
    }
}
/**
 * 
 * @export
 * @interface ItemResponseAccountBeanObject
 */
export interface ItemResponseAccountBeanObject {
    /**
     * 
     * @type {AccountBean}
     * @memberof ItemResponseAccountBeanObject
     */
    data?: AccountBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAccountBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAccountListItemBeanObject
 */
export interface ItemResponseAccountListItemBeanObject {
    /**
     * 
     * @type {AccountListItemBean}
     * @memberof ItemResponseAccountListItemBeanObject
     */
    data?: AccountListItemBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAccountListItemBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdGroupBeanObject
 */
export interface ItemResponseAdGroupBeanObject {
    /**
     * 
     * @type {AdGroupBean}
     * @memberof ItemResponseAdGroupBeanObject
     */
    data?: AdGroupBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdGroupBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdGroupListItemBeanObject
 */
export interface ItemResponseAdGroupListItemBeanObject {
    /**
     * 
     * @type {AdGroupListItemBean}
     * @memberof ItemResponseAdGroupListItemBeanObject
     */
    data?: AdGroupListItemBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdGroupListItemBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdUnitBeanObject
 */
export interface ItemResponseAdUnitBeanObject {
    /**
     * 
     * @type {AdUnitBean}
     * @memberof ItemResponseAdUnitBeanObject
     */
    data?: AdUnitBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdUnitBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdvertiserBalanceBeanObject
 */
export interface ItemResponseAdvertiserBalanceBeanObject {
    /**
     * 
     * @type {AdvertiserBalanceBean}
     * @memberof ItemResponseAdvertiserBalanceBeanObject
     */
    data?: AdvertiserBalanceBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdvertiserBalanceBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdvertiserBeanObject
 */
export interface ItemResponseAdvertiserBeanObject {
    /**
     * 
     * @type {AdvertiserBean}
     * @memberof ItemResponseAdvertiserBeanObject
     */
    data?: AdvertiserBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdvertiserBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdvertiserListItemBeanObject
 */
export interface ItemResponseAdvertiserListItemBeanObject {
    /**
     * 
     * @type {AdvertiserListItemBean}
     * @memberof ItemResponseAdvertiserListItemBeanObject
     */
    data?: AdvertiserListItemBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdvertiserListItemBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAgencyBalanceBeanObject
 */
export interface ItemResponseAgencyBalanceBeanObject {
    /**
     * 
     * @type {AgencyBalanceBean}
     * @memberof ItemResponseAgencyBalanceBeanObject
     */
    data?: AgencyBalanceBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAgencyBalanceBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAgencyBeanObject
 */
export interface ItemResponseAgencyBeanObject {
    /**
     * 
     * @type {AgencyBean}
     * @memberof ItemResponseAgencyBeanObject
     */
    data?: AgencyBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAgencyBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAgencyTransactionBeanObject
 */
export interface ItemResponseAgencyTransactionBeanObject {
    /**
     * 
     * @type {AgencyTransactionBean}
     * @memberof ItemResponseAgencyTransactionBeanObject
     */
    data?: AgencyTransactionBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAgencyTransactionBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAuthLogObject
 */
export interface ItemResponseAuthLogObject {
    /**
     * 
     * @type {AuthLog}
     * @memberof ItemResponseAuthLogObject
     */
    data?: AuthLog;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAuthLogObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseCampaignBeanObject
 */
export interface ItemResponseCampaignBeanObject {
    /**
     * 
     * @type {CampaignBean}
     * @memberof ItemResponseCampaignBeanObject
     */
    data?: CampaignBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseCampaignBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseCampaignListItemBeanObject
 */
export interface ItemResponseCampaignListItemBeanObject {
    /**
     * 
     * @type {CampaignListItemBean}
     * @memberof ItemResponseCampaignListItemBeanObject
     */
    data?: CampaignListItemBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseCampaignListItemBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseCreativeBeanObject
 */
export interface ItemResponseCreativeBeanObject {
    /**
     * 
     * @type {CreativeBean}
     * @memberof ItemResponseCreativeBeanObject
     */
    data?: CreativeBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseCreativeBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseCreativeListItemBeanObject
 */
export interface ItemResponseCreativeListItemBeanObject {
    /**
     * 
     * @type {CreativeListItemBean}
     * @memberof ItemResponseCreativeListItemBeanObject
     */
    data?: CreativeListItemBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseCreativeListItemBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseDealBeanObject
 */
export interface ItemResponseDealBeanObject {
    /**
     * 
     * @type {DealBean}
     * @memberof ItemResponseDealBeanObject
     */
    data?: DealBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseDealBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseDealDspBeanObject
 */
export interface ItemResponseDealDspBeanObject {
    /**
     * 
     * @type {DealDspBean}
     * @memberof ItemResponseDealDspBeanObject
     */
    data?: DealDspBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseDealDspBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseDspBeanObject
 */
export interface ItemResponseDspBeanObject {
    /**
     * 
     * @type {DspBean}
     * @memberof ItemResponseDspBeanObject
     */
    data?: DspBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseDspBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseDspListItemBeanObject
 */
export interface ItemResponseDspListItemBeanObject {
    /**
     * 
     * @type {DspListItemBean}
     * @memberof ItemResponseDspListItemBeanObject
     */
    data?: DspListItemBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseDspListItemBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseFilterListBeanObject
 */
export interface ItemResponseFilterListBeanObject {
    /**
     * 
     * @type {FilterListBean}
     * @memberof ItemResponseFilterListBeanObject
     */
    data?: FilterListBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseFilterListBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseFilterListGlobalBeanObject
 */
export interface ItemResponseFilterListGlobalBeanObject {
    /**
     * 
     * @type {FilterListGlobalBean}
     * @memberof ItemResponseFilterListGlobalBeanObject
     */
    data?: FilterListGlobalBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseFilterListGlobalBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseGlobalPropsBeanObject
 */
export interface ItemResponseGlobalPropsBeanObject {
    /**
     * 
     * @type {GlobalPropsBean}
     * @memberof ItemResponseGlobalPropsBeanObject
     */
    data?: GlobalPropsBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseGlobalPropsBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseLogBeanObject
 */
export interface ItemResponseLogBeanObject {
    /**
     * 
     * @type {LogBean}
     * @memberof ItemResponseLogBeanObject
     */
    data?: LogBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseLogBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseMandatoryFieldBeanObject
 */
export interface ItemResponseMandatoryFieldBeanObject {
    /**
     * 
     * @type {MandatoryFieldBean}
     * @memberof ItemResponseMandatoryFieldBeanObject
     */
    data?: MandatoryFieldBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseMandatoryFieldBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponsePageUrlKeywordsBeanObject
 */
export interface ItemResponsePageUrlKeywordsBeanObject {
    /**
     * 
     * @type {PageUrlKeywordsBean}
     * @memberof ItemResponsePageUrlKeywordsBeanObject
     */
    data?: PageUrlKeywordsBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponsePageUrlKeywordsBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponsePublisherBeanObject
 */
export interface ItemResponsePublisherBeanObject {
    /**
     * 
     * @type {PublisherBean}
     * @memberof ItemResponsePublisherBeanObject
     */
    data?: PublisherBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponsePublisherBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponsePublisherListItemBeanObject
 */
export interface ItemResponsePublisherListItemBeanObject {
    /**
     * 
     * @type {PublisherListItemBean}
     * @memberof ItemResponsePublisherListItemBeanObject
     */
    data?: PublisherListItemBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponsePublisherListItemBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseReportBeanObject
 */
export interface ItemResponseReportBeanObject {
    /**
     * 
     * @type {ReportBean}
     * @memberof ItemResponseReportBeanObject
     */
    data?: ReportBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseReportBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseRetargetingListBeanObject
 */
export interface ItemResponseRetargetingListBeanObject {
    /**
     * 
     * @type {RetargetingListBean}
     * @memberof ItemResponseRetargetingListBeanObject
     */
    data?: RetargetingListBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseRetargetingListBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSavedReportBeanObject
 */
export interface ItemResponseSavedReportBeanObject {
    /**
     * 
     * @type {SavedReportBean}
     * @memberof ItemResponseSavedReportBeanObject
     */
    data?: SavedReportBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSavedReportBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSavedReportListItemBeanObject
 */
export interface ItemResponseSavedReportListItemBeanObject {
    /**
     * 
     * @type {SavedReportListItemBean}
     * @memberof ItemResponseSavedReportListItemBeanObject
     */
    data?: SavedReportListItemBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSavedReportListItemBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSettingBeanObject
 */
export interface ItemResponseSettingBeanObject {
    /**
     * 
     * @type {SettingBean}
     * @memberof ItemResponseSettingBeanObject
     */
    data?: SettingBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSettingBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSiteBeanObject
 */
export interface ItemResponseSiteBeanObject {
    /**
     * 
     * @type {SiteBean}
     * @memberof ItemResponseSiteBeanObject
     */
    data?: SiteBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSiteBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSspBeanObject
 */
export interface ItemResponseSspBeanObject {
    /**
     * 
     * @type {SspBean}
     * @memberof ItemResponseSspBeanObject
     */
    data?: SspBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSspBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSspInfoBeanObject
 */
export interface ItemResponseSspInfoBeanObject {
    /**
     * 
     * @type {SspInfoBean}
     * @memberof ItemResponseSspInfoBeanObject
     */
    data?: SspInfoBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSspInfoBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSspListItemBeanObject
 */
export interface ItemResponseSspListItemBeanObject {
    /**
     * 
     * @type {SspListItemBean}
     * @memberof ItemResponseSspListItemBeanObject
     */
    data?: SspListItemBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSspListItemBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseStringObject
 */
export interface ItemResponseStringObject {
    /**
     * 
     * @type {string}
     * @memberof ItemResponseStringObject
     */
    data?: string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseStringObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseStripeConnectStatusBeanObject
 */
export interface ItemResponseStripeConnectStatusBeanObject {
    /**
     * 
     * @type {StripeConnectStatusBean}
     * @memberof ItemResponseStripeConnectStatusBeanObject
     */
    data?: StripeConnectStatusBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseStripeConnectStatusBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseTrackerBeanObject
 */
export interface ItemResponseTrackerBeanObject {
    /**
     * 
     * @type {TrackerBean}
     * @memberof ItemResponseTrackerBeanObject
     */
    data?: TrackerBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseTrackerBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseTrackerEventBeanObject
 */
export interface ItemResponseTrackerEventBeanObject {
    /**
     * 
     * @type {TrackerEventBean}
     * @memberof ItemResponseTrackerEventBeanObject
     */
    data?: TrackerEventBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseTrackerEventBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseTransactionBeanObject
 */
export interface ItemResponseTransactionBeanObject {
    /**
     * 
     * @type {TransactionBean}
     * @memberof ItemResponseTransactionBeanObject
     */
    data?: TransactionBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseTransactionBeanObject
     */
    permissions?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface KeyFilterClause
 */
export interface KeyFilterClause {
    /**
     * 
     * @type {string}
     * @memberof KeyFilterClause
     */
    type?: KeyFilterClause.TypeEnum;
    /**
     * 
     * @type {any}
     * @memberof KeyFilterClause
     */
    value?: any;
}

/**
 * @export
 * @namespace KeyFilterClause
 */
export namespace KeyFilterClause {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        In = <any> 'in',
        Between = <any> 'between',
        Equals = <any> 'equals',
        NotEquals = <any> 'notEquals',
        Greater = <any> 'greater',
        GreaterOrEquals = <any> 'greaterOrEquals',
        LessOrEquals = <any> 'lessOrEquals',
        Contains = <any> 'contains'
    }
}
/**
 * 
 * @export
 * @interface LanguageBean
 */
export interface LanguageBean {
    /**
     * 
     * @type {string}
     * @memberof LanguageBean
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageBean
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface ListPagination
 */
export interface ListPagination {
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface ListResponseAccountListItemBean
 */
export interface ListResponseAccountListItemBean {
    /**
     * 
     * @type {Array<ItemResponseAccountListItemBeanObject>}
     * @memberof ListResponseAccountListItemBean
     */
    data?: Array<ItemResponseAccountListItemBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAccountListItemBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseAdGroupListItemBean
 */
export interface ListResponseAdGroupListItemBean {
    /**
     * 
     * @type {Array<ItemResponseAdGroupListItemBeanObject>}
     * @memberof ListResponseAdGroupListItemBean
     */
    data?: Array<ItemResponseAdGroupListItemBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAdGroupListItemBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseAdUnitBean
 */
export interface ListResponseAdUnitBean {
    /**
     * 
     * @type {Array<ItemResponseAdUnitBeanObject>}
     * @memberof ListResponseAdUnitBean
     */
    data?: Array<ItemResponseAdUnitBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAdUnitBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseAdvertiserBalanceBean
 */
export interface ListResponseAdvertiserBalanceBean {
    /**
     * 
     * @type {Array<ItemResponseAdvertiserBalanceBeanObject>}
     * @memberof ListResponseAdvertiserBalanceBean
     */
    data?: Array<ItemResponseAdvertiserBalanceBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAdvertiserBalanceBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseAdvertiserListItemBean
 */
export interface ListResponseAdvertiserListItemBean {
    /**
     * 
     * @type {Array<ItemResponseAdvertiserListItemBeanObject>}
     * @memberof ListResponseAdvertiserListItemBean
     */
    data?: Array<ItemResponseAdvertiserListItemBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAdvertiserListItemBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseAgencyBean
 */
export interface ListResponseAgencyBean {
    /**
     * 
     * @type {Array<ItemResponseAgencyBeanObject>}
     * @memberof ListResponseAgencyBean
     */
    data?: Array<ItemResponseAgencyBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAgencyBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseAgencyTransactionBean
 */
export interface ListResponseAgencyTransactionBean {
    /**
     * 
     * @type {Array<ItemResponseAgencyTransactionBeanObject>}
     * @memberof ListResponseAgencyTransactionBean
     */
    data?: Array<ItemResponseAgencyTransactionBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAgencyTransactionBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseAuthLog
 */
export interface ListResponseAuthLog {
    /**
     * 
     * @type {Array<ItemResponseAuthLogObject>}
     * @memberof ListResponseAuthLog
     */
    data?: Array<ItemResponseAuthLogObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAuthLog
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseCampaignListItemBean
 */
export interface ListResponseCampaignListItemBean {
    /**
     * 
     * @type {Array<ItemResponseCampaignListItemBeanObject>}
     * @memberof ListResponseCampaignListItemBean
     */
    data?: Array<ItemResponseCampaignListItemBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseCampaignListItemBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseCreativeListItemBean
 */
export interface ListResponseCreativeListItemBean {
    /**
     * 
     * @type {Array<ItemResponseCreativeListItemBeanObject>}
     * @memberof ListResponseCreativeListItemBean
     */
    data?: Array<ItemResponseCreativeListItemBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseCreativeListItemBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseDealBean
 */
export interface ListResponseDealBean {
    /**
     * 
     * @type {Array<ItemResponseDealBeanObject>}
     * @memberof ListResponseDealBean
     */
    data?: Array<ItemResponseDealBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseDealBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseDealDspBean
 */
export interface ListResponseDealDspBean {
    /**
     * 
     * @type {Array<ItemResponseDealDspBeanObject>}
     * @memberof ListResponseDealDspBean
     */
    data?: Array<ItemResponseDealDspBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseDealDspBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseDspListItemBean
 */
export interface ListResponseDspListItemBean {
    /**
     * 
     * @type {Array<ItemResponseDspListItemBeanObject>}
     * @memberof ListResponseDspListItemBean
     */
    data?: Array<ItemResponseDspListItemBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseDspListItemBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseFilterListBean
 */
export interface ListResponseFilterListBean {
    /**
     * 
     * @type {Array<ItemResponseFilterListBeanObject>}
     * @memberof ListResponseFilterListBean
     */
    data?: Array<ItemResponseFilterListBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseFilterListBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseFilterListGlobalBean
 */
export interface ListResponseFilterListGlobalBean {
    /**
     * 
     * @type {Array<ItemResponseFilterListGlobalBeanObject>}
     * @memberof ListResponseFilterListGlobalBean
     */
    data?: Array<ItemResponseFilterListGlobalBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseFilterListGlobalBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseLogBean
 */
export interface ListResponseLogBean {
    /**
     * 
     * @type {Array<ItemResponseLogBeanObject>}
     * @memberof ListResponseLogBean
     */
    data?: Array<ItemResponseLogBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseLogBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseMandatoryFieldBean
 */
export interface ListResponseMandatoryFieldBean {
    /**
     * 
     * @type {Array<ItemResponseMandatoryFieldBeanObject>}
     * @memberof ListResponseMandatoryFieldBean
     */
    data?: Array<ItemResponseMandatoryFieldBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseMandatoryFieldBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponsePageUrlKeywordsBean
 */
export interface ListResponsePageUrlKeywordsBean {
    /**
     * 
     * @type {Array<ItemResponsePageUrlKeywordsBeanObject>}
     * @memberof ListResponsePageUrlKeywordsBean
     */
    data?: Array<ItemResponsePageUrlKeywordsBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponsePageUrlKeywordsBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponsePublisherListItemBean
 */
export interface ListResponsePublisherListItemBean {
    /**
     * 
     * @type {Array<ItemResponsePublisherListItemBeanObject>}
     * @memberof ListResponsePublisherListItemBean
     */
    data?: Array<ItemResponsePublisherListItemBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponsePublisherListItemBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseRetargetingListBean
 */
export interface ListResponseRetargetingListBean {
    /**
     * 
     * @type {Array<ItemResponseRetargetingListBeanObject>}
     * @memberof ListResponseRetargetingListBean
     */
    data?: Array<ItemResponseRetargetingListBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseRetargetingListBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseSavedReportListItemBean
 */
export interface ListResponseSavedReportListItemBean {
    /**
     * 
     * @type {Array<ItemResponseSavedReportListItemBeanObject>}
     * @memberof ListResponseSavedReportListItemBean
     */
    data?: Array<ItemResponseSavedReportListItemBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseSavedReportListItemBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseSettingBean
 */
export interface ListResponseSettingBean {
    /**
     * 
     * @type {Array<ItemResponseSettingBeanObject>}
     * @memberof ListResponseSettingBean
     */
    data?: Array<ItemResponseSettingBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseSettingBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseSiteBean
 */
export interface ListResponseSiteBean {
    /**
     * 
     * @type {Array<ItemResponseSiteBeanObject>}
     * @memberof ListResponseSiteBean
     */
    data?: Array<ItemResponseSiteBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseSiteBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseSspInfoBean
 */
export interface ListResponseSspInfoBean {
    /**
     * 
     * @type {Array<ItemResponseSspInfoBeanObject>}
     * @memberof ListResponseSspInfoBean
     */
    data?: Array<ItemResponseSspInfoBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseSspInfoBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseSspListItemBean
 */
export interface ListResponseSspListItemBean {
    /**
     * 
     * @type {Array<ItemResponseSspListItemBeanObject>}
     * @memberof ListResponseSspListItemBean
     */
    data?: Array<ItemResponseSspListItemBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseSspListItemBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseTrackerBean
 */
export interface ListResponseTrackerBean {
    /**
     * 
     * @type {Array<ItemResponseTrackerBeanObject>}
     * @memberof ListResponseTrackerBean
     */
    data?: Array<ItemResponseTrackerBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseTrackerBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseTrackerEventBean
 */
export interface ListResponseTrackerEventBean {
    /**
     * 
     * @type {Array<ItemResponseTrackerEventBeanObject>}
     * @memberof ListResponseTrackerEventBean
     */
    data?: Array<ItemResponseTrackerEventBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseTrackerEventBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface ListResponseTransactionBean
 */
export interface ListResponseTransactionBean {
    /**
     * 
     * @type {Array<ItemResponseTransactionBeanObject>}
     * @memberof ListResponseTransactionBean
     */
    data?: Array<ItemResponseTransactionBeanObject>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseTransactionBean
     */
    pagination?: ListPagination;
}
/**
 * 
 * @export
 * @interface LogBean
 */
export interface LogBean {
    /**
     * 
     * @type {number}
     * @memberof LogBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LogBean
     */
    entityId?: number;
    /**
     * 
     * @type {string}
     * @memberof LogBean
     */
    entity?: LogBean.EntityEnum;
    /**
     * 
     * @type {string}
     * @memberof LogBean
     */
    account?: string;
    /**
     * 
     * @type {string}
     * @memberof LogBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LogBean
     */
    prevValue?: string;
    /**
     * 
     * @type {string}
     * @memberof LogBean
     */
    currentValue?: string;
    /**
     * 
     * @type {Date}
     * @memberof LogBean
     */
    date?: Date;
}

/**
 * @export
 * @namespace LogBean
 */
export namespace LogBean {
    /**
     * @export
     * @enum {string}
     */
    export enum EntityEnum {
        Account = <any> 'Account',
        Advertiser = <any> 'Advertiser',
        AdvertiserBalance = <any> 'AdvertiserBalance',
        AdvertiserBalanceTransaction = <any> 'AdvertiserBalanceTransaction',
        AgencyBalance = <any> 'AgencyBalance',
        AgencyBalanceTransaction = <any> 'AgencyBalanceTransaction',
        AdSize = <any> 'AdSize',
        AdSizeBidFloor = <any> 'AdSizeBidFloor',
        Deal = <any> 'Deal',
        AdGroup = <any> 'AdGroup',
        Tracker = <any> 'Tracker',
        Country = <any> 'Country',
        Region = <any> 'Region',
        City = <any> 'City',
        Creative = <any> 'Creative',
        Dsp = <any> 'Dsp',
        DspEndpointAdUnit = <any> 'DspEndpointAdUnit',
        GlobalProps = <any> 'GlobalProps',
        IabCategory = <any> 'IabCategory',
        IasViewabilityCode = <any> 'IasViewabilityCode',
        IasAdFraudCode = <any> 'IasAdFraudCode',
        IasBrandSafetyCode = <any> 'IasBrandSafetyCode',
        Campaign = <any> 'Campaign',
        OS = <any> 'OS',
        Publisher = <any> 'Publisher',
        Report = <any> 'Report',
        Site = <any> 'Site',
        SemanticSubject = <any> 'SemanticSubject',
        Ssp = <any> 'Ssp',
        Zone = <any> 'Zone',
        NativeData = <any> 'NativeData',
        DealDsp = <any> 'DealDsp',
        DealDspSeat = <any> 'DealDspSeat',
        EmailConfirmation = <any> 'EmailConfirmation',
        Setting = <any> 'Setting',
        SavedReport = <any> 'SavedReport',
        MandatoryField = <any> 'MandatoryField',
        Agency = <any> 'Agency',
        Customization = <any> 'Customization',
        FilterListGlobal = <any> 'FilterListGlobal',
        RetargetingList = <any> 'RetargetingList',
        TrackerEvent = <any> 'TrackerEvent'
    }
}
/**
 * 
 * @export
 * @interface MandatoryFieldBean
 */
export interface MandatoryFieldBean {
    /**
     * 
     * @type {number}
     * @memberof MandatoryFieldBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MandatoryFieldBean
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MandatoryFieldBean
     */
    pathList?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MandatoryFieldBean
     */
    logic?: MandatoryFieldBean.LogicEnum;
    /**
     * 
     * @type {string}
     * @memberof MandatoryFieldBean
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MandatoryFieldBean
     */
    required?: boolean;
}

/**
 * @export
 * @namespace MandatoryFieldBean
 */
export namespace MandatoryFieldBean {
    /**
     * @export
     * @enum {string}
     */
    export enum LogicEnum {
        AND = <any> 'AND',
        OR = <any> 'OR'
    }
}
/**
 * 
 * @export
 * @interface NativeBulkBody
 */
export interface NativeBulkBody {
    /**
     * 
     * @type {Blob}
     * @memberof NativeBulkBody
     */
    csv: Blob;
    /**
     * 
     * @type {Blob}
     * @memberof NativeBulkBody
     */
    zip: Blob;
}
/**
 * 
 * @export
 * @interface NativeDataBean
 */
export interface NativeDataBean {
    /**
     * 
     * @type {number}
     * @memberof NativeDataBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof NativeDataBean
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NativeDataBean
     */
    description: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof NativeDataBean
     */
    nativeImageList?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof NativeDataBean
     */
    nativeVideoList?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof NativeDataBean
     */
    contextTypeList: Array<NativeDataBean.ContextTypeListEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof NativeDataBean
     */
    placementTypeList: Array<NativeDataBean.PlacementTypeListEnum>;
    /**
     * 
     * @type {string}
     * @memberof NativeDataBean
     */
    adCode: string;
    /**
     * 
     * @type {string}
     * @memberof NativeDataBean
     */
    vastCode?: string;
}

/**
 * @export
 * @namespace NativeDataBean
 */
export namespace NativeDataBean {
    /**
     * @export
     * @enum {string}
     */
    export enum ContextTypeListEnum {
        ContentFeeds = <any> 'Content Feeds',
        SocialFeeds = <any> 'Social Feeds',
        ProductFeeds = <any> 'Product Feeds',
        Others = <any> 'Others'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PlacementTypeListEnum {
        InFeed = <any> 'In Feed',
        InContent = <any> 'In Content',
        OutsideContent = <any> 'Outside Content',
        WidgetBelow = <any> 'Widget Below',
        Others = <any> 'Others'
    }
}
/**
 * 
 * @export
 * @interface NewAdvertiserPaymentBean
 */
export interface NewAdvertiserPaymentBean {
    /**
     * 
     * @type {number}
     * @memberof NewAdvertiserPaymentBean
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof NewAdvertiserPaymentBean
     */
    advertiserId: number;
    /**
     * 
     * @type {string}
     * @memberof NewAdvertiserPaymentBean
     */
    paySystem: NewAdvertiserPaymentBean.PaySystemEnum;
}

/**
 * @export
 * @namespace NewAdvertiserPaymentBean
 */
export namespace NewAdvertiserPaymentBean {
    /**
     * @export
     * @enum {string}
     */
    export enum PaySystemEnum {
        MONEY = <any> 'MONEY',
        STRIPE = <any> 'STRIPE'
    }
}
/**
 * 
 * @export
 * @interface NewPaymentBean
 */
export interface NewPaymentBean {
    /**
     * 
     * @type {number}
     * @memberof NewPaymentBean
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof NewPaymentBean
     */
    agencyId: number;
    /**
     * 
     * @type {string}
     * @memberof NewPaymentBean
     */
    paySystem: NewPaymentBean.PaySystemEnum;
}

/**
 * @export
 * @namespace NewPaymentBean
 */
export namespace NewPaymentBean {
    /**
     * @export
     * @enum {string}
     */
    export enum PaySystemEnum {
        MONEY = <any> 'MONEY',
        STRIPE = <any> 'STRIPE'
    }
}
/**
 * 
 * @export
 * @interface OperatingSystem
 */
export interface OperatingSystem {
    /**
     * 
     * @type {string}
     * @memberof OperatingSystem
     */
    name: OperatingSystem.NameEnum;
    /**
     * 
     * @type {string}
     * @memberof OperatingSystem
     */
    versionMin?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatingSystem
     */
    versionMax?: string;
}

/**
 * @export
 * @namespace OperatingSystem
 */
export namespace OperatingSystem {
    /**
     * @export
     * @enum {string}
     */
    export enum NameEnum {
        Windows = <any> 'Windows',
        Android = <any> 'Android',
        ChromeOS = <any> 'Chrome OS',
        IOS = <any> 'iOS',
        IOSIPhone = <any> 'iOS (iPhone)',
        IOSIPad = <any> 'iOS (iPad)',
        MacOS = <any> 'MacOS',
        Linux = <any> 'Linux',
        BlackBerry = <any> 'BlackBerry',
        Unknown = <any> 'Unknown'
    }
}
/**
 * 
 * @export
 * @interface OperationBean
 */
export interface OperationBean {
    /**
     * 
     * @type {number}
     * @memberof OperationBean
     */
    advertiserId: number;
    /**
     * 
     * @type {string}
     * @memberof OperationBean
     */
    operationType: OperationBean.OperationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof OperationBean
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof OperationBean
     */
    note?: string;
}

/**
 * @export
 * @namespace OperationBean
 */
export namespace OperationBean {
    /**
     * @export
     * @enum {string}
     */
    export enum OperationTypeEnum {
        ADD = <any> 'ADD',
        SUBTRACT = <any> 'SUBTRACT'
    }
}
/**
 * 
 * @export
 * @interface PageUrlKeywordsBean
 */
export interface PageUrlKeywordsBean {
    /**
     * 
     * @type {string}
     * @memberof PageUrlKeywordsBean
     */
    pageUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PageUrlKeywordsBean
     */
    keywords?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PageUrlKeywordsBean
     */
    brandSafety?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof PageUrlKeywordsBean
     */
    processedAt?: Date;
}
/**
 * 
 * @export
 * @interface PublisherBean
 */
export interface PublisherBean {
    /**
     * 
     * @type {number}
     * @memberof PublisherBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PublisherBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherBean
     */
    timeZoneId: string;
    /**
     * 
     * @type {number}
     * @memberof PublisherBean
     */
    revShare?: number;
    /**
     * 
     * @type {string}
     * @memberof PublisherBean
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherBean
     */
    sellerType?: PublisherBean.SellerTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof PublisherBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace PublisherBean
 */
export namespace PublisherBean {
    /**
     * @export
     * @enum {string}
     */
    export enum SellerTypeEnum {
        Publisher = <any> 'Publisher',
        Intermediary = <any> 'Intermediary',
        Both = <any> 'Both'
    }
}
/**
 * 
 * @export
 * @interface PublisherListItemBean
 */
export interface PublisherListItemBean {
    /**
     * 
     * @type {number}
     * @memberof PublisherListItemBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PublisherListItemBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherListItemBean
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherListItemBean
     */
    timeZoneId?: string;
    /**
     * 
     * @type {number}
     * @memberof PublisherListItemBean
     */
    revShare?: number;
    /**
     * 
     * @type {Date}
     * @memberof PublisherListItemBean
     */
    modified?: Date;
}
/**
 * 
 * @export
 * @interface RegionBean
 */
export interface RegionBean {
    /**
     * 
     * @type {number}
     * @memberof RegionBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RegionBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RegionBean
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof RegionBean
     */
    countryId?: number;
    /**
     * 
     * @type {string}
     * @memberof RegionBean
     */
    countryName?: string;
}
/**
 * 
 * @export
 * @interface ReportBean
 */
export interface ReportBean {
    /**
     * 
     * @type {number}
     * @memberof ReportBean
     */
    id?: number;
    /**
     * 
     * @type {Array<ReportColumnBean>}
     * @memberof ReportBean
     */
    columns?: Array<ReportColumnBean>;
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof ReportBean
     */
    rows?: Array<Array<any>>;
    /**
     * 
     * @type {number}
     * @memberof ReportBean
     */
    totalLines?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportBean
     */
    warning?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ReportBean
     */
    totalValues?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface ReportColumn
 */
export interface ReportColumn {
}
/**
 * 
 * @export
 * @interface ReportColumnBean
 */
export interface ReportColumnBean {
    /**
     * 
     * @type {string}
     * @memberof ReportColumnBean
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportColumnBean
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface ReportEnumBean
 */
export interface ReportEnumBean {
    /**
     * 
     * @type {string}
     * @memberof ReportEnumBean
     */
    formatType?: ReportEnumBean.FormatTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReportEnumBean
     */
    siteType?: ReportEnumBean.SiteTypeEnum;
}

/**
 * @export
 * @namespace ReportEnumBean
 */
export namespace ReportEnumBean {
    /**
     * @export
     * @enum {string}
     */
    export enum FormatTypeEnum {
        Audio = <any> 'Audio',
        Banner = <any> 'Banner',
        Native = <any> 'Native',
        Pop = <any> 'Pop',
        Push = <any> 'Push',
        Video = <any> 'Video'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SiteTypeEnum {
        Site = <any> 'Site',
        App = <any> 'App'
    }
}
/**
 * 
 * @export
 * @interface ReportFilter
 */
export interface ReportFilter {
    /**
     * 
     * @type {ReportColumn}
     * @memberof ReportFilter
     */
    key?: ReportColumn;
    /**
     * 
     * @type {string}
     * @memberof ReportFilter
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportFilter
     */
    type?: ReportFilter.TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReportFilter
     */
    valueType?: ReportFilter.ValueTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ReportFilter
     */
    maxParamsNumber?: number;
}

/**
 * @export
 * @namespace ReportFilter
 */
export namespace ReportFilter {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        EQUAL = <any> 'EQUAL',
        INLIST = <any> 'IN_LIST',
        CONTAINS = <any> 'CONTAINS'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ValueTypeEnum {
        Long = <any> 'Long',
        Enum = <any> 'Enum',
        String = <any> 'String'
    }
}
/**
 * 
 * @export
 * @interface ReportKeyColumn
 */
export interface ReportKeyColumn {
    /**
     * 
     * @type {ReportColumn}
     * @memberof ReportKeyColumn
     */
    value?: ReportColumn;
    /**
     * 
     * @type {string}
     * @memberof ReportKeyColumn
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface ReportMetadata
 */
export interface ReportMetadata {
    /**
     * 
     * @type {Array<ReportKeyColumn>}
     * @memberof ReportMetadata
     */
    keys?: Array<ReportKeyColumn>;
    /**
     * 
     * @type {Array<ReportValueColumn>}
     * @memberof ReportMetadata
     */
    values?: Array<ReportValueColumn>;
    /**
     * 
     * @type {Array<ReportFilter>}
     * @memberof ReportMetadata
     */
    filters?: Array<ReportFilter>;
}
/**
 * 
 * @export
 * @interface ReportRequestParametersObjectObject
 */
export interface ReportRequestParametersObjectObject {
    /**
     * 
     * @type {string}
     * @memberof ReportRequestParametersObjectObject
     */
    type?: ReportRequestParametersObjectObject.TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReportRequestParametersObjectObject
     */
    timezone?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof ReportRequestParametersObjectObject
     */
    keyColumns?: Array<any>;
    /**
     * 
     * @type {Array<any>}
     * @memberof ReportRequestParametersObjectObject
     */
    valueColumns?: Array<any>;
}

/**
 * @export
 * @namespace ReportRequestParametersObjectObject
 */
export namespace ReportRequestParametersObjectObject {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Stats = <any> 'Stats',
        Tracker = <any> 'Tracker'
    }
}
/**
 * 
 * @export
 * @interface ReportValueColumn
 */
export interface ReportValueColumn {
    /**
     * 
     * @type {ReportColumn}
     * @memberof ReportValueColumn
     */
    value?: ReportColumn;
    /**
     * 
     * @type {string}
     * @memberof ReportValueColumn
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface RetargetingListBean
 */
export interface RetargetingListBean {
    /**
     * 
     * @type {number}
     * @memberof RetargetingListBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RetargetingListBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof RetargetingListBean
     */
    advertiserName?: string;
    /**
     * 
     * @type {string}
     * @memberof RetargetingListBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RetargetingListBean
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof RetargetingListBean
     */
    endDate: string;
    /**
     * 
     * @type {boolean}
     * @memberof RetargetingListBean
     */
    autoUpdate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RetargetingListBean
     */
    status?: RetargetingListBean.StatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof RetargetingListBean
     */
    lastProcessedTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RetargetingListBean
     */
    created?: Date;
    /**
     * 
     * @type {Array<number>}
     * @memberof RetargetingListBean
     */
    adGroupIds?: Array<number>;
    /**
     * 
     * @type {Array<RetargetingListFilterDisplayBean>}
     * @memberof RetargetingListBean
     */
    filterDisplay?: Array<RetargetingListFilterDisplayBean>;
    /**
     * 
     * @type {number}
     * @memberof RetargetingListBean
     */
    collectedIpUaCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RetargetingListBean
     */
    collectedIfaCount?: number;
    /**
     * 
     * @type {string}
     * @memberof RetargetingListBean
     */
    errorMessage?: string;
    /**
     * 
     * @type {TrackerReportRequestParameters}
     * @memberof RetargetingListBean
     */
    reportRequest: TrackerReportRequestParameters;
}

/**
 * @export
 * @namespace RetargetingListBean
 */
export namespace RetargetingListBean {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        NEW = <any> 'NEW',
        PENDING = <any> 'PENDING',
        READY = <any> 'READY',
        FAILED = <any> 'FAILED'
    }
}
/**
 * 
 * @export
 * @interface RetargetingListFilterDisplayBean
 */
export interface RetargetingListFilterDisplayBean {
    /**
     * 
     * @type {string}
     * @memberof RetargetingListFilterDisplayBean
     */
    title?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RetargetingListFilterDisplayBean
     */
    values?: Array<string>;
}
/**
 * 
 * @export
 * @interface SavedReportBean
 */
export interface SavedReportBean {
    /**
     * 
     * @type {number}
     * @memberof SavedReportBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SavedReportBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SavedReportBean
     */
    reportPeriod: SavedReportBean.ReportPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof SavedReportBean
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedReportBean
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedReportBean
     */
    timezoneId: string;
    /**
     * 
     * @type {string}
     * @memberof SavedReportBean
     */
    reportType: SavedReportBean.ReportTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SavedReportBean
     */
    dimensions?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SavedReportBean
     */
    metrics?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SavedReportBean
     */
    events?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SavedReportBean
     */
    filters?: { [key: string]: any; };
}

/**
 * @export
 * @namespace SavedReportBean
 */
export namespace SavedReportBean {
    /**
     * @export
     * @enum {string}
     */
    export enum ReportPeriodEnum {
        TODAY = <any> 'TODAY',
        YESTERDAY = <any> 'YESTERDAY',
        LAST3DAYS = <any> 'LAST_3_DAYS',
        LAST7DAYS = <any> 'LAST_7_DAYS',
        LAST28DAYS = <any> 'LAST_28_DAYS',
        THISMONTH = <any> 'THIS_MONTH',
        LASTMONTH = <any> 'LAST_MONTH',
        CUSTOMRANGE = <any> 'CUSTOM_RANGE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ReportTypeEnum {
        Stats = <any> 'Stats',
        Tracker = <any> 'Tracker'
    }
}
/**
 * 
 * @export
 * @interface SavedReportListItemBean
 */
export interface SavedReportListItemBean {
    /**
     * 
     * @type {number}
     * @memberof SavedReportListItemBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SavedReportListItemBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SavedReportListItemBean
     */
    reportPeriod: SavedReportListItemBean.ReportPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof SavedReportListItemBean
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedReportListItemBean
     */
    endDate?: string;
    /**
     * 
     * @type {Date}
     * @memberof SavedReportListItemBean
     */
    modified?: Date;
    /**
     * 
     * @type {string}
     * @memberof SavedReportListItemBean
     */
    reportType?: SavedReportListItemBean.ReportTypeEnum;
}

/**
 * @export
 * @namespace SavedReportListItemBean
 */
export namespace SavedReportListItemBean {
    /**
     * @export
     * @enum {string}
     */
    export enum ReportPeriodEnum {
        TODAY = <any> 'TODAY',
        YESTERDAY = <any> 'YESTERDAY',
        LAST3DAYS = <any> 'LAST_3_DAYS',
        LAST7DAYS = <any> 'LAST_7_DAYS',
        LAST28DAYS = <any> 'LAST_28_DAYS',
        THISMONTH = <any> 'THIS_MONTH',
        LASTMONTH = <any> 'LAST_MONTH',
        CUSTOMRANGE = <any> 'CUSTOM_RANGE'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ReportTypeEnum {
        Stats = <any> 'Stats',
        Tracker = <any> 'Tracker'
    }
}
/**
 * 
 * @export
 * @interface SettingBean
 */
export interface SettingBean {
    /**
     * 
     * @type {number}
     * @memberof SettingBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SettingBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SettingBean
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingBean
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof SettingBean
     */
    valueType?: string;
}
/**
 * 
 * @export
 * @interface SignUpResponseBean
 */
export interface SignUpResponseBean {
    /**
     * 
     * @type {boolean}
     * @memberof SignUpResponseBean
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignUpResponseBean
     */
    accountNotFound?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignUpResponseBean
     */
    alreadyRegistered?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignUpResponseBean
     */
    passwordNotMatch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignUpResponseBean
     */
    passwordNotStrong?: boolean;
}
/**
 * 
 * @export
 * @interface SiteBean
 */
export interface SiteBean {
    /**
     * 
     * @type {number}
     * @memberof SiteBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteBean
     */
    publisherId: number;
    /**
     * 
     * @type {boolean}
     * @memberof SiteBean
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SiteBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SiteBean
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof SiteBean
     */
    domainBlackList?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SiteBean
     */
    iabCategoryIdList?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SiteBean
     */
    iabCategoryIdBlackList?: Array<number>;
    /**
     * 
     * @type {Date}
     * @memberof SiteBean
     */
    modified?: Date;
}
/**
 * 
 * @export
 * @interface SiteBulkBody
 */
export interface SiteBulkBody {
    /**
     * 
     * @type {Blob}
     * @memberof SiteBulkBody
     */
    csv?: Blob;
}
/**
 * 
 * @export
 * @interface SspBean
 */
export interface SspBean {
    /**
     * 
     * @type {number}
     * @memberof SspBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SspBean
     */
    agencyId?: number;
    /**
     * 
     * @type {string}
     * @memberof SspBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SspBean
     */
    internalName?: string;
    /**
     * 
     * @type {string}
     * @memberof SspBean
     */
    sspType: SspBean.SspTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SspBean
     */
    creativeType?: SspBean.CreativeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SspBean
     */
    endpoint: string;
    /**
     * 
     * @type {string}
     * @memberof SspBean
     */
    auctionMode: SspBean.AuctionModeEnum;
    /**
     * 
     * @type {string}
     * @memberof SspBean
     */
    trackingType: SspBean.TrackingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SspBean
     */
    bidswitchSspListMode: SspBean.BidswitchSspListModeEnum;
    /**
     * 
     * @type {string}
     * @memberof SspBean
     */
    bidswitchSspList?: string;
    /**
     * 
     * @type {string}
     * @memberof SspBean
     */
    outerSspToken?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SspBean
     */
    winOnImpression?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SspBean
     */
    vastWinOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SspBean
     */
    redirectOnce?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SspBean
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SspBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace SspBean
 */
export namespace SspBean {
    /**
     * @export
     * @enum {string}
     */
    export enum SspTypeEnum {
        Bidswitch = <any> 'Bidswitch',
        OpenRTB = <any> 'OpenRTB',
        Site = <any> 'Site',
        CommonXML = <any> 'CommonXML'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CreativeTypeEnum {
        Audio = <any> 'Audio',
        Banner = <any> 'Banner',
        Native = <any> 'Native',
        Pop = <any> 'Pop',
        Push = <any> 'Push',
        Video = <any> 'Video'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AuctionModeEnum {
        AuctionTypeFromRequest = <any> 'Auction type from request',
        FirstPrice = <any> 'First price',
        SecondPrice = <any> 'Second price'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TrackingTypeEnum {
        View = <any> 'View',
        Burl = <any> 'Burl',
        Win = <any> 'Win'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BidswitchSspListModeEnum {
        Black = <any> 'Black',
        White = <any> 'White'
    }
}
/**
 * 
 * @export
 * @interface SspInfoBean
 */
export interface SspInfoBean {
    /**
     * 
     * @type {number}
     * @memberof SspInfoBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SspInfoBean
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface SspListItemBean
 */
export interface SspListItemBean {
    /**
     * 
     * @type {number}
     * @memberof SspListItemBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SspListItemBean
     */
    agencyId?: number;
    /**
     * 
     * @type {string}
     * @memberof SspListItemBean
     */
    agencyName?: string;
    /**
     * 
     * @type {string}
     * @memberof SspListItemBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SspListItemBean
     */
    internalName?: string;
    /**
     * 
     * @type {string}
     * @memberof SspListItemBean
     */
    sspType?: SspListItemBean.SspTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SspListItemBean
     */
    endpoint?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SspListItemBean
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SspListItemBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace SspListItemBean
 */
export namespace SspListItemBean {
    /**
     * @export
     * @enum {string}
     */
    export enum SspTypeEnum {
        Bidswitch = <any> 'Bidswitch',
        OpenRTB = <any> 'OpenRTB',
        Site = <any> 'Site',
        CommonXML = <any> 'CommonXML'
    }
}
/**
 * 
 * @export
 * @interface SspReportBean
 */
export interface SspReportBean {
    /**
     * 
     * @type {number}
     * @memberof SspReportBean
     */
    id?: number;
    /**
     * 
     * @type {Breakdown}
     * @memberof SspReportBean
     */
    stats?: Breakdown;
}
/**
 * 
 * @export
 * @interface SspReportLine
 */
export interface SspReportLine {
    /**
     * 
     * @type {string}
     * @memberof SspReportLine
     */
    getDate?: string;
    /**
     * 
     * @type {number}
     * @memberof SspReportLine
     */
    responses?: number;
    /**
     * 
     * @type {number}
     * @memberof SspReportLine
     */
    impressions?: number;
    /**
     * 
     * @type {number}
     * @memberof SspReportLine
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof SspReportLine
     */
    revenue?: number;
}
/**
 * 
 * @export
 * @interface StripeConnectStatusBean
 */
export interface StripeConnectStatusBean {
    /**
     * 
     * @type {boolean}
     * @memberof StripeConnectStatusBean
     */
    configured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StripeConnectStatusBean
     */
    connected?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StripeConnectStatusBean
     */
    chargesEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StripeConnectStatusBean
     */
    payoutsEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StripeConnectStatusBean
     */
    livemode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StripeConnectStatusBean
     */
    accountDisplay?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StripeConnectStatusBean
     */
    paymentBlocked?: boolean;
}
/**
 * 
 * @export
 * @interface TimezoneBean
 */
export interface TimezoneBean {
    /**
     * 
     * @type {string}
     * @memberof TimezoneBean
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TimezoneBean
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof TimezoneBean
     */
    offset?: number;
}
/**
 * 
 * @export
 * @interface TrackerBean
 */
export interface TrackerBean {
    /**
     * 
     * @type {number}
     * @memberof TrackerBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackerBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackerBean
     */
    advertiserName?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackerBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TrackerBean
     */
    agencyId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackerBean
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackerBean
     */
    trackerType?: TrackerBean.TrackerTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof TrackerBean
     */
    eventId?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackerBean
     */
    eventName?: string;
    /**
     * 
     * @type {number}
     * @memberof TrackerBean
     */
    cost?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TrackerBean
     */
    specifyPriceInJsTag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrackerBean
     */
    specifyPriceInPrebidJs?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TrackerBean
     */
    modified?: Date;
}

/**
 * @export
 * @namespace TrackerBean
 */
export namespace TrackerBean {
    /**
     * @export
     * @enum {string}
     */
    export enum TrackerTypeEnum {
        Postback = <any> 'Postback',
        Pixel = <any> 'Pixel'
    }
}
/**
 * 
 * @export
 * @interface TrackerEventBean
 */
export interface TrackerEventBean {
    /**
     * 
     * @type {number}
     * @memberof TrackerEventBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackerEventBean
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrackerEventBean
     */
    withPrice?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TrackerEventBean
     */
    modified?: Date;
}
/**
 * 
 * @export
 * @interface TrackerPriceFlagsBean
 */
export interface TrackerPriceFlagsBean {
    /**
     * 
     * @type {boolean}
     * @memberof TrackerPriceFlagsBean
     */
    specifyPriceInJsTag: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrackerPriceFlagsBean
     */
    specifyPriceInPrebidJs: boolean;
}
/**
 * 
 * @export
 * @interface TrackerReportRequestParameters
 */
export interface TrackerReportRequestParameters extends ReportRequestParametersObjectObject {
    /**
     * 
     * @type {Array<TrackerStatKeyColumnDescription>}
     * @memberof TrackerReportRequestParameters
     */
    keyColumns?: Array<TrackerStatKeyColumnDescription>;
    /**
     * 
     * @type {Array<TrackerStatValueColumnDescription>}
     * @memberof TrackerReportRequestParameters
     */
    valueColumns?: Array<TrackerStatValueColumnDescription>;
}

/**
 * @export
 * @namespace TrackerReportRequestParameters
 */
export namespace TrackerReportRequestParameters {
}
/**
 * 
 * @export
 * @interface TrackerStatKeyColumnDescription
 */
export interface TrackerStatKeyColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof TrackerStatKeyColumnDescription
     */
    column?: TrackerStatKeyColumnDescription.ColumnEnum;
    /**
     * 
     * @type {string}
     * @memberof TrackerStatKeyColumnDescription
     */
    order?: TrackerStatKeyColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TrackerStatKeyColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {KeyFilterClause}
     * @memberof TrackerStatKeyColumnDescription
     */
    where?: KeyFilterClause;
    /**
     * 
     * @type {any}
     * @memberof TrackerStatKeyColumnDescription
     */
    param?: any;
    /**
     * 
     * @type {string}
     * @memberof TrackerStatKeyColumnDescription
     */
    alias?: string;
}

/**
 * @export
 * @namespace TrackerStatKeyColumnDescription
 */
export namespace TrackerStatKeyColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        Time = <any> 'Time',
        Agency = <any> 'Agency',
        AgencyId = <any> 'AgencyId',
        Tracker = <any> 'Tracker',
        TrackerId = <any> 'TrackerId',
        Ssp = <any> 'Ssp',
        SspId = <any> 'SspId',
        SubSsp = <any> 'SubSsp',
        RequestType = <any> 'RequestType',
        SspReqType = <any> 'SspReqType',
        Publisher = <any> 'Publisher',
        PublisherId = <any> 'PublisherId',
        Site = <any> 'Site',
        SiteId = <any> 'SiteId',
        AdUnit = <any> 'AdUnit',
        AdUnitId = <any> 'AdUnitId',
        DealId = <any> 'DealId',
        SiteType = <any> 'SiteType',
        UserIp = <any> 'UserIp',
        UserUa = <any> 'UserUa',
        UserIfa = <any> 'UserIfa',
        UserPageUrl = <any> 'UserPageUrl',
        UserReferrer = <any> 'UserReferrer',
        UserCountry = <any> 'UserCountry',
        UserRegion = <any> 'UserRegion',
        UserCity = <any> 'UserCity',
        UserCompany = <any> 'UserCompany',
        Ip = <any> 'Ip',
        Domain = <any> 'Domain',
        Bundle = <any> 'Bundle',
        Company = <any> 'Company',
        Country = <any> 'Country',
        CountryIso3 = <any> 'CountryIso3',
        DeviceType = <any> 'DeviceType',
        Os = <any> 'Os',
        ConnectionType = <any> 'ConnectionType',
        Browser = <any> 'Browser',
        Advertiser = <any> 'Advertiser',
        AdvertiserId = <any> 'AdvertiserId',
        Campaign = <any> 'Campaign',
        CampaignId = <any> 'CampaignId',
        AdGroup = <any> 'AdGroup',
        AdGroupId = <any> 'AdGroupId',
        Creative = <any> 'Creative',
        CreativeId = <any> 'CreativeId',
        CampaignDealId = <any> 'CampaignDealId',
        FormatType = <any> 'FormatType',
        AdSize = <any> 'AdSize',
        Event = <any> 'Event',
        ErrorEvent = <any> 'ErrorEvent',
        EventPrice = <any> 'EventPrice',
        ErrorEventPrice = <any> 'ErrorEventPrice',
        ErrorReason = <any> 'ErrorReason'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface TrackerStatValueColumnDescription
 */
export interface TrackerStatValueColumnDescription {
    /**
     * 
     * @type {string}
     * @memberof TrackerStatValueColumnDescription
     */
    column?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackerStatValueColumnDescription
     */
    order?: TrackerStatValueColumnDescription.OrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TrackerStatValueColumnDescription
     */
    onlyFilter?: boolean;
    /**
     * 
     * @type {ValueFilterClause}
     * @memberof TrackerStatValueColumnDescription
     */
    where?: ValueFilterClause;
    /**
     * 
     * @type {any}
     * @memberof TrackerStatValueColumnDescription
     */
    param?: any;
    /**
     * 
     * @type {string}
     * @memberof TrackerStatValueColumnDescription
     */
    alias?: string;
}

/**
 * @export
 * @namespace TrackerStatValueColumnDescription
 */
export namespace TrackerStatValueColumnDescription {
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface TransactionBean
 */
export interface TransactionBean {
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    advertiserId?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionBean
     */
    advertiserName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionBean
     */
    transactionType?: TransactionBean.TransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    amountBefore?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    amountAfter?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    totalSpends?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionBean
     */
    paySystem?: TransactionBean.PaySystemEnum;
    /**
     * 
     * @type {string}
     * @memberof TransactionBean
     */
    note?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransactionBean
     */
    created?: Date;
}

/**
 * @export
 * @namespace TransactionBean
 */
export namespace TransactionBean {
    /**
     * @export
     * @enum {string}
     */
    export enum TransactionTypeEnum {
        AGENCYPAY = <any> 'AGENCY_PAY',
        ADVERTISERPAY = <any> 'ADVERTISER_PAY',
        BIDDINGSPENDS = <any> 'BIDDING_SPENDS',
        ANTIFRAUDSPENDS = <any> 'ANTI_FRAUD_SPENDS',
        ADMINADDING = <any> 'ADMIN_ADDING',
        ADMINSUBTRACTION = <any> 'ADMIN_SUBTRACTION'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PaySystemEnum {
        MONEY = <any> 'MONEY',
        STRIPE = <any> 'STRIPE'
    }
}
/**
 * 
 * @export
 * @interface UploadTypeBody
 */
export interface UploadTypeBody {
    /**
     * 
     * @type {Blob}
     * @memberof UploadTypeBody
     */
    file: Blob;
}
/**
 * 
 * @export
 * @interface ValueFilterClause
 */
export interface ValueFilterClause {
    /**
     * 
     * @type {string}
     * @memberof ValueFilterClause
     */
    type?: ValueFilterClause.TypeEnum;
    /**
     * 
     * @type {any}
     * @memberof ValueFilterClause
     */
    value?: any;
}

/**
 * @export
 * @namespace ValueFilterClause
 */
export namespace ValueFilterClause {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        L = <any> 'l',
        G = <any> 'g',
        Le = <any> 'le',
        Ge = <any> 'ge',
        Between = <any> 'between'
    }
}
/**
 * AccountControllerApi - fetch parameter creator
 * @export
 */
export const AccountControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling account.');
            }
            const localVarPath = `/api/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Accounts
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {string} [role] 
         * @param {number} [agencyId] 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, role?: string, agencyId?: number, advertiserId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (agencyId !== undefined) {
                localVarQueryParameter['agencyId'] = agencyId;
            }

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProps(options: any = {}): FetchArgs {
            const localVarPath = `/api/account/props`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAccountStatus(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling changeAccountStatus.');
            }
            const localVarPath = `/api/account/{id}/change-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAccount.');
            }
            const localVarPath = `/api/account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAccount.');
            }
            const localVarPath = `/api/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAccount.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAccount.');
            }
            const localVarPath = `/api/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalToken(options: any = {}): FetchArgs {
            const localVarPath = `/api/account/external-token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs(userId: number, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling loginAs.');
            }
            const localVarPath = `/api/account/login-as/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} advertiserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsAdvertiser(advertiserId: number, options: any = {}): FetchArgs {
            // verify required parameter 'advertiserId' is not null or undefined
            if (advertiserId === null || advertiserId === undefined) {
                throw new RequiredError('advertiserId','Required parameter advertiserId was null or undefined when calling loginAsAdvertiser.');
            }
            const localVarPath = `/api/account/login-as-advertiser/{advertiserId}`
                .replace(`{${"advertiserId"}}`, encodeURIComponent(String(advertiserId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} agencyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsAgency(agencyId: number, options: any = {}): FetchArgs {
            // verify required parameter 'agencyId' is not null or undefined
            if (agencyId === null || agencyId === undefined) {
                throw new RequiredError('agencyId','Required parameter agencyId was null or undefined when calling loginAsAgency.');
            }
            const localVarPath = `/api/account/login-as-agency/{agencyId}`
                .replace(`{${"agencyId"}}`, encodeURIComponent(String(agencyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenStatus(options: any = {}): FetchArgs {
            const localVarPath = `/api/account/token-status`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountControllerApi - functional programming interface
 * @export
 */
export const AccountControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).account(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Accounts
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {string} [role] 
         * @param {number} [agencyId] 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, role?: string, agencyId?: number, advertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAccountListItemBean> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).accountList(sortFieldName, sortOrder, searchByName, active, role, agencyId, advertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProps(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).accountProps(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAccountStatus(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).changeAccountStatus(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).createAccount(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).deleteAccount(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBeanObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).editAccount(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalToken(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).externalToken(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs(userId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).loginAs(userId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} advertiserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsAdvertiser(advertiserId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).loginAsAdvertiser(advertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} agencyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsAgency(agencyId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).loginAsAgency(agencyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenStatus(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).tokenStatus(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AccountControllerApi - factory interface
 * @export
 */
export const AccountControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(id: number, options?: any) {
            return AccountControllerApiFp(configuration).account(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Accounts
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {string} [role] 
         * @param {number} [agencyId] 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, role?: string, agencyId?: number, advertiserId?: number, options?: any) {
            return AccountControllerApiFp(configuration).accountList(sortFieldName, sortOrder, searchByName, active, role, agencyId, advertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountProps(options?: any) {
            return AccountControllerApiFp(configuration).accountProps(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAccountStatus(id: number, options?: any) {
            return AccountControllerApiFp(configuration).changeAccountStatus(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options?: any) {
            return AccountControllerApiFp(configuration).createAccount(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options?: any) {
            return AccountControllerApiFp(configuration).deleteAccount(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options?: any) {
            return AccountControllerApiFp(configuration).editAccount(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalToken(options?: any) {
            return AccountControllerApiFp(configuration).externalToken(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs(userId: number, options?: any) {
            return AccountControllerApiFp(configuration).loginAs(userId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} advertiserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsAdvertiser(advertiserId: number, options?: any) {
            return AccountControllerApiFp(configuration).loginAsAdvertiser(advertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} agencyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsAgency(agencyId: number, options?: any) {
            return AccountControllerApiFp(configuration).loginAsAgency(agencyId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenStatus(options?: any) {
            return AccountControllerApiFp(configuration).tokenStatus(options)(fetch, basePath);
        },
    };
};

/**
 * AccountControllerApi - object-oriented interface
 * @export
 * @class AccountControllerApi
 * @extends {BaseAPI}
 */
export class AccountControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public account(id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).account(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Accounts
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {boolean} [active] 
     * @param {string} [role] 
     * @param {number} [agencyId] 
     * @param {number} [advertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public accountList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, role?: string, agencyId?: number, advertiserId?: number, options?: any) {
        return AccountControllerApiFp(this.configuration).accountList(sortFieldName, sortOrder, searchByName, active, role, agencyId, advertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public accountProps(options?: any) {
        return AccountControllerApiFp(this.configuration).accountProps(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public changeAccountStatus(id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).changeAccountStatus(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AccountBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public createAccount(body: AccountBean, options?: any) {
        return AccountControllerApiFp(this.configuration).createAccount(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public deleteAccount(id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).deleteAccount(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AccountBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public editAccount(body: AccountBean, id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).editAccount(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public externalToken(options?: any) {
        return AccountControllerApiFp(this.configuration).externalToken(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public loginAs(userId: number, options?: any) {
        return AccountControllerApiFp(this.configuration).loginAs(userId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} advertiserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public loginAsAdvertiser(advertiserId: number, options?: any) {
        return AccountControllerApiFp(this.configuration).loginAsAdvertiser(advertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} agencyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public loginAsAgency(agencyId: number, options?: any) {
        return AccountControllerApiFp(this.configuration).loginAsAgency(agencyId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public tokenStatus(options?: any) {
        return AccountControllerApiFp(this.configuration).tokenStatus(options)(this.fetch, this.basePath);
    }

}
/**
 * AdGroupControllerApi - fetch parameter creator
 * @export
 */
export const AdGroupControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroup(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adGroup.');
            }
            const localVarPath = `/api/ad-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all AdGroups for admin ui
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {string} [format] 
         * @param {number} [advertiserId] 
         * @param {number} [campaignId] 
         * @param {number} [creativeId] 
         * @param {number} [retargetingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroupList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, format?: string, advertiserId?: number, campaignId?: number, creativeId?: number, retargetingListId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/ad-group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }

            if (creativeId !== undefined) {
                localVarQueryParameter['creativeId'] = creativeId;
            }

            if (retargetingListId !== undefined) {
                localVarQueryParameter['retargetingListId'] = retargetingListId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdGroupBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdGroup(body: AdGroupBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAdGroup.');
            }
            const localVarPath = `/api/ad-group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdGroupBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdGroup(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAdGroup.');
            }
            const localVarPath = `/api/ad-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdGroupBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdGroup(body: AdGroupBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAdGroup.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAdGroup.');
            }
            const localVarPath = `/api/ad-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdGroupBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDeleteAdGroup(body: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling massDeleteAdGroup.');
            }
            const localVarPath = `/api/ad-group/massDelete`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDisableAdGroup(body: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling massDisableAdGroup.');
            }
            const localVarPath = `/api/ad-group/massDisable`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massEnableAdGroup(body: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling massEnableAdGroup.');
            }
            const localVarPath = `/api/ad-group/massEnable`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdGroupControllerApi - functional programming interface
 * @export
 */
export const AdGroupControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroup(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdGroupBeanObject> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).adGroup(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all AdGroups for admin ui
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {string} [format] 
         * @param {number} [advertiserId] 
         * @param {number} [campaignId] 
         * @param {number} [creativeId] 
         * @param {number} [retargetingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroupList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, format?: string, advertiserId?: number, campaignId?: number, creativeId?: number, retargetingListId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdGroupListItemBean> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).adGroupList(sortFieldName, sortOrder, searchByName, active, format, advertiserId, campaignId, creativeId, retargetingListId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdGroupBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdGroup(body: AdGroupBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdGroupBeanObject> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).createAdGroup(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdGroup(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).deleteAdGroup(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdGroupBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdGroup(body: AdGroupBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdGroupBeanObject> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).editAdGroup(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDeleteAdGroup(body: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).massDeleteAdGroup(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDisableAdGroup(body: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).massDisableAdGroup(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massEnableAdGroup(body: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdGroupControllerApiFetchParamCreator(configuration).massEnableAdGroup(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdGroupControllerApi - factory interface
 * @export
 */
export const AdGroupControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroup(id: number, options?: any) {
            return AdGroupControllerApiFp(configuration).adGroup(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all AdGroups for admin ui
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {string} [format] 
         * @param {number} [advertiserId] 
         * @param {number} [campaignId] 
         * @param {number} [creativeId] 
         * @param {number} [retargetingListId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroupList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, format?: string, advertiserId?: number, campaignId?: number, creativeId?: number, retargetingListId?: number, options?: any) {
            return AdGroupControllerApiFp(configuration).adGroupList(sortFieldName, sortOrder, searchByName, active, format, advertiserId, campaignId, creativeId, retargetingListId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdGroupBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdGroup(body: AdGroupBean, options?: any) {
            return AdGroupControllerApiFp(configuration).createAdGroup(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdGroup(id: number, options?: any) {
            return AdGroupControllerApiFp(configuration).deleteAdGroup(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdGroupBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdGroup(body: AdGroupBean, id: number, options?: any) {
            return AdGroupControllerApiFp(configuration).editAdGroup(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDeleteAdGroup(body: Array<number>, options?: any) {
            return AdGroupControllerApiFp(configuration).massDeleteAdGroup(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDisableAdGroup(body: Array<number>, options?: any) {
            return AdGroupControllerApiFp(configuration).massDisableAdGroup(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massEnableAdGroup(body: Array<number>, options?: any) {
            return AdGroupControllerApiFp(configuration).massEnableAdGroup(body, options)(fetch, basePath);
        },
    };
};

/**
 * AdGroupControllerApi - object-oriented interface
 * @export
 * @class AdGroupControllerApi
 * @extends {BaseAPI}
 */
export class AdGroupControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public adGroup(id: number, options?: any) {
        return AdGroupControllerApiFp(this.configuration).adGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all AdGroups for admin ui
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {boolean} [active] 
     * @param {string} [format] 
     * @param {number} [advertiserId] 
     * @param {number} [campaignId] 
     * @param {number} [creativeId] 
     * @param {number} [retargetingListId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public adGroupList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, format?: string, advertiserId?: number, campaignId?: number, creativeId?: number, retargetingListId?: number, options?: any) {
        return AdGroupControllerApiFp(this.configuration).adGroupList(sortFieldName, sortOrder, searchByName, active, format, advertiserId, campaignId, creativeId, retargetingListId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdGroupBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public createAdGroup(body: AdGroupBean, options?: any) {
        return AdGroupControllerApiFp(this.configuration).createAdGroup(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public deleteAdGroup(id: number, options?: any) {
        return AdGroupControllerApiFp(this.configuration).deleteAdGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdGroupBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public editAdGroup(body: AdGroupBean, id: number, options?: any) {
        return AdGroupControllerApiFp(this.configuration).editAdGroup(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public massDeleteAdGroup(body: Array<number>, options?: any) {
        return AdGroupControllerApiFp(this.configuration).massDeleteAdGroup(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public massDisableAdGroup(body: Array<number>, options?: any) {
        return AdGroupControllerApiFp(this.configuration).massDisableAdGroup(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdGroupControllerApi
     */
    public massEnableAdGroup(body: Array<number>, options?: any) {
        return AdGroupControllerApiFp(this.configuration).massEnableAdGroup(body, options)(this.fetch, this.basePath);
    }

}
/**
 * AdUnitControllerApi - fetch parameter creator
 * @export
 */
export const AdUnitControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnit(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adUnit.');
            }
            const localVarPath = `/api/ad-unit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitListByPublisherId(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adUnitListByPublisherId.');
            }
            const localVarPath = `/api/publisher/{id}/ad-unit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {number} [siteId] 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitPage(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, siteId?: number, publisherId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/ad-unit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }

            if (publisherId !== undefined) {
                localVarQueryParameter['publisherId'] = publisherId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitSelector(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adUnitSelector.');
            }
            const localVarPath = `/api/ad-unit/sel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitSelectorPage(sortFieldName?: string, sortOrder?: string, search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/ad-unit/sel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bySiteId(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling bySiteId.');
            }
            const localVarPath = `/api/site/{id}/ad-unit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdUnitBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdUnit(body: AdUnitBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAdUnit.');
            }
            const localVarPath = `/api/ad-unit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdUnitBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdUnit(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAdUnit.');
            }
            const localVarPath = `/api/ad-unit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdUnitBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdUnit(body: AdUnitBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAdUnit.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAdUnit.');
            }
            const localVarPath = `/api/ad-unit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdUnitBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdUnitCsv(options: any = {}): FetchArgs {
            const localVarPath = `/api/ad-unit/csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} active 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdUnitActive(id: number, active: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setAdUnitActive.');
            }
            // verify required parameter 'active' is not null or undefined
            if (active === null || active === undefined) {
                throw new RequiredError('active','Required parameter active was null or undefined when calling setAdUnitActive.');
            }
            const localVarPath = `/api/ad-unit/active/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToken(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateToken.');
            }
            const localVarPath = `/api/ad-unit/{id}/token`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdUnitControllerApi - functional programming interface
 * @export
 */
export const AdUnitControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnit(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdUnitBeanObject> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).adUnit(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitListByPublisherId(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdUnitBean> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).adUnitListByPublisherId(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {number} [siteId] 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitPage(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, siteId?: number, publisherId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdUnitBean> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).adUnitPage(sortFieldName, sortOrder, search, active, siteId, publisherId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitSelector(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdUnitBeanObject> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).adUnitSelector(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitSelectorPage(sortFieldName?: string, sortOrder?: string, search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdUnitBean> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).adUnitSelectorPage(sortFieldName, sortOrder, search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bySiteId(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdUnitBean> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).bySiteId(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdUnitBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdUnit(body: AdUnitBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdUnitBeanObject> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).createAdUnit(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdUnit(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).deleteAdUnit(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdUnitBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdUnit(body: AdUnitBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdUnitBeanObject> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).editAdUnit(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdUnitCsv(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).getAdUnitCsv(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} active 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdUnitActive(id: number, active: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdUnitBeanObject> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).setAdUnitActive(id, active, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToken(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdUnitBeanObject> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).updateToken(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdUnitControllerApi - factory interface
 * @export
 */
export const AdUnitControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnit(id: number, options?: any) {
            return AdUnitControllerApiFp(configuration).adUnit(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitListByPublisherId(id: number, options?: any) {
            return AdUnitControllerApiFp(configuration).adUnitListByPublisherId(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {number} [siteId] 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitPage(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, siteId?: number, publisherId?: number, options?: any) {
            return AdUnitControllerApiFp(configuration).adUnitPage(sortFieldName, sortOrder, search, active, siteId, publisherId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitSelector(id: number, options?: any) {
            return AdUnitControllerApiFp(configuration).adUnitSelector(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitSelectorPage(sortFieldName?: string, sortOrder?: string, search?: string, options?: any) {
            return AdUnitControllerApiFp(configuration).adUnitSelectorPage(sortFieldName, sortOrder, search, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bySiteId(id: number, options?: any) {
            return AdUnitControllerApiFp(configuration).bySiteId(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdUnitBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdUnit(body: AdUnitBean, options?: any) {
            return AdUnitControllerApiFp(configuration).createAdUnit(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdUnit(id: number, options?: any) {
            return AdUnitControllerApiFp(configuration).deleteAdUnit(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdUnitBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdUnit(body: AdUnitBean, id: number, options?: any) {
            return AdUnitControllerApiFp(configuration).editAdUnit(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdUnitCsv(options?: any) {
            return AdUnitControllerApiFp(configuration).getAdUnitCsv(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} active 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdUnitActive(id: number, active: boolean, options?: any) {
            return AdUnitControllerApiFp(configuration).setAdUnitActive(id, active, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToken(id: number, options?: any) {
            return AdUnitControllerApiFp(configuration).updateToken(id, options)(fetch, basePath);
        },
    };
};

/**
 * AdUnitControllerApi - object-oriented interface
 * @export
 * @class AdUnitControllerApi
 * @extends {BaseAPI}
 */
export class AdUnitControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public adUnit(id: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).adUnit(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public adUnitListByPublisherId(id: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).adUnitListByPublisherId(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [search] 
     * @param {boolean} [active] 
     * @param {number} [siteId] 
     * @param {number} [publisherId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public adUnitPage(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, siteId?: number, publisherId?: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).adUnitPage(sortFieldName, sortOrder, search, active, siteId, publisherId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public adUnitSelector(id: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).adUnitSelector(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public adUnitSelectorPage(sortFieldName?: string, sortOrder?: string, search?: string, options?: any) {
        return AdUnitControllerApiFp(this.configuration).adUnitSelectorPage(sortFieldName, sortOrder, search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public bySiteId(id: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).bySiteId(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdUnitBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public createAdUnit(body: AdUnitBean, options?: any) {
        return AdUnitControllerApiFp(this.configuration).createAdUnit(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public deleteAdUnit(id: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).deleteAdUnit(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdUnitBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public editAdUnit(body: AdUnitBean, id: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).editAdUnit(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public getAdUnitCsv(options?: any) {
        return AdUnitControllerApiFp(this.configuration).getAdUnitCsv(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} active 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public setAdUnitActive(id: number, active: boolean, options?: any) {
        return AdUnitControllerApiFp(this.configuration).setAdUnitActive(id, active, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public updateToken(id: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).updateToken(id, options)(this.fetch, this.basePath);
    }

}
/**
 * AdvControllerApi - fetch parameter creator
 * @export
 */
export const AdvControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adv(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adv.');
            }
            const localVarPath = `/api/adv/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [trusted] 
         * @param {boolean} [active] 
         * @param {number} [agencyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advPage(sortFieldName?: string, sortOrder?: string, search?: string, trusted?: boolean, active?: boolean, agencyId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/adv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (trusted !== undefined) {
                localVarQueryParameter['trusted'] = trusted;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (agencyId !== undefined) {
                localVarQueryParameter['agencyId'] = agencyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiserActivate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling advertiserActivate.');
            }
            const localVarPath = `/api/adv/activate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiserDeactivate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling advertiserDeactivate.');
            }
            const localVarPath = `/api/adv/deactivate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdvertiserBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdv(body: AdvertiserBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAdv.');
            }
            const localVarPath = `/api/adv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdvertiserBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdv(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAdv.');
            }
            const localVarPath = `/api/adv/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdvertiserBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdv(body: AdvertiserBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAdv.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAdv.');
            }
            const localVarPath = `/api/adv/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdvertiserBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeAdvTrusted(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling makeAdvTrusted.');
            }
            const localVarPath = `/api/adv/trusted/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeAdvUntrusted(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling makeAdvUntrusted.');
            }
            const localVarPath = `/api/adv/untrusted/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPayments1(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling unblockPayments1.');
            }
            const localVarPath = `/api/adv/{id}/payment-unblock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdvControllerApi - functional programming interface
 * @export
 */
export const AdvControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adv(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdvertiserBeanObject> {
            const localVarFetchArgs = AdvControllerApiFetchParamCreator(configuration).adv(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [trusted] 
         * @param {boolean} [active] 
         * @param {number} [agencyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advPage(sortFieldName?: string, sortOrder?: string, search?: string, trusted?: boolean, active?: boolean, agencyId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdvertiserListItemBean> {
            const localVarFetchArgs = AdvControllerApiFetchParamCreator(configuration).advPage(sortFieldName, sortOrder, search, trusted, active, agencyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiserActivate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AdvControllerApiFetchParamCreator(configuration).advertiserActivate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiserDeactivate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AdvControllerApiFetchParamCreator(configuration).advertiserDeactivate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdvertiserBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdv(body: AdvertiserBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdvertiserBeanObject> {
            const localVarFetchArgs = AdvControllerApiFetchParamCreator(configuration).createAdv(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdv(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdvControllerApiFetchParamCreator(configuration).deleteAdv(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdvertiserBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdv(body: AdvertiserBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdvertiserBeanObject> {
            const localVarFetchArgs = AdvControllerApiFetchParamCreator(configuration).editAdv(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeAdvTrusted(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AdvControllerApiFetchParamCreator(configuration).makeAdvTrusted(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeAdvUntrusted(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AdvControllerApiFetchParamCreator(configuration).makeAdvUntrusted(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPayments1(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AdvControllerApiFetchParamCreator(configuration).unblockPayments1(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdvControllerApi - factory interface
 * @export
 */
export const AdvControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adv(id: number, options?: any) {
            return AdvControllerApiFp(configuration).adv(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [trusted] 
         * @param {boolean} [active] 
         * @param {number} [agencyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advPage(sortFieldName?: string, sortOrder?: string, search?: string, trusted?: boolean, active?: boolean, agencyId?: number, options?: any) {
            return AdvControllerApiFp(configuration).advPage(sortFieldName, sortOrder, search, trusted, active, agencyId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiserActivate(id: number, options?: any) {
            return AdvControllerApiFp(configuration).advertiserActivate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advertiserDeactivate(id: number, options?: any) {
            return AdvControllerApiFp(configuration).advertiserDeactivate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdvertiserBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdv(body: AdvertiserBean, options?: any) {
            return AdvControllerApiFp(configuration).createAdv(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdv(id: number, options?: any) {
            return AdvControllerApiFp(configuration).deleteAdv(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdvertiserBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdv(body: AdvertiserBean, id: number, options?: any) {
            return AdvControllerApiFp(configuration).editAdv(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeAdvTrusted(id: number, options?: any) {
            return AdvControllerApiFp(configuration).makeAdvTrusted(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeAdvUntrusted(id: number, options?: any) {
            return AdvControllerApiFp(configuration).makeAdvUntrusted(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPayments1(id: number, options?: any) {
            return AdvControllerApiFp(configuration).unblockPayments1(id, options)(fetch, basePath);
        },
    };
};

/**
 * AdvControllerApi - object-oriented interface
 * @export
 * @class AdvControllerApi
 * @extends {BaseAPI}
 */
export class AdvControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvControllerApi
     */
    public adv(id: number, options?: any) {
        return AdvControllerApiFp(this.configuration).adv(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [search] 
     * @param {boolean} [trusted] 
     * @param {boolean} [active] 
     * @param {number} [agencyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvControllerApi
     */
    public advPage(sortFieldName?: string, sortOrder?: string, search?: string, trusted?: boolean, active?: boolean, agencyId?: number, options?: any) {
        return AdvControllerApiFp(this.configuration).advPage(sortFieldName, sortOrder, search, trusted, active, agencyId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvControllerApi
     */
    public advertiserActivate(id: number, options?: any) {
        return AdvControllerApiFp(this.configuration).advertiserActivate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvControllerApi
     */
    public advertiserDeactivate(id: number, options?: any) {
        return AdvControllerApiFp(this.configuration).advertiserDeactivate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdvertiserBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvControllerApi
     */
    public createAdv(body: AdvertiserBean, options?: any) {
        return AdvControllerApiFp(this.configuration).createAdv(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvControllerApi
     */
    public deleteAdv(id: number, options?: any) {
        return AdvControllerApiFp(this.configuration).deleteAdv(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdvertiserBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvControllerApi
     */
    public editAdv(body: AdvertiserBean, id: number, options?: any) {
        return AdvControllerApiFp(this.configuration).editAdv(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvControllerApi
     */
    public makeAdvTrusted(id: number, options?: any) {
        return AdvControllerApiFp(this.configuration).makeAdvTrusted(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvControllerApi
     */
    public makeAdvUntrusted(id: number, options?: any) {
        return AdvControllerApiFp(this.configuration).makeAdvUntrusted(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvControllerApi
     */
    public unblockPayments1(id: number, options?: any) {
        return AdvControllerApiFp(this.configuration).unblockPayments1(id, options)(this.fetch, this.basePath);
    }

}
/**
 * AgencyBalanceControllerApi - fetch parameter creator
 * @export
 */
export const AgencyBalanceControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} agency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyBalance(agency: number, options: any = {}): FetchArgs {
            // verify required parameter 'agency' is not null or undefined
            if (agency === null || agency === undefined) {
                throw new RequiredError('agency','Required parameter agency was null or undefined when calling agencyBalance.');
            }
            const localVarPath = `/api/agency-balance`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agency !== undefined) {
                localVarQueryParameter['agency'] = agency;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AgencyOperationBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyOperate(body: AgencyOperationBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling agencyOperate.');
            }
            const localVarPath = `/api/agency-balance/operate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AgencyOperationBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [agencyId] 
         * @param {string} [transactionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyTransactionList(sortFieldName?: string, sortOrder?: string, search?: string, startDate?: string, endDate?: string, agencyId?: number, transactionType?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/agency-transaction/page`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (agencyId !== undefined) {
                localVarQueryParameter['agencyId'] = agencyId;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NewPaymentBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAgencyPayment(body: NewPaymentBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling startAgencyPayment.');
            }
            const localVarPath = `/api/start-payment`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NewPaymentBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyBalanceControllerApi - functional programming interface
 * @export
 */
export const AgencyBalanceControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} agency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyBalance(agency: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAgencyBalanceBeanObject> {
            const localVarFetchArgs = AgencyBalanceControllerApiFetchParamCreator(configuration).agencyBalance(agency, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AgencyOperationBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyOperate(body: AgencyOperationBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAgencyTransactionBeanObject> {
            const localVarFetchArgs = AgencyBalanceControllerApiFetchParamCreator(configuration).agencyOperate(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [agencyId] 
         * @param {string} [transactionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyTransactionList(sortFieldName?: string, sortOrder?: string, search?: string, startDate?: string, endDate?: string, agencyId?: number, transactionType?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAgencyTransactionBean> {
            const localVarFetchArgs = AgencyBalanceControllerApiFetchParamCreator(configuration).agencyTransactionList(sortFieldName, sortOrder, search, startDate, endDate, agencyId, transactionType, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {NewPaymentBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAgencyPayment(body: NewPaymentBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AgencyBalanceControllerApiFetchParamCreator(configuration).startAgencyPayment(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AgencyBalanceControllerApi - factory interface
 * @export
 */
export const AgencyBalanceControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} agency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyBalance(agency: number, options?: any) {
            return AgencyBalanceControllerApiFp(configuration).agencyBalance(agency, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AgencyOperationBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyOperate(body: AgencyOperationBean, options?: any) {
            return AgencyBalanceControllerApiFp(configuration).agencyOperate(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [agencyId] 
         * @param {string} [transactionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyTransactionList(sortFieldName?: string, sortOrder?: string, search?: string, startDate?: string, endDate?: string, agencyId?: number, transactionType?: string, options?: any) {
            return AgencyBalanceControllerApiFp(configuration).agencyTransactionList(sortFieldName, sortOrder, search, startDate, endDate, agencyId, transactionType, options)(fetch, basePath);
        },
        /**
         * 
         * @param {NewPaymentBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAgencyPayment(body: NewPaymentBean, options?: any) {
            return AgencyBalanceControllerApiFp(configuration).startAgencyPayment(body, options)(fetch, basePath);
        },
    };
};

/**
 * AgencyBalanceControllerApi - object-oriented interface
 * @export
 * @class AgencyBalanceControllerApi
 * @extends {BaseAPI}
 */
export class AgencyBalanceControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} agency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyBalanceControllerApi
     */
    public agencyBalance(agency: number, options?: any) {
        return AgencyBalanceControllerApiFp(this.configuration).agencyBalance(agency, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AgencyOperationBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyBalanceControllerApi
     */
    public agencyOperate(body: AgencyOperationBean, options?: any) {
        return AgencyBalanceControllerApiFp(this.configuration).agencyOperate(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [search] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [agencyId] 
     * @param {string} [transactionType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyBalanceControllerApi
     */
    public agencyTransactionList(sortFieldName?: string, sortOrder?: string, search?: string, startDate?: string, endDate?: string, agencyId?: number, transactionType?: string, options?: any) {
        return AgencyBalanceControllerApiFp(this.configuration).agencyTransactionList(sortFieldName, sortOrder, search, startDate, endDate, agencyId, transactionType, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {NewPaymentBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyBalanceControllerApi
     */
    public startAgencyPayment(body: NewPaymentBean, options?: any) {
        return AgencyBalanceControllerApiFp(this.configuration).startAgencyPayment(body, options)(this.fetch, this.basePath);
    }

}
/**
 * AgencyControllerApi - fetch parameter creator
 * @export
 */
export const AgencyControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agency(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling agency.');
            }
            const localVarPath = `/api/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyActivate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling agencyActivate.');
            }
            const localVarPath = `/api/agency/activate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyCreate(body: AgencyBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling agencyCreate.');
            }
            const localVarPath = `/api/agency`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AgencyBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyDeactivate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling agencyDeactivate.');
            }
            const localVarPath = `/api/agency/deactivate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyDelete(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling agencyDelete.');
            }
            const localVarPath = `/api/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Agencies
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyPage(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/agency`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AgencyBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyUpdate(body: AgencyBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling agencyUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling agencyUpdate.');
            }
            const localVarPath = `/api/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AgencyBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowUiAccess(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling allowUiAccess.');
            }
            const localVarPath = `/api/agency/allow-ui/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restrictUiAccess(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling restrictUiAccess.');
            }
            const localVarPath = `/api/agency/restrict-ui/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPayments(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling unblockPayments.');
            }
            const localVarPath = `/api/agency/{id}/payment-unblock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyControllerApi - functional programming interface
 * @export
 */
export const AgencyControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agency(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAgencyBeanObject> {
            const localVarFetchArgs = AgencyControllerApiFetchParamCreator(configuration).agency(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyActivate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AgencyControllerApiFetchParamCreator(configuration).agencyActivate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyCreate(body: AgencyBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAgencyBeanObject> {
            const localVarFetchArgs = AgencyControllerApiFetchParamCreator(configuration).agencyCreate(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyDeactivate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AgencyControllerApiFetchParamCreator(configuration).agencyDeactivate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyDelete(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AgencyControllerApiFetchParamCreator(configuration).agencyDelete(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Agencies
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyPage(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAgencyBean> {
            const localVarFetchArgs = AgencyControllerApiFetchParamCreator(configuration).agencyPage(sortFieldName, sortOrder, search, active, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AgencyBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyUpdate(body: AgencyBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAgencyBeanObject> {
            const localVarFetchArgs = AgencyControllerApiFetchParamCreator(configuration).agencyUpdate(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowUiAccess(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AgencyControllerApiFetchParamCreator(configuration).allowUiAccess(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restrictUiAccess(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AgencyControllerApiFetchParamCreator(configuration).restrictUiAccess(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPayments(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = AgencyControllerApiFetchParamCreator(configuration).unblockPayments(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AgencyControllerApi - factory interface
 * @export
 */
export const AgencyControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agency(id: number, options?: any) {
            return AgencyControllerApiFp(configuration).agency(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyActivate(id: number, options?: any) {
            return AgencyControllerApiFp(configuration).agencyActivate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyCreate(body: AgencyBean, options?: any) {
            return AgencyControllerApiFp(configuration).agencyCreate(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyDeactivate(id: number, options?: any) {
            return AgencyControllerApiFp(configuration).agencyDeactivate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyDelete(id: number, options?: any) {
            return AgencyControllerApiFp(configuration).agencyDelete(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Agencies
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyPage(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, options?: any) {
            return AgencyControllerApiFp(configuration).agencyPage(sortFieldName, sortOrder, search, active, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AgencyBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyUpdate(body: AgencyBean, id: number, options?: any) {
            return AgencyControllerApiFp(configuration).agencyUpdate(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowUiAccess(id: number, options?: any) {
            return AgencyControllerApiFp(configuration).allowUiAccess(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restrictUiAccess(id: number, options?: any) {
            return AgencyControllerApiFp(configuration).restrictUiAccess(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPayments(id: number, options?: any) {
            return AgencyControllerApiFp(configuration).unblockPayments(id, options)(fetch, basePath);
        },
    };
};

/**
 * AgencyControllerApi - object-oriented interface
 * @export
 * @class AgencyControllerApi
 * @extends {BaseAPI}
 */
export class AgencyControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyControllerApi
     */
    public agency(id: number, options?: any) {
        return AgencyControllerApiFp(this.configuration).agency(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyControllerApi
     */
    public agencyActivate(id: number, options?: any) {
        return AgencyControllerApiFp(this.configuration).agencyActivate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AgencyBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyControllerApi
     */
    public agencyCreate(body: AgencyBean, options?: any) {
        return AgencyControllerApiFp(this.configuration).agencyCreate(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyControllerApi
     */
    public agencyDeactivate(id: number, options?: any) {
        return AgencyControllerApiFp(this.configuration).agencyDeactivate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyControllerApi
     */
    public agencyDelete(id: number, options?: any) {
        return AgencyControllerApiFp(this.configuration).agencyDelete(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Agencies
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [search] 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyControllerApi
     */
    public agencyPage(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, options?: any) {
        return AgencyControllerApiFp(this.configuration).agencyPage(sortFieldName, sortOrder, search, active, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AgencyBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyControllerApi
     */
    public agencyUpdate(body: AgencyBean, id: number, options?: any) {
        return AgencyControllerApiFp(this.configuration).agencyUpdate(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyControllerApi
     */
    public allowUiAccess(id: number, options?: any) {
        return AgencyControllerApiFp(this.configuration).allowUiAccess(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyControllerApi
     */
    public restrictUiAccess(id: number, options?: any) {
        return AgencyControllerApiFp(this.configuration).restrictUiAccess(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyControllerApi
     */
    public unblockPayments(id: number, options?: any) {
        return AgencyControllerApiFp(this.configuration).unblockPayments(id, options)(this.fetch, this.basePath);
    }

}
/**
 * AuthLogReportControllerApi - fetch parameter creator
 * @export
 */
export const AuthLogReportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [accountId] 
         * @param {number} [agencyId] 
         * @param {string} [interfaceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogList(startDate?: string, endDate?: string, accountId?: number, agencyId?: number, interfaceId?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/auth-log`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (agencyId !== undefined) {
                localVarQueryParameter['agencyId'] = agencyId;
            }

            if (interfaceId !== undefined) {
                localVarQueryParameter['interfaceId'] = interfaceId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthLogReportControllerApi - functional programming interface
 * @export
 */
export const AuthLogReportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [accountId] 
         * @param {number} [agencyId] 
         * @param {string} [interfaceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogList(startDate?: string, endDate?: string, accountId?: number, agencyId?: number, interfaceId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAuthLog> {
            const localVarFetchArgs = AuthLogReportControllerApiFetchParamCreator(configuration).authLogList(startDate, endDate, accountId, agencyId, interfaceId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AuthLogReportControllerApi - factory interface
 * @export
 */
export const AuthLogReportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [accountId] 
         * @param {number} [agencyId] 
         * @param {string} [interfaceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogList(startDate?: string, endDate?: string, accountId?: number, agencyId?: number, interfaceId?: string, options?: any) {
            return AuthLogReportControllerApiFp(configuration).authLogList(startDate, endDate, accountId, agencyId, interfaceId, options)(fetch, basePath);
        },
    };
};

/**
 * AuthLogReportControllerApi - object-oriented interface
 * @export
 * @class AuthLogReportControllerApi
 * @extends {BaseAPI}
 */
export class AuthLogReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [accountId] 
     * @param {number} [agencyId] 
     * @param {string} [interfaceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthLogReportControllerApi
     */
    public authLogList(startDate?: string, endDate?: string, accountId?: number, agencyId?: number, interfaceId?: string, options?: any) {
        return AuthLogReportControllerApiFp(this.configuration).authLogList(startDate, endDate, accountId, agencyId, interfaceId, options)(this.fetch, this.basePath);
    }

}
/**
 * BalanceControllerApi - fetch parameter creator
 * @export
 */
export const BalanceControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} advertiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balance(advertiser: number, options: any = {}): FetchArgs {
            // verify required parameter 'advertiser' is not null or undefined
            if (advertiser === null || advertiser === undefined) {
                throw new RequiredError('advertiser','Required parameter advertiser was null or undefined when calling balance.');
            }
            const localVarPath = `/api/balance`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertiser !== undefined) {
                localVarQueryParameter['advertiser'] = advertiser;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceList(sortFieldName?: string, sortOrder?: string, searchByName?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/balance/page`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OperationBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceOperate(body: OperationBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling balanceOperate.');
            }
            const localVarPath = `/api/balance/operate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OperationBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NewAdvertiserPaymentBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAdvertiserPayment(body: NewAdvertiserPaymentBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling startAdvertiserPayment.');
            }
            const localVarPath = `/api/balance/start-payment`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NewAdvertiserPaymentBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [advertiserId] 
         * @param {string} [transactionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionList(sortFieldName?: string, sortOrder?: string, search?: string, startDate?: string, endDate?: string, advertiserId?: number, transactionType?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/transaction/page`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BalanceControllerApi - functional programming interface
 * @export
 */
export const BalanceControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} advertiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balance(advertiser: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdvertiserBalanceBeanObject> {
            const localVarFetchArgs = BalanceControllerApiFetchParamCreator(configuration).balance(advertiser, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceList(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdvertiserBalanceBean> {
            const localVarFetchArgs = BalanceControllerApiFetchParamCreator(configuration).balanceList(sortFieldName, sortOrder, searchByName, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {OperationBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceOperate(body: OperationBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseTransactionBeanObject> {
            const localVarFetchArgs = BalanceControllerApiFetchParamCreator(configuration).balanceOperate(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {NewAdvertiserPaymentBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAdvertiserPayment(body: NewAdvertiserPaymentBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = BalanceControllerApiFetchParamCreator(configuration).startAdvertiserPayment(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [advertiserId] 
         * @param {string} [transactionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionList(sortFieldName?: string, sortOrder?: string, search?: string, startDate?: string, endDate?: string, advertiserId?: number, transactionType?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseTransactionBean> {
            const localVarFetchArgs = BalanceControllerApiFetchParamCreator(configuration).transactionList(sortFieldName, sortOrder, search, startDate, endDate, advertiserId, transactionType, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * BalanceControllerApi - factory interface
 * @export
 */
export const BalanceControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} advertiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balance(advertiser: number, options?: any) {
            return BalanceControllerApiFp(configuration).balance(advertiser, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceList(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
            return BalanceControllerApiFp(configuration).balanceList(sortFieldName, sortOrder, searchByName, options)(fetch, basePath);
        },
        /**
         * 
         * @param {OperationBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceOperate(body: OperationBean, options?: any) {
            return BalanceControllerApiFp(configuration).balanceOperate(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {NewAdvertiserPaymentBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAdvertiserPayment(body: NewAdvertiserPaymentBean, options?: any) {
            return BalanceControllerApiFp(configuration).startAdvertiserPayment(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [advertiserId] 
         * @param {string} [transactionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionList(sortFieldName?: string, sortOrder?: string, search?: string, startDate?: string, endDate?: string, advertiserId?: number, transactionType?: string, options?: any) {
            return BalanceControllerApiFp(configuration).transactionList(sortFieldName, sortOrder, search, startDate, endDate, advertiserId, transactionType, options)(fetch, basePath);
        },
    };
};

/**
 * BalanceControllerApi - object-oriented interface
 * @export
 * @class BalanceControllerApi
 * @extends {BaseAPI}
 */
export class BalanceControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} advertiser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public balance(advertiser: number, options?: any) {
        return BalanceControllerApiFp(this.configuration).balance(advertiser, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public balanceList(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
        return BalanceControllerApiFp(this.configuration).balanceList(sortFieldName, sortOrder, searchByName, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {OperationBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public balanceOperate(body: OperationBean, options?: any) {
        return BalanceControllerApiFp(this.configuration).balanceOperate(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {NewAdvertiserPaymentBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public startAdvertiserPayment(body: NewAdvertiserPaymentBean, options?: any) {
        return BalanceControllerApiFp(this.configuration).startAdvertiserPayment(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [search] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [advertiserId] 
     * @param {string} [transactionType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceControllerApi
     */
    public transactionList(sortFieldName?: string, sortOrder?: string, search?: string, startDate?: string, endDate?: string, advertiserId?: number, transactionType?: string, options?: any) {
        return BalanceControllerApiFp(this.configuration).transactionList(sortFieldName, sortOrder, search, startDate, endDate, advertiserId, transactionType, options)(this.fetch, this.basePath);
    }

}
/**
 * BuildInfoControllerApi - fetch parameter creator
 * @export
 */
export const BuildInfoControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        about(options: any = {}): FetchArgs {
            const localVarPath = `/build-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aboutPrometheus(options: any = {}): FetchArgs {
            const localVarPath = `/build-info/prometheus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuildInfoControllerApi - functional programming interface
 * @export
 */
export const BuildInfoControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        about(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: any; }> {
            const localVarFetchArgs = BuildInfoControllerApiFetchParamCreator(configuration).about(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aboutPrometheus(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = BuildInfoControllerApiFetchParamCreator(configuration).aboutPrometheus(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * BuildInfoControllerApi - factory interface
 * @export
 */
export const BuildInfoControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        about(options?: any) {
            return BuildInfoControllerApiFp(configuration).about(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aboutPrometheus(options?: any) {
            return BuildInfoControllerApiFp(configuration).aboutPrometheus(options)(fetch, basePath);
        },
    };
};

/**
 * BuildInfoControllerApi - object-oriented interface
 * @export
 * @class BuildInfoControllerApi
 * @extends {BaseAPI}
 */
export class BuildInfoControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildInfoControllerApi
     */
    public about(options?: any) {
        return BuildInfoControllerApiFp(this.configuration).about(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildInfoControllerApi
     */
    public aboutPrometheus(options?: any) {
        return BuildInfoControllerApiFp(this.configuration).aboutPrometheus(options)(this.fetch, this.basePath);
    }

}
/**
 * CampaignControllerApi - fetch parameter creator
 * @export
 */
export const CampaignControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaign(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling campaign.');
            }
            const localVarPath = `/api/campaign/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignActivate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling campaignActivate.');
            }
            const localVarPath = `/api/campaign/activate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CampaignBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignCreate(body: CampaignBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling campaignCreate.');
            }
            const localVarPath = `/api/campaign`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CampaignBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignDeactivate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling campaignDeactivate.');
            }
            const localVarPath = `/api/campaign/deactivate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignDelete(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling campaignDelete.');
            }
            const localVarPath = `/api/campaign/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Campaigns
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignList(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, advertiserId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/campaign`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CampaignBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignUpdate(body: CampaignBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling campaignUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling campaignUpdate.');
            }
            const localVarPath = `/api/campaign/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CampaignBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignControllerApi - functional programming interface
 * @export
 */
export const CampaignControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaign(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCampaignBeanObject> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).campaign(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignActivate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).campaignActivate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {CampaignBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignCreate(body: CampaignBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCampaignBeanObject> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).campaignCreate(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignDeactivate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).campaignDeactivate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignDelete(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).campaignDelete(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Campaigns
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignList(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, advertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseCampaignListItemBean> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).campaignList(sortFieldName, sortOrder, search, active, advertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {CampaignBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignUpdate(body: CampaignBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCampaignBeanObject> {
            const localVarFetchArgs = CampaignControllerApiFetchParamCreator(configuration).campaignUpdate(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CampaignControllerApi - factory interface
 * @export
 */
export const CampaignControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaign(id: number, options?: any) {
            return CampaignControllerApiFp(configuration).campaign(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignActivate(id: number, options?: any) {
            return CampaignControllerApiFp(configuration).campaignActivate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {CampaignBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignCreate(body: CampaignBean, options?: any) {
            return CampaignControllerApiFp(configuration).campaignCreate(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignDeactivate(id: number, options?: any) {
            return CampaignControllerApiFp(configuration).campaignDeactivate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignDelete(id: number, options?: any) {
            return CampaignControllerApiFp(configuration).campaignDelete(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Campaigns
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {boolean} [active] 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignList(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, advertiserId?: number, options?: any) {
            return CampaignControllerApiFp(configuration).campaignList(sortFieldName, sortOrder, search, active, advertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {CampaignBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignUpdate(body: CampaignBean, id: number, options?: any) {
            return CampaignControllerApiFp(configuration).campaignUpdate(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * CampaignControllerApi - object-oriented interface
 * @export
 * @class CampaignControllerApi
 * @extends {BaseAPI}
 */
export class CampaignControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public campaign(id: number, options?: any) {
        return CampaignControllerApiFp(this.configuration).campaign(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public campaignActivate(id: number, options?: any) {
        return CampaignControllerApiFp(this.configuration).campaignActivate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {CampaignBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public campaignCreate(body: CampaignBean, options?: any) {
        return CampaignControllerApiFp(this.configuration).campaignCreate(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public campaignDeactivate(id: number, options?: any) {
        return CampaignControllerApiFp(this.configuration).campaignDeactivate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public campaignDelete(id: number, options?: any) {
        return CampaignControllerApiFp(this.configuration).campaignDelete(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Campaigns
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [search] 
     * @param {boolean} [active] 
     * @param {number} [advertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public campaignList(sortFieldName?: string, sortOrder?: string, search?: string, active?: boolean, advertiserId?: number, options?: any) {
        return CampaignControllerApiFp(this.configuration).campaignList(sortFieldName, sortOrder, search, active, advertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {CampaignBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public campaignUpdate(body: CampaignBean, id: number, options?: any) {
        return CampaignControllerApiFp(this.configuration).campaignUpdate(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * CreativeControllerApi - fetch parameter creator
 * @export
 */
export const CreativeControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} bean 
         * @param {Blob} [icon] 
         * @param {Blob} [media] 
         * @param {Array<Blob>} [nativeImages] 
         * @param {Array<Blob>} [nativeVideos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreative(bean: string, icon?: Blob, media?: Blob, nativeImages?: Array<Blob>, nativeVideos?: Array<Blob>, options: any = {}): FetchArgs {
            // verify required parameter 'bean' is not null or undefined
            if (bean === null || bean === undefined) {
                throw new RequiredError('bean','Required parameter bean was null or undefined when calling createCreative.');
            }
            const localVarPath = `/api/creative`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            if (bean !== undefined) {
                localVarQueryParameter['bean'] = bean;
            }

            if (icon !== undefined) {
                localVarFormParams.set('icon', icon as any);
            }

            if (media !== undefined) {
                localVarFormParams.set('media', media as any);
            }

            if (nativeImages) {
                nativeImages.forEach((element) => {
                    localVarFormParams.append('nativeImages', element as any);
                })
            }

            if (nativeVideos) {
                nativeVideos.forEach((element) => {
                    localVarFormParams.append('nativeVideos', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nativeDataBeanJson 
         * @param {NativeBulkBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNativeBulk(nativeDataBeanJson: string, body?: NativeBulkBody, options: any = {}): FetchArgs {
            // verify required parameter 'nativeDataBeanJson' is not null or undefined
            if (nativeDataBeanJson === null || nativeDataBeanJson === undefined) {
                throw new RequiredError('nativeDataBeanJson','Required parameter nativeDataBeanJson was null or undefined when calling createNativeBulk.');
            }
            const localVarPath = `/api/creative/native/bulk`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nativeDataBeanJson !== undefined) {
                localVarQueryParameter['nativeDataBeanJson'] = nativeDataBeanJson;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NativeBulkBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Creatives
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {string} [searchByStatus] 
         * @param {boolean} [active] 
         * @param {string} [format] 
         * @param {number} [adGroupId] 
         * @param {number} [advertiserId] 
         * @param {Array<number>} [creativeIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeList(sortFieldName?: string, sortOrder?: string, searchByName?: string, searchByStatus?: string, active?: boolean, format?: string, adGroupId?: number, advertiserId?: number, creativeIds?: Array<number>, options: any = {}): FetchArgs {
            const localVarPath = `/api/creative`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (searchByStatus !== undefined) {
                localVarQueryParameter['searchByStatus'] = searchByStatus;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (adGroupId !== undefined) {
                localVarQueryParameter['adGroupId'] = adGroupId;
            }

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (creativeIds) {
                localVarQueryParameter['creativeIds'] = creativeIds;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeUploadImage(file?: Blob, options: any = {}): FetchArgs {
            const localVarPath = `/api/creative/upload`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            if (file !== undefined) {
                localVarFormParams.set('file', file as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreative(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCreative.');
            }
            const localVarPath = `/api/creative/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} bean 
         * @param {Blob} [icon] 
         * @param {Blob} [media] 
         * @param {Array<Blob>} [nativeImages] 
         * @param {Array<Blob>} [nativeVideos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCreative(id: number, bean: string, icon?: Blob, media?: Blob, nativeImages?: Array<Blob>, nativeVideos?: Array<Blob>, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editCreative.');
            }
            // verify required parameter 'bean' is not null or undefined
            if (bean === null || bean === undefined) {
                throw new RequiredError('bean','Required parameter bean was null or undefined when calling editCreative.');
            }
            const localVarPath = `/api/creative/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            if (bean !== undefined) {
                localVarQueryParameter['bean'] = bean;
            }

            if (icon !== undefined) {
                localVarFormParams.set('icon', icon as any);
            }

            if (media !== undefined) {
                localVarFormParams.set('media', media as any);
            }

            if (nativeImages) {
                nativeImages.forEach((element) => {
                    localVarFormParams.append('nativeImages', element as any);
                })
            }

            if (nativeVideos) {
                nativeVideos.forEach((element) => {
                    localVarFormParams.append('nativeVideos', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreative(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCreative.');
            }
            const localVarPath = `/api/creative/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massApproveCreative(body: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling massApproveCreative.');
            }
            const localVarPath = `/api/creative/massApprove`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDeleteCreative(body: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling massDeleteCreative.');
            }
            const localVarPath = `/api/creative/massDelete`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDisableCreative(body: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling massDisableCreative.');
            }
            const localVarPath = `/api/creative/massDisable`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massEnableCreative(body: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling massEnableCreative.');
            }
            const localVarPath = `/api/creative/massEnable`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massRefuseCreative(body: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling massRefuseCreative.');
            }
            const localVarPath = `/api/creative/massRefuse`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreativeControllerApi - functional programming interface
 * @export
 */
export const CreativeControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} bean 
         * @param {Blob} [icon] 
         * @param {Blob} [media] 
         * @param {Array<Blob>} [nativeImages] 
         * @param {Array<Blob>} [nativeVideos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreative(bean: string, icon?: Blob, media?: Blob, nativeImages?: Array<Blob>, nativeVideos?: Array<Blob>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCreativeBeanObject> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).createCreative(bean, icon, media, nativeImages, nativeVideos, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} nativeDataBeanJson 
         * @param {NativeBulkBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNativeBulk(nativeDataBeanJson: string, body?: NativeBulkBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BulkResultBean> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).createNativeBulk(nativeDataBeanJson, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Creatives
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {string} [searchByStatus] 
         * @param {boolean} [active] 
         * @param {string} [format] 
         * @param {number} [adGroupId] 
         * @param {number} [advertiserId] 
         * @param {Array<number>} [creativeIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeList(sortFieldName?: string, sortOrder?: string, searchByName?: string, searchByStatus?: string, active?: boolean, format?: string, adGroupId?: number, advertiserId?: number, creativeIds?: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseCreativeListItemBean> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).creativeList(sortFieldName, sortOrder, searchByName, searchByStatus, active, format, adGroupId, advertiserId, creativeIds, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeUploadImage(file?: Blob, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).creativeUploadImage(file, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreative(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).deleteCreative(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} bean 
         * @param {Blob} [icon] 
         * @param {Blob} [media] 
         * @param {Array<Blob>} [nativeImages] 
         * @param {Array<Blob>} [nativeVideos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCreative(id: number, bean: string, icon?: Blob, media?: Blob, nativeImages?: Array<Blob>, nativeVideos?: Array<Blob>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCreativeBeanObject> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).editCreative(id, bean, icon, media, nativeImages, nativeVideos, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreative(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCreativeBeanObject> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).getCreative(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massApproveCreative(body: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).massApproveCreative(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDeleteCreative(body: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).massDeleteCreative(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDisableCreative(body: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).massDisableCreative(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massEnableCreative(body: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).massEnableCreative(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massRefuseCreative(body: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CreativeControllerApiFetchParamCreator(configuration).massRefuseCreative(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CreativeControllerApi - factory interface
 * @export
 */
export const CreativeControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} bean 
         * @param {Blob} [icon] 
         * @param {Blob} [media] 
         * @param {Array<Blob>} [nativeImages] 
         * @param {Array<Blob>} [nativeVideos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreative(bean: string, icon?: Blob, media?: Blob, nativeImages?: Array<Blob>, nativeVideos?: Array<Blob>, options?: any) {
            return CreativeControllerApiFp(configuration).createCreative(bean, icon, media, nativeImages, nativeVideos, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} nativeDataBeanJson 
         * @param {NativeBulkBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNativeBulk(nativeDataBeanJson: string, body?: NativeBulkBody, options?: any) {
            return CreativeControllerApiFp(configuration).createNativeBulk(nativeDataBeanJson, body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Creatives
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {string} [searchByStatus] 
         * @param {boolean} [active] 
         * @param {string} [format] 
         * @param {number} [adGroupId] 
         * @param {number} [advertiserId] 
         * @param {Array<number>} [creativeIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeList(sortFieldName?: string, sortOrder?: string, searchByName?: string, searchByStatus?: string, active?: boolean, format?: string, adGroupId?: number, advertiserId?: number, creativeIds?: Array<number>, options?: any) {
            return CreativeControllerApiFp(configuration).creativeList(sortFieldName, sortOrder, searchByName, searchByStatus, active, format, adGroupId, advertiserId, creativeIds, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creativeUploadImage(file?: Blob, options?: any) {
            return CreativeControllerApiFp(configuration).creativeUploadImage(file, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCreative(id: number, options?: any) {
            return CreativeControllerApiFp(configuration).deleteCreative(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} bean 
         * @param {Blob} [icon] 
         * @param {Blob} [media] 
         * @param {Array<Blob>} [nativeImages] 
         * @param {Array<Blob>} [nativeVideos] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCreative(id: number, bean: string, icon?: Blob, media?: Blob, nativeImages?: Array<Blob>, nativeVideos?: Array<Blob>, options?: any) {
            return CreativeControllerApiFp(configuration).editCreative(id, bean, icon, media, nativeImages, nativeVideos, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreative(id: number, options?: any) {
            return CreativeControllerApiFp(configuration).getCreative(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massApproveCreative(body: Array<number>, options?: any) {
            return CreativeControllerApiFp(configuration).massApproveCreative(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDeleteCreative(body: Array<number>, options?: any) {
            return CreativeControllerApiFp(configuration).massDeleteCreative(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDisableCreative(body: Array<number>, options?: any) {
            return CreativeControllerApiFp(configuration).massDisableCreative(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massEnableCreative(body: Array<number>, options?: any) {
            return CreativeControllerApiFp(configuration).massEnableCreative(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massRefuseCreative(body: Array<number>, options?: any) {
            return CreativeControllerApiFp(configuration).massRefuseCreative(body, options)(fetch, basePath);
        },
    };
};

/**
 * CreativeControllerApi - object-oriented interface
 * @export
 * @class CreativeControllerApi
 * @extends {BaseAPI}
 */
export class CreativeControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} bean 
     * @param {Blob} [icon] 
     * @param {Blob} [media] 
     * @param {Array<Blob>} [nativeImages] 
     * @param {Array<Blob>} [nativeVideos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public createCreative(bean: string, icon?: Blob, media?: Blob, nativeImages?: Array<Blob>, nativeVideos?: Array<Blob>, options?: any) {
        return CreativeControllerApiFp(this.configuration).createCreative(bean, icon, media, nativeImages, nativeVideos, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} nativeDataBeanJson 
     * @param {NativeBulkBody} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public createNativeBulk(nativeDataBeanJson: string, body?: NativeBulkBody, options?: any) {
        return CreativeControllerApiFp(this.configuration).createNativeBulk(nativeDataBeanJson, body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Creatives
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {string} [searchByStatus] 
     * @param {boolean} [active] 
     * @param {string} [format] 
     * @param {number} [adGroupId] 
     * @param {number} [advertiserId] 
     * @param {Array<number>} [creativeIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public creativeList(sortFieldName?: string, sortOrder?: string, searchByName?: string, searchByStatus?: string, active?: boolean, format?: string, adGroupId?: number, advertiserId?: number, creativeIds?: Array<number>, options?: any) {
        return CreativeControllerApiFp(this.configuration).creativeList(sortFieldName, sortOrder, searchByName, searchByStatus, active, format, adGroupId, advertiserId, creativeIds, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Blob} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public creativeUploadImage(file?: Blob, options?: any) {
        return CreativeControllerApiFp(this.configuration).creativeUploadImage(file, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public deleteCreative(id: number, options?: any) {
        return CreativeControllerApiFp(this.configuration).deleteCreative(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {string} bean 
     * @param {Blob} [icon] 
     * @param {Blob} [media] 
     * @param {Array<Blob>} [nativeImages] 
     * @param {Array<Blob>} [nativeVideos] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public editCreative(id: number, bean: string, icon?: Blob, media?: Blob, nativeImages?: Array<Blob>, nativeVideos?: Array<Blob>, options?: any) {
        return CreativeControllerApiFp(this.configuration).editCreative(id, bean, icon, media, nativeImages, nativeVideos, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public getCreative(id: number, options?: any) {
        return CreativeControllerApiFp(this.configuration).getCreative(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public massApproveCreative(body: Array<number>, options?: any) {
        return CreativeControllerApiFp(this.configuration).massApproveCreative(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public massDeleteCreative(body: Array<number>, options?: any) {
        return CreativeControllerApiFp(this.configuration).massDeleteCreative(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public massDisableCreative(body: Array<number>, options?: any) {
        return CreativeControllerApiFp(this.configuration).massDisableCreative(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public massEnableCreative(body: Array<number>, options?: any) {
        return CreativeControllerApiFp(this.configuration).massEnableCreative(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativeControllerApi
     */
    public massRefuseCreative(body: Array<number>, options?: any) {
        return CreativeControllerApiFp(this.configuration).massRefuseCreative(body, options)(this.fetch, this.basePath);
    }

}
/**
 * CustomizationControllerApi - fetch parameter creator
 * @export
 */
export const CustomizationControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavicon(options: any = {}): FetchArgs {
            const localVarPath = `/api/custom/favicon`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogo(options: any = {}): FetchArgs {
            const localVarPath = `/api/custom/logo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {{ [key: string]: any; }} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomSettings(body: { [key: string]: any; }, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling uploadCustomSettings.');
            }
            const localVarPath = `/api/custom/settings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"{ [key: string]: any; }" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFavicon(file?: Blob, options: any = {}): FetchArgs {
            const localVarPath = `/api/custom/favicon`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            if (file !== undefined) {
                localVarFormParams.set('file', file as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo(file?: Blob, options: any = {}): FetchArgs {
            const localVarPath = `/api/custom/logo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            if (file !== undefined) {
                localVarFormParams.set('file', file as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomizationControllerApi - functional programming interface
 * @export
 */
export const CustomizationControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavicon(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CustomizationControllerApiFetchParamCreator(configuration).deleteFavicon(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CustomizationControllerApiFetchParamCreator(configuration).deleteLogo(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {{ [key: string]: any; }} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomSettings(body: { [key: string]: any; }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CustomizationControllerApiFetchParamCreator(configuration).uploadCustomSettings(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFavicon(file?: Blob, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CustomizationControllerApiFetchParamCreator(configuration).uploadFavicon(file, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo(file?: Blob, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CustomizationControllerApiFetchParamCreator(configuration).uploadLogo(file, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CustomizationControllerApi - factory interface
 * @export
 */
export const CustomizationControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavicon(options?: any) {
            return CustomizationControllerApiFp(configuration).deleteFavicon(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogo(options?: any) {
            return CustomizationControllerApiFp(configuration).deleteLogo(options)(fetch, basePath);
        },
        /**
         * 
         * @param {{ [key: string]: any; }} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomSettings(body: { [key: string]: any; }, options?: any) {
            return CustomizationControllerApiFp(configuration).uploadCustomSettings(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFavicon(file?: Blob, options?: any) {
            return CustomizationControllerApiFp(configuration).uploadFavicon(file, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Blob} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo(file?: Blob, options?: any) {
            return CustomizationControllerApiFp(configuration).uploadLogo(file, options)(fetch, basePath);
        },
    };
};

/**
 * CustomizationControllerApi - object-oriented interface
 * @export
 * @class CustomizationControllerApi
 * @extends {BaseAPI}
 */
export class CustomizationControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationControllerApi
     */
    public deleteFavicon(options?: any) {
        return CustomizationControllerApiFp(this.configuration).deleteFavicon(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationControllerApi
     */
    public deleteLogo(options?: any) {
        return CustomizationControllerApiFp(this.configuration).deleteLogo(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {{ [key: string]: any; }} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationControllerApi
     */
    public uploadCustomSettings(body: { [key: string]: any; }, options?: any) {
        return CustomizationControllerApiFp(this.configuration).uploadCustomSettings(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Blob} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationControllerApi
     */
    public uploadFavicon(file?: Blob, options?: any) {
        return CustomizationControllerApiFp(this.configuration).uploadFavicon(file, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Blob} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomizationControllerApi
     */
    public uploadLogo(file?: Blob, options?: any) {
        return CustomizationControllerApiFp(this.configuration).uploadLogo(file, options)(this.fetch, this.basePath);
    }

}
/**
 * DealControllerApi - fetch parameter creator
 * @export
 */
export const DealControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DealBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeal(body: DealBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createDeal.');
            }
            const localVarPath = `/api/deal`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DealBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deal(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deal.');
            }
            const localVarPath = `/api/deal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealActivate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling dealActivate.');
            }
            const localVarPath = `/api/deal/activate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealDeactivate(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling dealDeactivate.');
            }
            const localVarPath = `/api/deal/deactivate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealDspList(options: any = {}): FetchArgs {
            const localVarPath = `/api/deal/deal-dsp`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/deal`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeal(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteDeal.');
            }
            const localVarPath = `/api/deal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DealBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDeal(body: DealBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editDeal.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editDeal.');
            }
            const localVarPath = `/api/deal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DealBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealCsv(options: any = {}): FetchArgs {
            const localVarPath = `/api/deal/csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DealControllerApi - functional programming interface
 * @export
 */
export const DealControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DealBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeal(body: DealBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDealBeanObject> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).createDeal(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deal(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDealBeanObject> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).deal(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealActivate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).dealActivate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealDeactivate(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).dealDeactivate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealDspList(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDealDspBean> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).dealDspList(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDealBean> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).dealPage(sortFieldName, sortOrder, searchByName, active, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeal(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).deleteDeal(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DealBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDeal(body: DealBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDealBeanObject> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).editDeal(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealCsv(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DealControllerApiFetchParamCreator(configuration).getDealCsv(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DealControllerApi - factory interface
 * @export
 */
export const DealControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {DealBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeal(body: DealBean, options?: any) {
            return DealControllerApiFp(configuration).createDeal(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deal(id: number, options?: any) {
            return DealControllerApiFp(configuration).deal(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealActivate(id: number, options?: any) {
            return DealControllerApiFp(configuration).dealActivate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealDeactivate(id: number, options?: any) {
            return DealControllerApiFp(configuration).dealDeactivate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealDspList(options?: any) {
            return DealControllerApiFp(configuration).dealDspList(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, options?: any) {
            return DealControllerApiFp(configuration).dealPage(sortFieldName, sortOrder, searchByName, active, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeal(id: number, options?: any) {
            return DealControllerApiFp(configuration).deleteDeal(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DealBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDeal(body: DealBean, id: number, options?: any) {
            return DealControllerApiFp(configuration).editDeal(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealCsv(options?: any) {
            return DealControllerApiFp(configuration).getDealCsv(options)(fetch, basePath);
        },
    };
};

/**
 * DealControllerApi - object-oriented interface
 * @export
 * @class DealControllerApi
 * @extends {BaseAPI}
 */
export class DealControllerApi extends BaseAPI {
    /**
     * 
     * @param {DealBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public createDeal(body: DealBean, options?: any) {
        return DealControllerApiFp(this.configuration).createDeal(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public deal(id: number, options?: any) {
        return DealControllerApiFp(this.configuration).deal(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public dealActivate(id: number, options?: any) {
        return DealControllerApiFp(this.configuration).dealActivate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public dealDeactivate(id: number, options?: any) {
        return DealControllerApiFp(this.configuration).dealDeactivate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public dealDspList(options?: any) {
        return DealControllerApiFp(this.configuration).dealDspList(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public dealPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, options?: any) {
        return DealControllerApiFp(this.configuration).dealPage(sortFieldName, sortOrder, searchByName, active, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public deleteDeal(id: number, options?: any) {
        return DealControllerApiFp(this.configuration).deleteDeal(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DealBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public editDeal(body: DealBean, id: number, options?: any) {
        return DealControllerApiFp(this.configuration).editDeal(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealControllerApi
     */
    public getDealCsv(options?: any) {
        return DealControllerApiFp(this.configuration).getDealCsv(options)(this.fetch, this.basePath);
    }

}
/**
 * DictionariesControllerApi - fetch parameter creator
 * @export
 */
export const DictionariesControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignDeal(options: any = {}): FetchArgs {
            const localVarPath = `/api/campaign-deal`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [countryIds] 
         * @param {Array<number>} [regionIds] 
         * @param {string} [q] 
         * @param {Array<number>} [cityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cities(countryIds?: Array<number>, regionIds?: Array<number>, q?: string, cityIds?: Array<number>, options: any = {}): FetchArgs {
            const localVarPath = `/api/city`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (countryIds) {
                localVarQueryParameter['countryIds'] = countryIds;
            }

            if (regionIds) {
                localVarQueryParameter['regionIds'] = regionIds;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (cityIds) {
                localVarQueryParameter['cityIds'] = cityIds;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cityGet(ids: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new RequiredError('ids','Required parameter ids was null or undefined when calling cityGet.');
            }
            const localVarPath = `/api/city/get`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pattern 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<number>} [selectedIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        citySearch(pattern: string, pageSize: number, pageNumber: number, selectedIds?: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'pattern' is not null or undefined
            if (pattern === null || pattern === undefined) {
                throw new RequiredError('pattern','Required parameter pattern was null or undefined when calling citySearch.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling citySearch.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling citySearch.');
            }
            const localVarPath = `/api/city/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pattern !== undefined) {
                localVarQueryParameter['pattern'] = pattern;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (selectedIds) {
                localVarQueryParameter['selectedIds'] = selectedIds;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} names 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyGet(names: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'names' is not null or undefined
            if (names === null || names === undefined) {
                throw new RequiredError('names','Required parameter names was null or undefined when calling companyGet.');
            }
            const localVarPath = `/api/company/get`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (names) {
                localVarQueryParameter['names'] = names;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pattern 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} [selectedNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySearch(pattern: string, pageSize: number, pageNumber: number, selectedNames?: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'pattern' is not null or undefined
            if (pattern === null || pattern === undefined) {
                throw new RequiredError('pattern','Required parameter pattern was null or undefined when calling companySearch.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling companySearch.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling companySearch.');
            }
            const localVarPath = `/api/company/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pattern !== undefined) {
                localVarQueryParameter['pattern'] = pattern;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (selectedNames) {
                localVarQueryParameter['selectedNames'] = selectedNames;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options: any = {}): FetchArgs {
            const localVarPath = `/api/country`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iabCategories(options: any = {}): FetchArgs {
            const localVarPath = `/api/iab-category`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iasBrandSafetyCodes(options: any = {}): FetchArgs {
            const localVarPath = `/api/ias-brand-safety-codes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of keywords
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keywords(search: string, options: any = {}): FetchArgs {
            // verify required parameter 'search' is not null or undefined
            if (search === null || search === undefined) {
                throw new RequiredError('search','Required parameter search was null or undefined when calling keywords.');
            }
            const localVarPath = `/api/keywords`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        language(options: any = {}): FetchArgs {
            const localVarPath = `/api/language`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated list of page URLs with their keywords
         * @param {string} [pageUrlSearch] 
         * @param {string} [keywordSearch] 
         * @param {string} [brandSafetySearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUrlKeywords(pageUrlSearch?: string, keywordSearch?: string, brandSafetySearch?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/page-url-keywords`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageUrlSearch !== undefined) {
                localVarQueryParameter['pageUrlSearch'] = pageUrlSearch;
            }

            if (keywordSearch !== undefined) {
                localVarQueryParameter['keywordSearch'] = keywordSearch;
            }

            if (brandSafetySearch !== undefined) {
                localVarQueryParameter['brandSafetySearch'] = brandSafetySearch;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionGet(ids: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'ids' is not null or undefined
            if (ids === null || ids === undefined) {
                throw new RequiredError('ids','Required parameter ids was null or undefined when calling regionGet.');
            }
            const localVarPath = `/api/region/get`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pattern 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<number>} [selectedIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionSearch(pattern: string, pageSize: number, pageNumber: number, selectedIds?: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'pattern' is not null or undefined
            if (pattern === null || pattern === undefined) {
                throw new RequiredError('pattern','Required parameter pattern was null or undefined when calling regionSearch.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling regionSearch.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling regionSearch.');
            }
            const localVarPath = `/api/region/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pattern !== undefined) {
                localVarQueryParameter['pattern'] = pattern;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (selectedIds) {
                localVarQueryParameter['selectedIds'] = selectedIds;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} countryIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regions(countryIds: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'countryIds' is not null or undefined
            if (countryIds === null || countryIds === undefined) {
                throw new RequiredError('countryIds','Required parameter countryIds was null or undefined when calling regions.');
            }
            const localVarPath = `/api/region`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (countryIds) {
                localVarQueryParameter['countryIds'] = countryIds;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timezone(options: any = {}): FetchArgs {
            const localVarPath = `/api/timezone`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionariesControllerApi - functional programming interface
 * @export
 */
export const DictionariesControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignDeal(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).campaignDeal(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} [countryIds] 
         * @param {Array<number>} [regionIds] 
         * @param {string} [q] 
         * @param {Array<number>} [cityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cities(countryIds?: Array<number>, regionIds?: Array<number>, q?: string, cityIds?: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CityBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).cities(countryIds, regionIds, q, cityIds, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cityGet(ids: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CityBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).cityGet(ids, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} pattern 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<number>} [selectedIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        citySearch(pattern: string, pageSize: number, pageNumber: number, selectedIds?: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CityBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).citySearch(pattern, pageSize, pageNumber, selectedIds, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<string>} names 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyGet(names: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CompanyBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).companyGet(names, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} pattern 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} [selectedNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySearch(pattern: string, pageSize: number, pageNumber: number, selectedNames?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CompanyBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).companySearch(pattern, pageSize, pageNumber, selectedNames, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CountryBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).countries(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iabCategories(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<IabCategoryBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).iabCategories(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iasBrandSafetyCodes(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<IasBrandSafetyCodeBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).iasBrandSafetyCodes(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get list of keywords
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keywords(search: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).keywords(search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        language(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LanguageBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).language(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get paginated list of page URLs with their keywords
         * @param {string} [pageUrlSearch] 
         * @param {string} [keywordSearch] 
         * @param {string} [brandSafetySearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUrlKeywords(pageUrlSearch?: string, keywordSearch?: string, brandSafetySearch?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponsePageUrlKeywordsBean> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).pageUrlKeywords(pageUrlSearch, keywordSearch, brandSafetySearch, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionGet(ids: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<RegionBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).regionGet(ids, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} pattern 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<number>} [selectedIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionSearch(pattern: string, pageSize: number, pageNumber: number, selectedIds?: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<RegionBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).regionSearch(pattern, pageSize, pageNumber, selectedIds, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} countryIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regions(countryIds: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<RegionBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).regions(countryIds, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timezone(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TimezoneBean>> {
            const localVarFetchArgs = DictionariesControllerApiFetchParamCreator(configuration).timezone(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DictionariesControllerApi - factory interface
 * @export
 */
export const DictionariesControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        campaignDeal(options?: any) {
            return DictionariesControllerApiFp(configuration).campaignDeal(options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} [countryIds] 
         * @param {Array<number>} [regionIds] 
         * @param {string} [q] 
         * @param {Array<number>} [cityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cities(countryIds?: Array<number>, regionIds?: Array<number>, q?: string, cityIds?: Array<number>, options?: any) {
            return DictionariesControllerApiFp(configuration).cities(countryIds, regionIds, q, cityIds, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cityGet(ids: Array<number>, options?: any) {
            return DictionariesControllerApiFp(configuration).cityGet(ids, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} pattern 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<number>} [selectedIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        citySearch(pattern: string, pageSize: number, pageNumber: number, selectedIds?: Array<number>, options?: any) {
            return DictionariesControllerApiFp(configuration).citySearch(pattern, pageSize, pageNumber, selectedIds, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<string>} names 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyGet(names: Array<string>, options?: any) {
            return DictionariesControllerApiFp(configuration).companyGet(names, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} pattern 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} [selectedNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companySearch(pattern: string, pageSize: number, pageNumber: number, selectedNames?: Array<string>, options?: any) {
            return DictionariesControllerApiFp(configuration).companySearch(pattern, pageSize, pageNumber, selectedNames, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countries(options?: any) {
            return DictionariesControllerApiFp(configuration).countries(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iabCategories(options?: any) {
            return DictionariesControllerApiFp(configuration).iabCategories(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iasBrandSafetyCodes(options?: any) {
            return DictionariesControllerApiFp(configuration).iasBrandSafetyCodes(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get list of keywords
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keywords(search: string, options?: any) {
            return DictionariesControllerApiFp(configuration).keywords(search, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        language(options?: any) {
            return DictionariesControllerApiFp(configuration).language(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get paginated list of page URLs with their keywords
         * @param {string} [pageUrlSearch] 
         * @param {string} [keywordSearch] 
         * @param {string} [brandSafetySearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUrlKeywords(pageUrlSearch?: string, keywordSearch?: string, brandSafetySearch?: string, options?: any) {
            return DictionariesControllerApiFp(configuration).pageUrlKeywords(pageUrlSearch, keywordSearch, brandSafetySearch, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionGet(ids: Array<number>, options?: any) {
            return DictionariesControllerApiFp(configuration).regionGet(ids, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} pattern 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<number>} [selectedIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionSearch(pattern: string, pageSize: number, pageNumber: number, selectedIds?: Array<number>, options?: any) {
            return DictionariesControllerApiFp(configuration).regionSearch(pattern, pageSize, pageNumber, selectedIds, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} countryIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regions(countryIds: Array<number>, options?: any) {
            return DictionariesControllerApiFp(configuration).regions(countryIds, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timezone(options?: any) {
            return DictionariesControllerApiFp(configuration).timezone(options)(fetch, basePath);
        },
    };
};

/**
 * DictionariesControllerApi - object-oriented interface
 * @export
 * @class DictionariesControllerApi
 * @extends {BaseAPI}
 */
export class DictionariesControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public campaignDeal(options?: any) {
        return DictionariesControllerApiFp(this.configuration).campaignDeal(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} [countryIds] 
     * @param {Array<number>} [regionIds] 
     * @param {string} [q] 
     * @param {Array<number>} [cityIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public cities(countryIds?: Array<number>, regionIds?: Array<number>, q?: string, cityIds?: Array<number>, options?: any) {
        return DictionariesControllerApiFp(this.configuration).cities(countryIds, regionIds, q, cityIds, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public cityGet(ids: Array<number>, options?: any) {
        return DictionariesControllerApiFp(this.configuration).cityGet(ids, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} pattern 
     * @param {number} pageSize 
     * @param {number} pageNumber 
     * @param {Array<number>} [selectedIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public citySearch(pattern: string, pageSize: number, pageNumber: number, selectedIds?: Array<number>, options?: any) {
        return DictionariesControllerApiFp(this.configuration).citySearch(pattern, pageSize, pageNumber, selectedIds, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} names 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public companyGet(names: Array<string>, options?: any) {
        return DictionariesControllerApiFp(this.configuration).companyGet(names, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} pattern 
     * @param {number} pageSize 
     * @param {number} pageNumber 
     * @param {Array<string>} [selectedNames] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public companySearch(pattern: string, pageSize: number, pageNumber: number, selectedNames?: Array<string>, options?: any) {
        return DictionariesControllerApiFp(this.configuration).companySearch(pattern, pageSize, pageNumber, selectedNames, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public countries(options?: any) {
        return DictionariesControllerApiFp(this.configuration).countries(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public iabCategories(options?: any) {
        return DictionariesControllerApiFp(this.configuration).iabCategories(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public iasBrandSafetyCodes(options?: any) {
        return DictionariesControllerApiFp(this.configuration).iasBrandSafetyCodes(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get list of keywords
     * @param {string} search 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public keywords(search: string, options?: any) {
        return DictionariesControllerApiFp(this.configuration).keywords(search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public language(options?: any) {
        return DictionariesControllerApiFp(this.configuration).language(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get paginated list of page URLs with their keywords
     * @param {string} [pageUrlSearch] 
     * @param {string} [keywordSearch] 
     * @param {string} [brandSafetySearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public pageUrlKeywords(pageUrlSearch?: string, keywordSearch?: string, brandSafetySearch?: string, options?: any) {
        return DictionariesControllerApiFp(this.configuration).pageUrlKeywords(pageUrlSearch, keywordSearch, brandSafetySearch, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public regionGet(ids: Array<number>, options?: any) {
        return DictionariesControllerApiFp(this.configuration).regionGet(ids, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} pattern 
     * @param {number} pageSize 
     * @param {number} pageNumber 
     * @param {Array<number>} [selectedIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public regionSearch(pattern: string, pageSize: number, pageNumber: number, selectedIds?: Array<number>, options?: any) {
        return DictionariesControllerApiFp(this.configuration).regionSearch(pattern, pageSize, pageNumber, selectedIds, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} countryIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public regions(countryIds: Array<number>, options?: any) {
        return DictionariesControllerApiFp(this.configuration).regions(countryIds, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionariesControllerApi
     */
    public timezone(options?: any) {
        return DictionariesControllerApiFp(this.configuration).timezone(options)(this.fetch, this.basePath);
    }

}
/**
 * DspControllerApi - fetch parameter creator
 * @export
 */
export const DspControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDsp(body: DspBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createDsp.');
            }
            const localVarPath = `/api/dsp`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DspBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDsp(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteDsp.');
            }
            const localVarPath = `/api/dsp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dsp(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling dsp.');
            }
            const localVarPath = `/api/dsp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dspList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/dsp`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDsp(body: DspBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editDsp.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editDsp.');
            }
            const localVarPath = `/api/dsp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DspBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDisableDsp(body: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling massDisableDsp.');
            }
            const localVarPath = `/api/dsp/massDisable`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massEnableDsp(body: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling massEnableDsp.');
            }
            const localVarPath = `/api/dsp/massEnable`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dspId 
         * @param {DspIdAdUnitIdBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZoneAdUnitIds(dspId: number, body?: DspIdAdUnitIdBody, options: any = {}): FetchArgs {
            // verify required parameter 'dspId' is not null or undefined
            if (dspId === null || dspId === undefined) {
                throw new RequiredError('dspId','Required parameter dspId was null or undefined when calling updateZoneAdUnitIds.');
            }
            const localVarPath = `/api/dsp/{dspId}/adUnitId`
                .replace(`{${"dspId"}}`, encodeURIComponent(String(dspId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DspIdAdUnitIdBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DspControllerApi - functional programming interface
 * @export
 */
export const DspControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDsp(body: DspBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDspBeanObject> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).createDsp(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDsp(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).deleteDsp(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dsp(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDspBeanObject> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).dsp(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dspList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseDspListItemBean> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).dspList(sortFieldName, sortOrder, searchByName, active, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDsp(body: DspBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseDspBeanObject> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).editDsp(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDisableDsp(body: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).massDisableDsp(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massEnableDsp(body: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).massEnableDsp(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} dspId 
         * @param {DspIdAdUnitIdBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZoneAdUnitIds(dspId: number, body?: DspIdAdUnitIdBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdUnitIdResultBean> {
            const localVarFetchArgs = DspControllerApiFetchParamCreator(configuration).updateZoneAdUnitIds(dspId, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DspControllerApi - factory interface
 * @export
 */
export const DspControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {DspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDsp(body: DspBean, options?: any) {
            return DspControllerApiFp(configuration).createDsp(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDsp(id: number, options?: any) {
            return DspControllerApiFp(configuration).deleteDsp(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dsp(id: number, options?: any) {
            return DspControllerApiFp(configuration).dsp(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dspList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, options?: any) {
            return DspControllerApiFp(configuration).dspList(sortFieldName, sortOrder, searchByName, active, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDsp(body: DspBean, id: number, options?: any) {
            return DspControllerApiFp(configuration).editDsp(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massDisableDsp(body: Array<number>, options?: any) {
            return DspControllerApiFp(configuration).massDisableDsp(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        massEnableDsp(body: Array<number>, options?: any) {
            return DspControllerApiFp(configuration).massEnableDsp(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} dspId 
         * @param {DspIdAdUnitIdBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZoneAdUnitIds(dspId: number, body?: DspIdAdUnitIdBody, options?: any) {
            return DspControllerApiFp(configuration).updateZoneAdUnitIds(dspId, body, options)(fetch, basePath);
        },
    };
};

/**
 * DspControllerApi - object-oriented interface
 * @export
 * @class DspControllerApi
 * @extends {BaseAPI}
 */
export class DspControllerApi extends BaseAPI {
    /**
     * 
     * @param {DspBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public createDsp(body: DspBean, options?: any) {
        return DspControllerApiFp(this.configuration).createDsp(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public deleteDsp(id: number, options?: any) {
        return DspControllerApiFp(this.configuration).deleteDsp(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public dsp(id: number, options?: any) {
        return DspControllerApiFp(this.configuration).dsp(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public dspList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, options?: any) {
        return DspControllerApiFp(this.configuration).dspList(sortFieldName, sortOrder, searchByName, active, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DspBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public editDsp(body: DspBean, id: number, options?: any) {
        return DspControllerApiFp(this.configuration).editDsp(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public massDisableDsp(body: Array<number>, options?: any) {
        return DspControllerApiFp(this.configuration).massDisableDsp(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public massEnableDsp(body: Array<number>, options?: any) {
        return DspControllerApiFp(this.configuration).massEnableDsp(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} dspId 
     * @param {DspIdAdUnitIdBody} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DspControllerApi
     */
    public updateZoneAdUnitIds(dspId: number, body?: DspIdAdUnitIdBody, options?: any) {
        return DspControllerApiFp(this.configuration).updateZoneAdUnitIds(dspId, body, options)(this.fetch, this.basePath);
    }

}
/**
 * FilterListControllerApi - fetch parameter creator
 * @export
 */
export const FilterListControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FilterListBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilterList(body: FilterListBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createFilterList.');
            }
            const localVarPath = `/api/filter-list`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FilterListBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterList(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteFilterList.');
            }
            const localVarPath = `/api/filter-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterListFile(id: number, fileId: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteFilterListFile.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling deleteFilterListFile.');
            }
            const localVarPath = `/api/filter-list/{id}/{fileId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterList(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getFilterList.');
            }
            const localVarPath = `/api/filter-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {string} [type] 
         * @param {number} [advertiserId] 
         * @param {string} [ownedBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageFilterLists(sortFieldName?: string, sortOrder?: string, searchByName?: string, type?: string, advertiserId?: number, ownedBy?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/filter-list`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (ownedBy !== undefined) {
                localVarQueryParameter['ownedBy'] = ownedBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FilterListBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilterList(body: FilterListBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateFilterList.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateFilterList.');
            }
            const localVarPath = `/api/filter-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FilterListBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type 
         * @param {UploadTypeBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFilterListFile(type: string, body?: UploadTypeBody, options: any = {}): FetchArgs {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling uploadFilterListFile.');
            }
            const localVarPath = `/api/filter-list/upload/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UploadTypeBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilterListControllerApi - functional programming interface
 * @export
 */
export const FilterListControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FilterListBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilterList(body: FilterListBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FilterListBean> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).createFilterList(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterList(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).deleteFilterList(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterListFile(id: number, fileId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).deleteFilterListFile(id, fileId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterList(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FilterListBean> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).getFilterList(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {string} [type] 
         * @param {number} [advertiserId] 
         * @param {string} [ownedBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageFilterLists(sortFieldName?: string, sortOrder?: string, searchByName?: string, type?: string, advertiserId?: number, ownedBy?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseFilterListBean> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).getPageFilterLists(sortFieldName, sortOrder, searchByName, type, advertiserId, ownedBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {FilterListBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilterList(body: FilterListBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FilterListBean> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).updateFilterList(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} type 
         * @param {UploadTypeBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFilterListFile(type: string, body?: UploadTypeBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = FilterListControllerApiFetchParamCreator(configuration).uploadFilterListFile(type, body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * FilterListControllerApi - factory interface
 * @export
 */
export const FilterListControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {FilterListBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilterList(body: FilterListBean, options?: any) {
            return FilterListControllerApiFp(configuration).createFilterList(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterList(id: number, options?: any) {
            return FilterListControllerApiFp(configuration).deleteFilterList(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterListFile(id: number, fileId: number, options?: any) {
            return FilterListControllerApiFp(configuration).deleteFilterListFile(id, fileId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterList(id: number, options?: any) {
            return FilterListControllerApiFp(configuration).getFilterList(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {string} [type] 
         * @param {number} [advertiserId] 
         * @param {string} [ownedBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageFilterLists(sortFieldName?: string, sortOrder?: string, searchByName?: string, type?: string, advertiserId?: number, ownedBy?: string, options?: any) {
            return FilterListControllerApiFp(configuration).getPageFilterLists(sortFieldName, sortOrder, searchByName, type, advertiserId, ownedBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {FilterListBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilterList(body: FilterListBean, id: number, options?: any) {
            return FilterListControllerApiFp(configuration).updateFilterList(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} type 
         * @param {UploadTypeBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFilterListFile(type: string, body?: UploadTypeBody, options?: any) {
            return FilterListControllerApiFp(configuration).uploadFilterListFile(type, body, options)(fetch, basePath);
        },
    };
};

/**
 * FilterListControllerApi - object-oriented interface
 * @export
 * @class FilterListControllerApi
 * @extends {BaseAPI}
 */
export class FilterListControllerApi extends BaseAPI {
    /**
     * 
     * @param {FilterListBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public createFilterList(body: FilterListBean, options?: any) {
        return FilterListControllerApiFp(this.configuration).createFilterList(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public deleteFilterList(id: number, options?: any) {
        return FilterListControllerApiFp(this.configuration).deleteFilterList(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public deleteFilterListFile(id: number, fileId: number, options?: any) {
        return FilterListControllerApiFp(this.configuration).deleteFilterListFile(id, fileId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public getFilterList(id: number, options?: any) {
        return FilterListControllerApiFp(this.configuration).getFilterList(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {string} [type] 
     * @param {number} [advertiserId] 
     * @param {string} [ownedBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public getPageFilterLists(sortFieldName?: string, sortOrder?: string, searchByName?: string, type?: string, advertiserId?: number, ownedBy?: string, options?: any) {
        return FilterListControllerApiFp(this.configuration).getPageFilterLists(sortFieldName, sortOrder, searchByName, type, advertiserId, ownedBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {FilterListBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public updateFilterList(body: FilterListBean, id: number, options?: any) {
        return FilterListControllerApiFp(this.configuration).updateFilterList(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} type 
     * @param {UploadTypeBody} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListControllerApi
     */
    public uploadFilterListFile(type: string, body?: UploadTypeBody, options?: any) {
        return FilterListControllerApiFp(this.configuration).uploadFilterListFile(type, body, options)(this.fetch, this.basePath);
    }

}
/**
 * FilterListGlobalControllerApi - fetch parameter creator
 * @export
 */
export const FilterListGlobalControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFilterListGlobalStatus(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling changeFilterListGlobalStatus.');
            }
            const localVarPath = `/api/filter-list-global/{id}/change-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobal(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling filterListGlobal.');
            }
            const localVarPath = `/api/filter-list-global/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FilterListGlobalBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalCreate(body: FilterListGlobalBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling filterListGlobalCreate.');
            }
            const localVarPath = `/api/filter-list-global`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FilterListGlobalBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalDelete(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling filterListGlobalDelete.');
            }
            const localVarPath = `/api/filter-list-global/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {number} [filterListId] 
         * @param {number} [agencyId] 
         * @param {number} [advertiserId] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalPage(sortFieldName?: string, sortOrder?: string, search?: string, filterListId?: number, agencyId?: number, advertiserId?: number, active?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/filter-list-global`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filterListId !== undefined) {
                localVarQueryParameter['filterListId'] = filterListId;
            }

            if (agencyId !== undefined) {
                localVarQueryParameter['agencyId'] = agencyId;
            }

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FilterListGlobalBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalUpdate(body: FilterListGlobalBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling filterListGlobalUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling filterListGlobalUpdate.');
            }
            const localVarPath = `/api/filter-list-global/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FilterListGlobalBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilterListGlobalControllerApi - functional programming interface
 * @export
 */
export const FilterListGlobalControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFilterListGlobalStatus(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = FilterListGlobalControllerApiFetchParamCreator(configuration).changeFilterListGlobalStatus(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobal(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseFilterListGlobalBeanObject> {
            const localVarFetchArgs = FilterListGlobalControllerApiFetchParamCreator(configuration).filterListGlobal(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {FilterListGlobalBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalCreate(body: FilterListGlobalBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseFilterListGlobalBeanObject> {
            const localVarFetchArgs = FilterListGlobalControllerApiFetchParamCreator(configuration).filterListGlobalCreate(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalDelete(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = FilterListGlobalControllerApiFetchParamCreator(configuration).filterListGlobalDelete(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {number} [filterListId] 
         * @param {number} [agencyId] 
         * @param {number} [advertiserId] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalPage(sortFieldName?: string, sortOrder?: string, search?: string, filterListId?: number, agencyId?: number, advertiserId?: number, active?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseFilterListGlobalBean> {
            const localVarFetchArgs = FilterListGlobalControllerApiFetchParamCreator(configuration).filterListGlobalPage(sortFieldName, sortOrder, search, filterListId, agencyId, advertiserId, active, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {FilterListGlobalBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalUpdate(body: FilterListGlobalBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseFilterListGlobalBeanObject> {
            const localVarFetchArgs = FilterListGlobalControllerApiFetchParamCreator(configuration).filterListGlobalUpdate(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * FilterListGlobalControllerApi - factory interface
 * @export
 */
export const FilterListGlobalControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFilterListGlobalStatus(id: number, options?: any) {
            return FilterListGlobalControllerApiFp(configuration).changeFilterListGlobalStatus(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobal(id: number, options?: any) {
            return FilterListGlobalControllerApiFp(configuration).filterListGlobal(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {FilterListGlobalBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalCreate(body: FilterListGlobalBean, options?: any) {
            return FilterListGlobalControllerApiFp(configuration).filterListGlobalCreate(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalDelete(id: number, options?: any) {
            return FilterListGlobalControllerApiFp(configuration).filterListGlobalDelete(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {number} [filterListId] 
         * @param {number} [agencyId] 
         * @param {number} [advertiserId] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalPage(sortFieldName?: string, sortOrder?: string, search?: string, filterListId?: number, agencyId?: number, advertiserId?: number, active?: boolean, options?: any) {
            return FilterListGlobalControllerApiFp(configuration).filterListGlobalPage(sortFieldName, sortOrder, search, filterListId, agencyId, advertiserId, active, options)(fetch, basePath);
        },
        /**
         * 
         * @param {FilterListGlobalBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterListGlobalUpdate(body: FilterListGlobalBean, id: number, options?: any) {
            return FilterListGlobalControllerApiFp(configuration).filterListGlobalUpdate(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * FilterListGlobalControllerApi - object-oriented interface
 * @export
 * @class FilterListGlobalControllerApi
 * @extends {BaseAPI}
 */
export class FilterListGlobalControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListGlobalControllerApi
     */
    public changeFilterListGlobalStatus(id: number, options?: any) {
        return FilterListGlobalControllerApiFp(this.configuration).changeFilterListGlobalStatus(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListGlobalControllerApi
     */
    public filterListGlobal(id: number, options?: any) {
        return FilterListGlobalControllerApiFp(this.configuration).filterListGlobal(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {FilterListGlobalBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListGlobalControllerApi
     */
    public filterListGlobalCreate(body: FilterListGlobalBean, options?: any) {
        return FilterListGlobalControllerApiFp(this.configuration).filterListGlobalCreate(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListGlobalControllerApi
     */
    public filterListGlobalDelete(id: number, options?: any) {
        return FilterListGlobalControllerApiFp(this.configuration).filterListGlobalDelete(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [search] 
     * @param {number} [filterListId] 
     * @param {number} [agencyId] 
     * @param {number} [advertiserId] 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListGlobalControllerApi
     */
    public filterListGlobalPage(sortFieldName?: string, sortOrder?: string, search?: string, filterListId?: number, agencyId?: number, advertiserId?: number, active?: boolean, options?: any) {
        return FilterListGlobalControllerApiFp(this.configuration).filterListGlobalPage(sortFieldName, sortOrder, search, filterListId, agencyId, advertiserId, active, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {FilterListGlobalBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterListGlobalControllerApi
     */
    public filterListGlobalUpdate(body: FilterListGlobalBean, id: number, options?: any) {
        return FilterListGlobalControllerApiFp(this.configuration).filterListGlobalUpdate(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * GlobalPropsControllerApi - fetch parameter creator
 * @export
 */
export const GlobalPropsControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GlobalPropsBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editGlobalProps(body: GlobalPropsBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editGlobalProps.');
            }
            const localVarPath = `/api/global-props`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GlobalPropsBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalProps(options: any = {}): FetchArgs {
            const localVarPath = `/api/global-props`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalPropsControllerApi - functional programming interface
 * @export
 */
export const GlobalPropsControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GlobalPropsBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editGlobalProps(body: GlobalPropsBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseGlobalPropsBeanObject> {
            const localVarFetchArgs = GlobalPropsControllerApiFetchParamCreator(configuration).editGlobalProps(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalProps(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseGlobalPropsBeanObject> {
            const localVarFetchArgs = GlobalPropsControllerApiFetchParamCreator(configuration).globalProps(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * GlobalPropsControllerApi - factory interface
 * @export
 */
export const GlobalPropsControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {GlobalPropsBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editGlobalProps(body: GlobalPropsBean, options?: any) {
            return GlobalPropsControllerApiFp(configuration).editGlobalProps(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalProps(options?: any) {
            return GlobalPropsControllerApiFp(configuration).globalProps(options)(fetch, basePath);
        },
    };
};

/**
 * GlobalPropsControllerApi - object-oriented interface
 * @export
 * @class GlobalPropsControllerApi
 * @extends {BaseAPI}
 */
export class GlobalPropsControllerApi extends BaseAPI {
    /**
     * 
     * @param {GlobalPropsBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalPropsControllerApi
     */
    public editGlobalProps(body: GlobalPropsBean, options?: any) {
        return GlobalPropsControllerApiFp(this.configuration).editGlobalProps(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalPropsControllerApi
     */
    public globalProps(options?: any) {
        return GlobalPropsControllerApiFp(this.configuration).globalProps(options)(this.fetch, this.basePath);
    }

}
/**
 * HeartBeatControllerApi - fetch parameter creator
 * @export
 */
export const HeartBeatControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck(options: any = {}): FetchArgs {
            const localVarPath = `/heartbeat`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeartBeatControllerApi - functional programming interface
 * @export
 */
export const HeartBeatControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = HeartBeatControllerApiFetchParamCreator(configuration).healthCheck(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * HeartBeatControllerApi - factory interface
 * @export
 */
export const HeartBeatControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck(options?: any) {
            return HeartBeatControllerApiFp(configuration).healthCheck(options)(fetch, basePath);
        },
    };
};

/**
 * HeartBeatControllerApi - object-oriented interface
 * @export
 * @class HeartBeatControllerApi
 * @extends {BaseAPI}
 */
export class HeartBeatControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeartBeatControllerApi
     */
    public healthCheck(options?: any) {
        return HeartBeatControllerApiFp(this.configuration).healthCheck(options)(this.fetch, this.basePath);
    }

}
/**
 * InfoControllerApi - fetch parameter creator
 * @export
 */
export const InfoControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyInfo(options: any = {}): FetchArgs {
            const localVarPath = `/api/agency-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfo(options: any = {}): FetchArgs {
            const localVarPath = `/api/build-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoControllerApi - functional programming interface
 * @export
 */
export const InfoControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomizationBean> {
            const localVarFetchArgs = InfoControllerApiFetchParamCreator(configuration).agencyInfo(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BuildInfoBean> {
            const localVarFetchArgs = InfoControllerApiFetchParamCreator(configuration).buildInfo(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * InfoControllerApi - factory interface
 * @export
 */
export const InfoControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyInfo(options?: any) {
            return InfoControllerApiFp(configuration).agencyInfo(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfo(options?: any) {
            return InfoControllerApiFp(configuration).buildInfo(options)(fetch, basePath);
        },
    };
};

/**
 * InfoControllerApi - object-oriented interface
 * @export
 * @class InfoControllerApi
 * @extends {BaseAPI}
 */
export class InfoControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoControllerApi
     */
    public agencyInfo(options?: any) {
        return InfoControllerApiFp(this.configuration).agencyInfo(options)(this.fetch, this.basePath);
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoControllerApi
     */
    public buildInfo(options?: any) {
        return InfoControllerApiFp(this.configuration).buildInfo(options)(this.fetch, this.basePath);
    }

}
/**
 * LogControllerApi - fetch parameter creator
 * @export
 */
export const LogControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogCsv(entityType?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/log/csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {string} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logList(sortFieldName?: string, sortOrder?: string, searchByName?: string, entityType?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/log`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogControllerApi - functional programming interface
 * @export
 */
export const LogControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogCsv(entityType?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: string; }> {
            const localVarFetchArgs = LogControllerApiFetchParamCreator(configuration).getLogCsv(entityType, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {string} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logList(sortFieldName?: string, sortOrder?: string, searchByName?: string, entityType?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseLogBean> {
            const localVarFetchArgs = LogControllerApiFetchParamCreator(configuration).logList(sortFieldName, sortOrder, searchByName, entityType, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * LogControllerApi - factory interface
 * @export
 */
export const LogControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogCsv(entityType?: string, options?: any) {
            return LogControllerApiFp(configuration).getLogCsv(entityType, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {string} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logList(sortFieldName?: string, sortOrder?: string, searchByName?: string, entityType?: string, options?: any) {
            return LogControllerApiFp(configuration).logList(sortFieldName, sortOrder, searchByName, entityType, options)(fetch, basePath);
        },
    };
};

/**
 * LogControllerApi - object-oriented interface
 * @export
 * @class LogControllerApi
 * @extends {BaseAPI}
 */
export class LogControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [entityType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogControllerApi
     */
    public getLogCsv(entityType?: string, options?: any) {
        return LogControllerApiFp(this.configuration).getLogCsv(entityType, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {string} [entityType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogControllerApi
     */
    public logList(sortFieldName?: string, sortOrder?: string, searchByName?: string, entityType?: string, options?: any) {
        return LogControllerApiFp(this.configuration).logList(sortFieldName, sortOrder, searchByName, entityType, options)(this.fetch, this.basePath);
    }

}
/**
 * MandatoryFieldControllerApi - fetch parameter creator
 * @export
 */
export const MandatoryFieldControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryField(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling mandatoryField.');
            }
            const localVarPath = `/api/mandatory-field/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MandatoryFieldBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldCreate(body: MandatoryFieldBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling mandatoryFieldCreate.');
            }
            const localVarPath = `/api/mandatory-field`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MandatoryFieldBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldDelete(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling mandatoryFieldDelete.');
            }
            const localVarPath = `/api/mandatory-field/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MandatoryFieldBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldEdit(body: MandatoryFieldBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling mandatoryFieldEdit.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling mandatoryFieldEdit.');
            }
            const localVarPath = `/api/mandatory-field/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MandatoryFieldBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldToggleRequired(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling mandatoryFieldToggleRequired.');
            }
            const localVarPath = `/api/mandatory-field/{id}/toggle-required`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [required] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFields(sortFieldName?: string, sortOrder?: string, searchByName?: string, required?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/mandatory-field`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (required !== undefined) {
                localVarQueryParameter['required'] = required;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MandatoryFieldControllerApi - functional programming interface
 * @export
 */
export const MandatoryFieldControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryField(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseMandatoryFieldBeanObject> {
            const localVarFetchArgs = MandatoryFieldControllerApiFetchParamCreator(configuration).mandatoryField(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {MandatoryFieldBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldCreate(body: MandatoryFieldBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseMandatoryFieldBeanObject> {
            const localVarFetchArgs = MandatoryFieldControllerApiFetchParamCreator(configuration).mandatoryFieldCreate(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldDelete(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = MandatoryFieldControllerApiFetchParamCreator(configuration).mandatoryFieldDelete(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {MandatoryFieldBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldEdit(body: MandatoryFieldBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseMandatoryFieldBeanObject> {
            const localVarFetchArgs = MandatoryFieldControllerApiFetchParamCreator(configuration).mandatoryFieldEdit(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldToggleRequired(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseMandatoryFieldBeanObject> {
            const localVarFetchArgs = MandatoryFieldControllerApiFetchParamCreator(configuration).mandatoryFieldToggleRequired(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [required] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFields(sortFieldName?: string, sortOrder?: string, searchByName?: string, required?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseMandatoryFieldBean> {
            const localVarFetchArgs = MandatoryFieldControllerApiFetchParamCreator(configuration).mandatoryFields(sortFieldName, sortOrder, searchByName, required, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * MandatoryFieldControllerApi - factory interface
 * @export
 */
export const MandatoryFieldControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryField(id: number, options?: any) {
            return MandatoryFieldControllerApiFp(configuration).mandatoryField(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {MandatoryFieldBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldCreate(body: MandatoryFieldBean, options?: any) {
            return MandatoryFieldControllerApiFp(configuration).mandatoryFieldCreate(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldDelete(id: number, options?: any) {
            return MandatoryFieldControllerApiFp(configuration).mandatoryFieldDelete(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {MandatoryFieldBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldEdit(body: MandatoryFieldBean, id: number, options?: any) {
            return MandatoryFieldControllerApiFp(configuration).mandatoryFieldEdit(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFieldToggleRequired(id: number, options?: any) {
            return MandatoryFieldControllerApiFp(configuration).mandatoryFieldToggleRequired(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [required] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mandatoryFields(sortFieldName?: string, sortOrder?: string, searchByName?: string, required?: boolean, options?: any) {
            return MandatoryFieldControllerApiFp(configuration).mandatoryFields(sortFieldName, sortOrder, searchByName, required, options)(fetch, basePath);
        },
    };
};

/**
 * MandatoryFieldControllerApi - object-oriented interface
 * @export
 * @class MandatoryFieldControllerApi
 * @extends {BaseAPI}
 */
export class MandatoryFieldControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandatoryFieldControllerApi
     */
    public mandatoryField(id: number, options?: any) {
        return MandatoryFieldControllerApiFp(this.configuration).mandatoryField(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {MandatoryFieldBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandatoryFieldControllerApi
     */
    public mandatoryFieldCreate(body: MandatoryFieldBean, options?: any) {
        return MandatoryFieldControllerApiFp(this.configuration).mandatoryFieldCreate(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandatoryFieldControllerApi
     */
    public mandatoryFieldDelete(id: number, options?: any) {
        return MandatoryFieldControllerApiFp(this.configuration).mandatoryFieldDelete(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {MandatoryFieldBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandatoryFieldControllerApi
     */
    public mandatoryFieldEdit(body: MandatoryFieldBean, id: number, options?: any) {
        return MandatoryFieldControllerApiFp(this.configuration).mandatoryFieldEdit(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandatoryFieldControllerApi
     */
    public mandatoryFieldToggleRequired(id: number, options?: any) {
        return MandatoryFieldControllerApiFp(this.configuration).mandatoryFieldToggleRequired(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {boolean} [required] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandatoryFieldControllerApi
     */
    public mandatoryFields(sortFieldName?: string, sortOrder?: string, searchByName?: string, required?: boolean, options?: any) {
        return MandatoryFieldControllerApiFp(this.configuration).mandatoryFields(sortFieldName, sortOrder, searchByName, required, options)(this.fetch, this.basePath);
    }

}
/**
 * NbrStatApi - fetch parameter creator
 * @export
 */
export const NbrStatApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} adGroupId 
         * @param {string} timeKey 
         * @param {number} [sspId] 
         * @param {string} [outerSsp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroupNbr(adGroupId: number, timeKey: string, sspId?: number, outerSsp?: string, options: any = {}): FetchArgs {
            // verify required parameter 'adGroupId' is not null or undefined
            if (adGroupId === null || adGroupId === undefined) {
                throw new RequiredError('adGroupId','Required parameter adGroupId was null or undefined when calling adGroupNbr.');
            }
            // verify required parameter 'timeKey' is not null or undefined
            if (timeKey === null || timeKey === undefined) {
                throw new RequiredError('timeKey','Required parameter timeKey was null or undefined when calling adGroupNbr.');
            }
            const localVarPath = `/api/system/nbr/{adGroupId}/{timeKey}`
                .replace(`{${"adGroupId"}}`, encodeURIComponent(String(adGroupId)))
                .replace(`{${"timeKey"}}`, encodeURIComponent(String(timeKey)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sspId !== undefined) {
                localVarQueryParameter['ssp-id'] = sspId;
            }

            if (outerSsp !== undefined) {
                localVarQueryParameter['outer-ssp'] = outerSsp;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dspId 
         * @param {string} timeKey 
         * @param {number} [sspId] 
         * @param {string} [outerSsp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dspNbr(dspId: number, timeKey: string, sspId?: number, outerSsp?: string, options: any = {}): FetchArgs {
            // verify required parameter 'dspId' is not null or undefined
            if (dspId === null || dspId === undefined) {
                throw new RequiredError('dspId','Required parameter dspId was null or undefined when calling dspNbr.');
            }
            // verify required parameter 'timeKey' is not null or undefined
            if (timeKey === null || timeKey === undefined) {
                throw new RequiredError('timeKey','Required parameter timeKey was null or undefined when calling dspNbr.');
            }
            const localVarPath = `/api/system/dsp-nbr/{dspId}/{timeKey}`
                .replace(`{${"dspId"}}`, encodeURIComponent(String(dspId)))
                .replace(`{${"timeKey"}}`, encodeURIComponent(String(timeKey)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sspId !== undefined) {
                localVarQueryParameter['ssp-id'] = sspId;
            }

            if (outerSsp !== undefined) {
                localVarQueryParameter['outer-ssp'] = outerSsp;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NbrStatApi - functional programming interface
 * @export
 */
export const NbrStatApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} adGroupId 
         * @param {string} timeKey 
         * @param {number} [sspId] 
         * @param {string} [outerSsp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroupNbr(adGroupId: number, timeKey: string, sspId?: number, outerSsp?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: any; }> {
            const localVarFetchArgs = NbrStatApiFetchParamCreator(configuration).adGroupNbr(adGroupId, timeKey, sspId, outerSsp, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} dspId 
         * @param {string} timeKey 
         * @param {number} [sspId] 
         * @param {string} [outerSsp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dspNbr(dspId: number, timeKey: string, sspId?: number, outerSsp?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: any; }> {
            const localVarFetchArgs = NbrStatApiFetchParamCreator(configuration).dspNbr(dspId, timeKey, sspId, outerSsp, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * NbrStatApi - factory interface
 * @export
 */
export const NbrStatApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} adGroupId 
         * @param {string} timeKey 
         * @param {number} [sspId] 
         * @param {string} [outerSsp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adGroupNbr(adGroupId: number, timeKey: string, sspId?: number, outerSsp?: string, options?: any) {
            return NbrStatApiFp(configuration).adGroupNbr(adGroupId, timeKey, sspId, outerSsp, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} dspId 
         * @param {string} timeKey 
         * @param {number} [sspId] 
         * @param {string} [outerSsp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dspNbr(dspId: number, timeKey: string, sspId?: number, outerSsp?: string, options?: any) {
            return NbrStatApiFp(configuration).dspNbr(dspId, timeKey, sspId, outerSsp, options)(fetch, basePath);
        },
    };
};

/**
 * NbrStatApi - object-oriented interface
 * @export
 * @class NbrStatApi
 * @extends {BaseAPI}
 */
export class NbrStatApi extends BaseAPI {
    /**
     * 
     * @param {number} adGroupId 
     * @param {string} timeKey 
     * @param {number} [sspId] 
     * @param {string} [outerSsp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NbrStatApi
     */
    public adGroupNbr(adGroupId: number, timeKey: string, sspId?: number, outerSsp?: string, options?: any) {
        return NbrStatApiFp(this.configuration).adGroupNbr(adGroupId, timeKey, sspId, outerSsp, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} dspId 
     * @param {string} timeKey 
     * @param {number} [sspId] 
     * @param {string} [outerSsp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NbrStatApi
     */
    public dspNbr(dspId: number, timeKey: string, sspId?: number, outerSsp?: string, options?: any) {
        return NbrStatApiFp(this.configuration).dspNbr(dspId, timeKey, sspId, outerSsp, options)(this.fetch, this.basePath);
    }

}
/**
 * PublisherControllerApi - fetch parameter creator
 * @export
 */
export const PublisherControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PublisherBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisher(body: PublisherBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPublisher.');
            }
            const localVarPath = `/api/publisher`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PublisherBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisher(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deletePublisher.');
            }
            const localVarPath = `/api/publisher/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PublisherBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPublisher(body: PublisherBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editPublisher.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editPublisher.');
            }
            const localVarPath = `/api/publisher/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PublisherBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSellersJson(options: any = {}): FetchArgs {
            const localVarPath = `/api/publisher/json`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisher(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling publisher.');
            }
            const localVarPath = `/api/publisher/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/publisher`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherSelectorPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/publisher/sel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublisherControllerApi - functional programming interface
 * @export
 */
export const PublisherControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PublisherBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisher(body: PublisherBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherBeanObject> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).createPublisher(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisher(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).deletePublisher(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {PublisherBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPublisher(body: PublisherBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherBeanObject> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).editPublisher(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSellersJson(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).getSellersJson(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisher(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponsePublisherBeanObject> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).publisher(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponsePublisherListItemBean> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).publisherPage(sortFieldName, sortOrder, searchByName, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherSelectorPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponsePublisherListItemBean> {
            const localVarFetchArgs = PublisherControllerApiFetchParamCreator(configuration).publisherSelectorPage(sortFieldName, sortOrder, searchByName, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PublisherControllerApi - factory interface
 * @export
 */
export const PublisherControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {PublisherBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisher(body: PublisherBean, options?: any) {
            return PublisherControllerApiFp(configuration).createPublisher(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisher(id: number, options?: any) {
            return PublisherControllerApiFp(configuration).deletePublisher(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {PublisherBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPublisher(body: PublisherBean, id: number, options?: any) {
            return PublisherControllerApiFp(configuration).editPublisher(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSellersJson(options?: any) {
            return PublisherControllerApiFp(configuration).getSellersJson(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisher(id: number, options?: any) {
            return PublisherControllerApiFp(configuration).publisher(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
            return PublisherControllerApiFp(configuration).publisherPage(sortFieldName, sortOrder, searchByName, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherSelectorPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
            return PublisherControllerApiFp(configuration).publisherSelectorPage(sortFieldName, sortOrder, searchByName, options)(fetch, basePath);
        },
    };
};

/**
 * PublisherControllerApi - object-oriented interface
 * @export
 * @class PublisherControllerApi
 * @extends {BaseAPI}
 */
export class PublisherControllerApi extends BaseAPI {
    /**
     * 
     * @param {PublisherBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public createPublisher(body: PublisherBean, options?: any) {
        return PublisherControllerApiFp(this.configuration).createPublisher(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public deletePublisher(id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).deletePublisher(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {PublisherBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public editPublisher(body: PublisherBean, id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).editPublisher(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public getSellersJson(options?: any) {
        return PublisherControllerApiFp(this.configuration).getSellersJson(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public publisher(id: number, options?: any) {
        return PublisherControllerApiFp(this.configuration).publisher(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public publisherPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
        return PublisherControllerApiFp(this.configuration).publisherPage(sortFieldName, sortOrder, searchByName, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherControllerApi
     */
    public publisherSelectorPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
        return PublisherControllerApiFp(this.configuration).publisherSelectorPage(sortFieldName, sortOrder, searchByName, options)(this.fetch, this.basePath);
    }

}
/**
 * RegistrationControllerApi - fetch parameter creator
 * @export
 */
export const RegistrationControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailConfirmation(options: any = {}): FetchArgs {
            const localVarPath = `/public-api/test`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} action 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailConfirmation1(action: string, code: string, options: any = {}): FetchArgs {
            // verify required parameter 'action' is not null or undefined
            if (action === null || action === undefined) {
                throw new RequiredError('action','Required parameter action was null or undefined when calling emailConfirmation1.');
            }
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling emailConfirmation1.');
            }
            const localVarPath = `/public-api/email-confirmation/{action}/{code}`
                .replace(`{${"action"}}`, encodeURIComponent(String(action)))
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAdvertiser(body: AccountBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling registerAdvertiser.');
            }
            const localVarPath = `/public-api/register/advertiser`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPassword(body: AccountBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling registerPassword.');
            }
            const localVarPath = `/public-api/register/password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body: AccountBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling resetPassword.');
            }
            const localVarPath = `/public-api/reset-password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationControllerApi - functional programming interface
 * @export
 */
export const RegistrationControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailConfirmation(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = RegistrationControllerApiFetchParamCreator(configuration).emailConfirmation(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} action 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailConfirmation1(action: string, code: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = RegistrationControllerApiFetchParamCreator(configuration).emailConfirmation1(action, code, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAdvertiser(body: AccountBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SignUpResponseBean> {
            const localVarFetchArgs = RegistrationControllerApiFetchParamCreator(configuration).registerAdvertiser(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPassword(body: AccountBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SignUpResponseBean> {
            const localVarFetchArgs = RegistrationControllerApiFetchParamCreator(configuration).registerPassword(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body: AccountBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SignUpResponseBean> {
            const localVarFetchArgs = RegistrationControllerApiFetchParamCreator(configuration).resetPassword(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * RegistrationControllerApi - factory interface
 * @export
 */
export const RegistrationControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailConfirmation(options?: any) {
            return RegistrationControllerApiFp(configuration).emailConfirmation(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} action 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailConfirmation1(action: string, code: string, options?: any) {
            return RegistrationControllerApiFp(configuration).emailConfirmation1(action, code, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAdvertiser(body: AccountBean, options?: any) {
            return RegistrationControllerApiFp(configuration).registerAdvertiser(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPassword(body: AccountBean, options?: any) {
            return RegistrationControllerApiFp(configuration).registerPassword(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body: AccountBean, options?: any) {
            return RegistrationControllerApiFp(configuration).resetPassword(body, options)(fetch, basePath);
        },
    };
};

/**
 * RegistrationControllerApi - object-oriented interface
 * @export
 * @class RegistrationControllerApi
 * @extends {BaseAPI}
 */
export class RegistrationControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public emailConfirmation(options?: any) {
        return RegistrationControllerApiFp(this.configuration).emailConfirmation(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} action 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public emailConfirmation1(action: string, code: string, options?: any) {
        return RegistrationControllerApiFp(this.configuration).emailConfirmation1(action, code, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AccountBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public registerAdvertiser(body: AccountBean, options?: any) {
        return RegistrationControllerApiFp(this.configuration).registerAdvertiser(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AccountBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public registerPassword(body: AccountBean, options?: any) {
        return RegistrationControllerApiFp(this.configuration).registerPassword(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AccountBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public resetPassword(body: AccountBean, options?: any) {
        return RegistrationControllerApiFp(this.configuration).resetPassword(body, options)(this.fetch, this.basePath);
    }

}
/**
 * ReportControllerApi - fetch parameter creator
 * @export
 */
export const ReportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        columns(options: any = {}): FetchArgs {
            const localVarPath = `/api/report/columns`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportEnumBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatTypeEnum(body: ReportEnumBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling formatTypeEnum.');
            }
            const localVarPath = `/api/report/format-type`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReportEnumBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadata(type?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/report/metadata`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiReportBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        report(body: ApiReportBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling report.');
            }
            const localVarPath = `/api/report`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ApiReportBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportCsvBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExportCsv(body: ExportCsvBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling reportExportCsv.');
            }
            const localVarPath = `/api/report/export/csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ExportCsvBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportXlsxBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExportXlsx(body: ExportXlsxBody, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling reportExportXlsx.');
            }
            const localVarPath = `/api/report/export/xlsx`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ExportXlsxBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportControllerApi - functional programming interface
 * @export
 */
export const ReportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        columns(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: string; }> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).columns(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ReportEnumBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatTypeEnum(body: ReportEnumBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReportEnumBean> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).formatTypeEnum(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadata(type?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReportMetadata> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).metadata(type, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ApiReportBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        report(body: ApiReportBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseReportBeanObject> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).report(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ExportCsvBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExportCsv(body: ExportCsvBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).reportExportCsv(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ExportXlsxBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExportXlsx(body: ExportXlsxBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).reportExportXlsx(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ReportControllerApi - factory interface
 * @export
 */
export const ReportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        columns(options?: any) {
            return ReportControllerApiFp(configuration).columns(options)(fetch, basePath);
        },
        /**
         * 
         * @param {ReportEnumBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatTypeEnum(body: ReportEnumBean, options?: any) {
            return ReportControllerApiFp(configuration).formatTypeEnum(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadata(type?: string, options?: any) {
            return ReportControllerApiFp(configuration).metadata(type, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ApiReportBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        report(body: ApiReportBody, options?: any) {
            return ReportControllerApiFp(configuration).report(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ExportCsvBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExportCsv(body: ExportCsvBody, options?: any) {
            return ReportControllerApiFp(configuration).reportExportCsv(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ExportXlsxBody} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExportXlsx(body: ExportXlsxBody, options?: any) {
            return ReportControllerApiFp(configuration).reportExportXlsx(body, options)(fetch, basePath);
        },
    };
};

/**
 * ReportControllerApi - object-oriented interface
 * @export
 * @class ReportControllerApi
 * @extends {BaseAPI}
 */
export class ReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public columns(options?: any) {
        return ReportControllerApiFp(this.configuration).columns(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ReportEnumBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public formatTypeEnum(body: ReportEnumBean, options?: any) {
        return ReportControllerApiFp(this.configuration).formatTypeEnum(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public metadata(type?: string, options?: any) {
        return ReportControllerApiFp(this.configuration).metadata(type, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ApiReportBody} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public report(body: ApiReportBody, options?: any) {
        return ReportControllerApiFp(this.configuration).report(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ExportCsvBody} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public reportExportCsv(body: ExportCsvBody, options?: any) {
        return ReportControllerApiFp(this.configuration).reportExportCsv(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ExportXlsxBody} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public reportExportXlsx(body: ExportXlsxBody, options?: any) {
        return ReportControllerApiFp(this.configuration).reportExportXlsx(body, options)(this.fetch, this.basePath);
    }

}
/**
 * RetargetingListControllerApi - fetch parameter creator
 * @export
 */
export const RetargetingListControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            const localVarPath = `/api/retargeting-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RetargetingListBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: RetargetingListBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling create.');
            }
            const localVarPath = `/api/retargeting-list`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RetargetingListBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOne(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOne.');
            }
            const localVarPath = `/api/retargeting-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {number} [advertiserId] 
         * @param {boolean} [excludeFailed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(sortFieldName?: string, sortOrder?: string, searchByName?: string, advertiserId?: number, excludeFailed?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/retargeting-list`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            if (excludeFailed !== undefined) {
                localVarQueryParameter['excludeFailed'] = excludeFailed;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RetargetingListControllerApi - functional programming interface
 * @export
 */
export const RetargetingListControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = RetargetingListControllerApiFetchParamCreator(configuration)._delete(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {RetargetingListBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: RetargetingListBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseRetargetingListBeanObject> {
            const localVarFetchArgs = RetargetingListControllerApiFetchParamCreator(configuration).create(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOne(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseRetargetingListBeanObject> {
            const localVarFetchArgs = RetargetingListControllerApiFetchParamCreator(configuration).getOne(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {number} [advertiserId] 
         * @param {boolean} [excludeFailed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(sortFieldName?: string, sortOrder?: string, searchByName?: string, advertiserId?: number, excludeFailed?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseRetargetingListBean> {
            const localVarFetchArgs = RetargetingListControllerApiFetchParamCreator(configuration).list(sortFieldName, sortOrder, searchByName, advertiserId, excludeFailed, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * RetargetingListControllerApi - factory interface
 * @export
 */
export const RetargetingListControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: number, options?: any) {
            return RetargetingListControllerApiFp(configuration)._delete(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {RetargetingListBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: RetargetingListBean, options?: any) {
            return RetargetingListControllerApiFp(configuration).create(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOne(id: number, options?: any) {
            return RetargetingListControllerApiFp(configuration).getOne(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {number} [advertiserId] 
         * @param {boolean} [excludeFailed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(sortFieldName?: string, sortOrder?: string, searchByName?: string, advertiserId?: number, excludeFailed?: boolean, options?: any) {
            return RetargetingListControllerApiFp(configuration).list(sortFieldName, sortOrder, searchByName, advertiserId, excludeFailed, options)(fetch, basePath);
        },
    };
};

/**
 * RetargetingListControllerApi - object-oriented interface
 * @export
 * @class RetargetingListControllerApi
 * @extends {BaseAPI}
 */
export class RetargetingListControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetargetingListControllerApi
     */
    public _delete(id: number, options?: any) {
        return RetargetingListControllerApiFp(this.configuration)._delete(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {RetargetingListBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetargetingListControllerApi
     */
    public create(body: RetargetingListBean, options?: any) {
        return RetargetingListControllerApiFp(this.configuration).create(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetargetingListControllerApi
     */
    public getOne(id: number, options?: any) {
        return RetargetingListControllerApiFp(this.configuration).getOne(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {number} [advertiserId] 
     * @param {boolean} [excludeFailed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RetargetingListControllerApi
     */
    public list(sortFieldName?: string, sortOrder?: string, searchByName?: string, advertiserId?: number, excludeFailed?: boolean, options?: any) {
        return RetargetingListControllerApiFp(this.configuration).list(sortFieldName, sortOrder, searchByName, advertiserId, excludeFailed, options)(this.fetch, this.basePath);
    }

}
/**
 * SavedReportControllerApi - fetch parameter creator
 * @export
 */
export const SavedReportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SavedReportBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSavedReport(body: SavedReportBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createSavedReport.');
            }
            const localVarPath = `/api/saved-report`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SavedReportBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSavedReport(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteSavedReport.');
            }
            const localVarPath = `/api/saved-report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SavedReportBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSavedReport(body: SavedReportBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editSavedReport.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editSavedReport.');
            }
            const localVarPath = `/api/saved-report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SavedReportBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedReport(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSavedReport.');
            }
            const localVarPath = `/api/saved-report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reportType 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savedReportList(reportType: string, sortFieldName?: string, sortOrder?: string, searchByName?: string, options: any = {}): FetchArgs {
            // verify required parameter 'reportType' is not null or undefined
            if (reportType === null || reportType === undefined) {
                throw new RequiredError('reportType','Required parameter reportType was null or undefined when calling savedReportList.');
            }
            const localVarPath = `/api/saved-report`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (reportType !== undefined) {
                localVarQueryParameter['reportType'] = reportType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SavedReportControllerApi - functional programming interface
 * @export
 */
export const SavedReportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SavedReportBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSavedReport(body: SavedReportBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSavedReportBeanObject> {
            const localVarFetchArgs = SavedReportControllerApiFetchParamCreator(configuration).createSavedReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSavedReport(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SavedReportControllerApiFetchParamCreator(configuration).deleteSavedReport(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SavedReportBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSavedReport(body: SavedReportBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSavedReportBeanObject> {
            const localVarFetchArgs = SavedReportControllerApiFetchParamCreator(configuration).editSavedReport(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedReport(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSavedReportBeanObject> {
            const localVarFetchArgs = SavedReportControllerApiFetchParamCreator(configuration).getSavedReport(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} reportType 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savedReportList(reportType: string, sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSavedReportListItemBean> {
            const localVarFetchArgs = SavedReportControllerApiFetchParamCreator(configuration).savedReportList(reportType, sortFieldName, sortOrder, searchByName, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SavedReportControllerApi - factory interface
 * @export
 */
export const SavedReportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {SavedReportBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSavedReport(body: SavedReportBean, options?: any) {
            return SavedReportControllerApiFp(configuration).createSavedReport(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSavedReport(id: number, options?: any) {
            return SavedReportControllerApiFp(configuration).deleteSavedReport(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {SavedReportBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSavedReport(body: SavedReportBean, id: number, options?: any) {
            return SavedReportControllerApiFp(configuration).editSavedReport(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedReport(id: number, options?: any) {
            return SavedReportControllerApiFp(configuration).getSavedReport(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} reportType 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savedReportList(reportType: string, sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
            return SavedReportControllerApiFp(configuration).savedReportList(reportType, sortFieldName, sortOrder, searchByName, options)(fetch, basePath);
        },
    };
};

/**
 * SavedReportControllerApi - object-oriented interface
 * @export
 * @class SavedReportControllerApi
 * @extends {BaseAPI}
 */
export class SavedReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {SavedReportBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedReportControllerApi
     */
    public createSavedReport(body: SavedReportBean, options?: any) {
        return SavedReportControllerApiFp(this.configuration).createSavedReport(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedReportControllerApi
     */
    public deleteSavedReport(id: number, options?: any) {
        return SavedReportControllerApiFp(this.configuration).deleteSavedReport(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SavedReportBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedReportControllerApi
     */
    public editSavedReport(body: SavedReportBean, id: number, options?: any) {
        return SavedReportControllerApiFp(this.configuration).editSavedReport(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedReportControllerApi
     */
    public getSavedReport(id: number, options?: any) {
        return SavedReportControllerApiFp(this.configuration).getSavedReport(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} reportType 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedReportControllerApi
     */
    public savedReportList(reportType: string, sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
        return SavedReportControllerApiFp(this.configuration).savedReportList(reportType, sortFieldName, sortOrder, searchByName, options)(this.fetch, this.basePath);
    }

}
/**
 * SettingControllerApi - fetch parameter creator
 * @export
 */
export const SettingControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SettingBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingEdit(body: SettingBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling settingEdit.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling settingEdit.');
            }
            const localVarPath = `/api/setting/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SettingBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingList(options: any = {}): FetchArgs {
            const localVarPath = `/api/setting-list`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settings(sortFieldName?: string, sortOrder?: string, searchByName?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/setting`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingControllerApi - functional programming interface
 * @export
 */
export const SettingControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SettingBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingEdit(body: SettingBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSettingBeanObject> {
            const localVarFetchArgs = SettingControllerApiFetchParamCreator(configuration).settingEdit(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingList(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSettingBean> {
            const localVarFetchArgs = SettingControllerApiFetchParamCreator(configuration).settingList(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settings(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSettingBean> {
            const localVarFetchArgs = SettingControllerApiFetchParamCreator(configuration).settings(sortFieldName, sortOrder, searchByName, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SettingControllerApi - factory interface
 * @export
 */
export const SettingControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {SettingBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingEdit(body: SettingBean, id: number, options?: any) {
            return SettingControllerApiFp(configuration).settingEdit(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingList(options?: any) {
            return SettingControllerApiFp(configuration).settingList(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settings(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
            return SettingControllerApiFp(configuration).settings(sortFieldName, sortOrder, searchByName, options)(fetch, basePath);
        },
    };
};

/**
 * SettingControllerApi - object-oriented interface
 * @export
 * @class SettingControllerApi
 * @extends {BaseAPI}
 */
export class SettingControllerApi extends BaseAPI {
    /**
     * 
     * @param {SettingBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingControllerApi
     */
    public settingEdit(body: SettingBean, id: number, options?: any) {
        return SettingControllerApiFp(this.configuration).settingEdit(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingControllerApi
     */
    public settingList(options?: any) {
        return SettingControllerApiFp(this.configuration).settingList(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingControllerApi
     */
    public settings(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
        return SettingControllerApiFp(this.configuration).settings(sortFieldName, sortOrder, searchByName, options)(this.fetch, this.basePath);
    }

}
/**
 * SiteControllerApi - fetch parameter creator
 * @export
 */
export const SiteControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SiteBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite(body: SiteBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createSite.');
            }
            const localVarPath = `/api/site`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SiteBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SiteBulkBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteBulk(body?: SiteBulkBody, options: any = {}): FetchArgs {
            const localVarPath = `/api/site/bulk`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SiteBulkBody" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSite(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteSite.');
            }
            const localVarPath = `/api/site/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SiteBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSite(body: SiteBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editSite.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editSite.');
            }
            const localVarPath = `/api/site/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SiteBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteCsv(options: any = {}): FetchArgs {
            const localVarPath = `/api/site/csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} active 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActive(id: number, active: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setActive.');
            }
            // verify required parameter 'active' is not null or undefined
            if (active === null || active === undefined) {
                throw new RequiredError('active','Required parameter active was null or undefined when calling setActive.');
            }
            const localVarPath = `/api/site/active/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        site(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling site.');
            }
            const localVarPath = `/api/site/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, publisherId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/site`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (publisherId !== undefined) {
                localVarQueryParameter['publisherId'] = publisherId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteListByPublisherId(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling siteListByPublisherId.');
            }
            const localVarPath = `/api/publisher/{id}/site`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SiteControllerApi - functional programming interface
 * @export
 */
export const SiteControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SiteBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite(body: SiteBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSiteBeanObject> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).createSite(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SiteBulkBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteBulk(body?: SiteBulkBody, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BulkResultBean> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).createSiteBulk(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSite(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).deleteSite(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SiteBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSite(body: SiteBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSiteBeanObject> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).editSite(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteCsv(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).getSiteCsv(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} active 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActive(id: number, active: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSiteBeanObject> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).setActive(id, active, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        site(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSiteBeanObject> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).site(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, publisherId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSiteBean> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).siteList(sortFieldName, sortOrder, searchByName, active, publisherId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteListByPublisherId(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSiteBean> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).siteListByPublisherId(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SiteControllerApi - factory interface
 * @export
 */
export const SiteControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {SiteBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite(body: SiteBean, options?: any) {
            return SiteControllerApiFp(configuration).createSite(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {SiteBulkBody} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteBulk(body?: SiteBulkBody, options?: any) {
            return SiteControllerApiFp(configuration).createSiteBulk(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSite(id: number, options?: any) {
            return SiteControllerApiFp(configuration).deleteSite(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {SiteBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSite(body: SiteBean, id: number, options?: any) {
            return SiteControllerApiFp(configuration).editSite(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteCsv(options?: any) {
            return SiteControllerApiFp(configuration).getSiteCsv(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} active 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActive(id: number, active: boolean, options?: any) {
            return SiteControllerApiFp(configuration).setActive(id, active, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        site(id: number, options?: any) {
            return SiteControllerApiFp(configuration).site(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, publisherId?: number, options?: any) {
            return SiteControllerApiFp(configuration).siteList(sortFieldName, sortOrder, searchByName, active, publisherId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteListByPublisherId(id: number, options?: any) {
            return SiteControllerApiFp(configuration).siteListByPublisherId(id, options)(fetch, basePath);
        },
    };
};

/**
 * SiteControllerApi - object-oriented interface
 * @export
 * @class SiteControllerApi
 * @extends {BaseAPI}
 */
export class SiteControllerApi extends BaseAPI {
    /**
     * 
     * @param {SiteBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public createSite(body: SiteBean, options?: any) {
        return SiteControllerApiFp(this.configuration).createSite(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SiteBulkBody} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public createSiteBulk(body?: SiteBulkBody, options?: any) {
        return SiteControllerApiFp(this.configuration).createSiteBulk(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public deleteSite(id: number, options?: any) {
        return SiteControllerApiFp(this.configuration).deleteSite(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SiteBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public editSite(body: SiteBean, id: number, options?: any) {
        return SiteControllerApiFp(this.configuration).editSite(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public getSiteCsv(options?: any) {
        return SiteControllerApiFp(this.configuration).getSiteCsv(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} active 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public setActive(id: number, active: boolean, options?: any) {
        return SiteControllerApiFp(this.configuration).setActive(id, active, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public site(id: number, options?: any) {
        return SiteControllerApiFp(this.configuration).site(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {boolean} [active] 
     * @param {number} [publisherId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public siteList(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, publisherId?: number, options?: any) {
        return SiteControllerApiFp(this.configuration).siteList(sortFieldName, sortOrder, searchByName, active, publisherId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public siteListByPublisherId(id: number, options?: any) {
        return SiteControllerApiFp(this.configuration).siteListByPublisherId(id, options)(this.fetch, this.basePath);
    }

}
/**
 * SspControllerApi - fetch parameter creator
 * @export
 */
export const SspControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSspStatus(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling changeSspStatus.');
            }
            const localVarPath = `/api/ssp/{id}/change-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSsp(body: SspBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createSsp.');
            }
            const localVarPath = `/api/ssp`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SspBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSsp(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteSsp.');
            }
            const localVarPath = `/api/ssp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSsp(body: SspBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editSsp.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editSsp.');
            }
            const localVarPath = `/api/ssp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SspBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSspToken(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling generateSspToken.');
            }
            const localVarPath = `/api/ssp/{id}/token`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssp(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling ssp.');
            }
            const localVarPath = `/api/ssp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspList(options: any = {}): FetchArgs {
            const localVarPath = `/api/ssp/list`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {string} [sspType] 
         * @param {number} [agencyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, sspType?: string, agencyId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/ssp`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (sspType !== undefined) {
                localVarQueryParameter['sspType'] = sspType;
            }

            if (agencyId !== undefined) {
                localVarQueryParameter['agencyId'] = agencyId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspSelector(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sspSelector.');
            }
            const localVarPath = `/api/ssp/sel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspSelectorPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/ssp/sel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (searchByName !== undefined) {
                localVarQueryParameter['searchByName'] = searchByName;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SspControllerApi - functional programming interface
 * @export
 */
export const SspControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSspStatus(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSspBeanObject> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).changeSspStatus(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSsp(body: SspBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSspBeanObject> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).createSsp(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSsp(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).deleteSsp(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSsp(body: SspBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSspBeanObject> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).editSsp(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSspToken(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).generateSspToken(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssp(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSspBeanObject> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).ssp(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspList(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSspInfoBean> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).sspList(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {string} [sspType] 
         * @param {number} [agencyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, sspType?: string, agencyId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSspListItemBean> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).sspPage(sortFieldName, sortOrder, searchByName, active, sspType, agencyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspSelector(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSspBeanObject> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).sspSelector(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspSelectorPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSspListItemBean> {
            const localVarFetchArgs = SspControllerApiFetchParamCreator(configuration).sspSelectorPage(sortFieldName, sortOrder, searchByName, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SspControllerApi - factory interface
 * @export
 */
export const SspControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSspStatus(id: number, options?: any) {
            return SspControllerApiFp(configuration).changeSspStatus(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {SspBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSsp(body: SspBean, options?: any) {
            return SspControllerApiFp(configuration).createSsp(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSsp(id: number, options?: any) {
            return SspControllerApiFp(configuration).deleteSsp(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {SspBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSsp(body: SspBean, id: number, options?: any) {
            return SspControllerApiFp(configuration).editSsp(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSspToken(id: number, options?: any) {
            return SspControllerApiFp(configuration).generateSspToken(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssp(id: number, options?: any) {
            return SspControllerApiFp(configuration).ssp(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspList(options?: any) {
            return SspControllerApiFp(configuration).sspList(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {boolean} [active] 
         * @param {string} [sspType] 
         * @param {number} [agencyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, sspType?: string, agencyId?: number, options?: any) {
            return SspControllerApiFp(configuration).sspPage(sortFieldName, sortOrder, searchByName, active, sspType, agencyId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspSelector(id: number, options?: any) {
            return SspControllerApiFp(configuration).sspSelector(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [searchByName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sspSelectorPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
            return SspControllerApiFp(configuration).sspSelectorPage(sortFieldName, sortOrder, searchByName, options)(fetch, basePath);
        },
    };
};

/**
 * SspControllerApi - object-oriented interface
 * @export
 * @class SspControllerApi
 * @extends {BaseAPI}
 */
export class SspControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public changeSspStatus(id: number, options?: any) {
        return SspControllerApiFp(this.configuration).changeSspStatus(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SspBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public createSsp(body: SspBean, options?: any) {
        return SspControllerApiFp(this.configuration).createSsp(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public deleteSsp(id: number, options?: any) {
        return SspControllerApiFp(this.configuration).deleteSsp(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SspBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public editSsp(body: SspBean, id: number, options?: any) {
        return SspControllerApiFp(this.configuration).editSsp(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public generateSspToken(id: number, options?: any) {
        return SspControllerApiFp(this.configuration).generateSspToken(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public ssp(id: number, options?: any) {
        return SspControllerApiFp(this.configuration).ssp(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public sspList(options?: any) {
        return SspControllerApiFp(this.configuration).sspList(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {boolean} [active] 
     * @param {string} [sspType] 
     * @param {number} [agencyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public sspPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, active?: boolean, sspType?: string, agencyId?: number, options?: any) {
        return SspControllerApiFp(this.configuration).sspPage(sortFieldName, sortOrder, searchByName, active, sspType, agencyId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public sspSelector(id: number, options?: any) {
        return SspControllerApiFp(this.configuration).sspSelector(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [searchByName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspControllerApi
     */
    public sspSelectorPage(sortFieldName?: string, sortOrder?: string, searchByName?: string, options?: any) {
        return SspControllerApiFp(this.configuration).sspSelectorPage(sortFieldName, sortOrder, searchByName, options)(this.fetch, this.basePath);
    }

}
/**
 * SspStatControllerApi - fetch parameter creator
 * @export
 */
export const SspStatControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} token 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readStat(token: string, startDate: string, endDate: string, options: any = {}): FetchArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling readStat.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new RequiredError('startDate','Required parameter startDate was null or undefined when calling readStat.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new RequiredError('endDate','Required parameter endDate was null or undefined when calling readStat.');
            }
            const localVarPath = `/stats/{token}/{startDate}/{endDate}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)))
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SspStatControllerApi - functional programming interface
 * @export
 */
export const SspStatControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} token 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readStat(token: string, startDate: string, endDate: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SspReportBean> {
            const localVarFetchArgs = SspStatControllerApiFetchParamCreator(configuration).readStat(token, startDate, endDate, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SspStatControllerApi - factory interface
 * @export
 */
export const SspStatControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} token 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readStat(token: string, startDate: string, endDate: string, options?: any) {
            return SspStatControllerApiFp(configuration).readStat(token, startDate, endDate, options)(fetch, basePath);
        },
    };
};

/**
 * SspStatControllerApi - object-oriented interface
 * @export
 * @class SspStatControllerApi
 * @extends {BaseAPI}
 */
export class SspStatControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} token 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SspStatControllerApi
     */
    public readStat(token: string, startDate: string, endDate: string, options?: any) {
        return SspStatControllerApiFp(this.configuration).readStat(token, startDate, endDate, options)(this.fetch, this.basePath);
    }

}
/**
 * StripeConnectControllerApi - fetch parameter creator
 * @export
 */
export const StripeConnectControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorize(options: any = {}): FetchArgs {
            const localVarPath = `/api/stripe-connect/authorize`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnect(options: any = {}): FetchArgs {
            const localVarPath = `/api/stripe-connect`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status(options: any = {}): FetchArgs {
            const localVarPath = `/api/stripe-connect/status`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeConnectControllerApi - functional programming interface
 * @export
 */
export const StripeConnectControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorize(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStringObject> {
            const localVarFetchArgs = StripeConnectControllerApiFetchParamCreator(configuration).authorize(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnect(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = StripeConnectControllerApiFetchParamCreator(configuration).disconnect(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseStripeConnectStatusBeanObject> {
            const localVarFetchArgs = StripeConnectControllerApiFetchParamCreator(configuration).status(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * StripeConnectControllerApi - factory interface
 * @export
 */
export const StripeConnectControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorize(options?: any) {
            return StripeConnectControllerApiFp(configuration).authorize(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnect(options?: any) {
            return StripeConnectControllerApiFp(configuration).disconnect(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status(options?: any) {
            return StripeConnectControllerApiFp(configuration).status(options)(fetch, basePath);
        },
    };
};

/**
 * StripeConnectControllerApi - object-oriented interface
 * @export
 * @class StripeConnectControllerApi
 * @extends {BaseAPI}
 */
export class StripeConnectControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectControllerApi
     */
    public authorize(options?: any) {
        return StripeConnectControllerApiFp(this.configuration).authorize(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectControllerApi
     */
    public disconnect(options?: any) {
        return StripeConnectControllerApiFp(this.configuration).disconnect(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectControllerApi
     */
    public status(options?: any) {
        return StripeConnectControllerApiFp(this.configuration).status(options)(this.fetch, this.basePath);
    }

}
/**
 * StripeConnectOAuthControllerApi - fetch parameter creator
 * @export
 */
export const StripeConnectOAuthControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} state 
         * @param {string} [code] 
         * @param {string} [error] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback(state: string, code?: string, error?: string, options: any = {}): FetchArgs {
            // verify required parameter 'state' is not null or undefined
            if (state === null || state === undefined) {
                throw new RequiredError('state','Required parameter state was null or undefined when calling callback.');
            }
            const localVarPath = `/public-api/money/stripe/connect/oauth/callback`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeConnectOAuthControllerApi - functional programming interface
 * @export
 */
export const StripeConnectOAuthControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} state 
         * @param {string} [code] 
         * @param {string} [error] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback(state: string, code?: string, error?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = StripeConnectOAuthControllerApiFetchParamCreator(configuration).callback(state, code, error, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * StripeConnectOAuthControllerApi - factory interface
 * @export
 */
export const StripeConnectOAuthControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} state 
         * @param {string} [code] 
         * @param {string} [error] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback(state: string, code?: string, error?: string, options?: any) {
            return StripeConnectOAuthControllerApiFp(configuration).callback(state, code, error, options)(fetch, basePath);
        },
    };
};

/**
 * StripeConnectOAuthControllerApi - object-oriented interface
 * @export
 * @class StripeConnectOAuthControllerApi
 * @extends {BaseAPI}
 */
export class StripeConnectOAuthControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} state 
     * @param {string} [code] 
     * @param {string} [error] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeConnectOAuthControllerApi
     */
    public callback(state: string, code?: string, error?: string, options?: any) {
        return StripeConnectOAuthControllerApiFp(this.configuration).callback(state, code, error, options)(this.fetch, this.basePath);
    }

}
/**
 * StripeControllerApi - fetch parameter creator
 * @export
 */
export const StripeControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} body 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onConnectedAccountPayment(body: string, stripeSignature: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling onConnectedAccountPayment.');
            }
            // verify required parameter 'stripeSignature' is not null or undefined
            if (stripeSignature === null || stripeSignature === undefined) {
                throw new RequiredError('stripeSignature','Required parameter stripeSignature was null or undefined when calling onConnectedAccountPayment.');
            }
            const localVarPath = `/public-api/money/pay/connected/finish`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stripeSignature !== undefined && stripeSignature !== null) {
                localVarHeaderParameter['Stripe-Signature'] = String(stripeSignature);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onConnectedPaymentStartCancel(sessionId: string, options: any = {}): FetchArgs {
            // verify required parameter 'sessionId' is not null or undefined
            if (sessionId === null || sessionId === undefined) {
                throw new RequiredError('sessionId','Required parameter sessionId was null or undefined when calling onConnectedPaymentStartCancel.');
            }
            const localVarPath = `/public-api/money/pay/connected/cancel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onConnectedPaymentStartSuccess(sessionId: string, options: any = {}): FetchArgs {
            // verify required parameter 'sessionId' is not null or undefined
            if (sessionId === null || sessionId === undefined) {
                throw new RequiredError('sessionId','Required parameter sessionId was null or undefined when calling onConnectedPaymentStartSuccess.');
            }
            const localVarPath = `/public-api/money/pay/connected/success`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onPaymentStartFail(sessionId: string, options: any = {}): FetchArgs {
            // verify required parameter 'sessionId' is not null or undefined
            if (sessionId === null || sessionId === undefined) {
                throw new RequiredError('sessionId','Required parameter sessionId was null or undefined when calling onPaymentStartFail.');
            }
            const localVarPath = `/public-api/money/pay/cancel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onPaymentStartSuccess(sessionId: string, options: any = {}): FetchArgs {
            // verify required parameter 'sessionId' is not null or undefined
            if (sessionId === null || sessionId === undefined) {
                throw new RequiredError('sessionId','Required parameter sessionId was null or undefined when calling onPaymentStartSuccess.');
            }
            const localVarPath = `/public-api/money/pay/success`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onSuccessFinishPayment(body: string, stripeSignature: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling onSuccessFinishPayment.');
            }
            // verify required parameter 'stripeSignature' is not null or undefined
            if (stripeSignature === null || stripeSignature === undefined) {
                throw new RequiredError('stripeSignature','Required parameter stripeSignature was null or undefined when calling onSuccessFinishPayment.');
            }
            const localVarPath = `/public-api/money/pay/finish`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stripeSignature !== undefined && stripeSignature !== null) {
                localVarHeaderParameter['Stripe-Signature'] = String(stripeSignature);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeControllerApi - functional programming interface
 * @export
 */
export const StripeControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} body 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onConnectedAccountPayment(body: string, stripeSignature: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = StripeControllerApiFetchParamCreator(configuration).onConnectedAccountPayment(body, stripeSignature, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onConnectedPaymentStartCancel(sessionId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = StripeControllerApiFetchParamCreator(configuration).onConnectedPaymentStartCancel(sessionId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onConnectedPaymentStartSuccess(sessionId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = StripeControllerApiFetchParamCreator(configuration).onConnectedPaymentStartSuccess(sessionId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onPaymentStartFail(sessionId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = StripeControllerApiFetchParamCreator(configuration).onPaymentStartFail(sessionId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onPaymentStartSuccess(sessionId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = StripeControllerApiFetchParamCreator(configuration).onPaymentStartSuccess(sessionId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onSuccessFinishPayment(body: string, stripeSignature: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = StripeControllerApiFetchParamCreator(configuration).onSuccessFinishPayment(body, stripeSignature, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * StripeControllerApi - factory interface
 * @export
 */
export const StripeControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} body 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onConnectedAccountPayment(body: string, stripeSignature: string, options?: any) {
            return StripeControllerApiFp(configuration).onConnectedAccountPayment(body, stripeSignature, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onConnectedPaymentStartCancel(sessionId: string, options?: any) {
            return StripeControllerApiFp(configuration).onConnectedPaymentStartCancel(sessionId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onConnectedPaymentStartSuccess(sessionId: string, options?: any) {
            return StripeControllerApiFp(configuration).onConnectedPaymentStartSuccess(sessionId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onPaymentStartFail(sessionId: string, options?: any) {
            return StripeControllerApiFp(configuration).onPaymentStartFail(sessionId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onPaymentStartSuccess(sessionId: string, options?: any) {
            return StripeControllerApiFp(configuration).onPaymentStartSuccess(sessionId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} body 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onSuccessFinishPayment(body: string, stripeSignature: string, options?: any) {
            return StripeControllerApiFp(configuration).onSuccessFinishPayment(body, stripeSignature, options)(fetch, basePath);
        },
    };
};

/**
 * StripeControllerApi - object-oriented interface
 * @export
 * @class StripeControllerApi
 * @extends {BaseAPI}
 */
export class StripeControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} body 
     * @param {string} stripeSignature 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApi
     */
    public onConnectedAccountPayment(body: string, stripeSignature: string, options?: any) {
        return StripeControllerApiFp(this.configuration).onConnectedAccountPayment(body, stripeSignature, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApi
     */
    public onConnectedPaymentStartCancel(sessionId: string, options?: any) {
        return StripeControllerApiFp(this.configuration).onConnectedPaymentStartCancel(sessionId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApi
     */
    public onConnectedPaymentStartSuccess(sessionId: string, options?: any) {
        return StripeControllerApiFp(this.configuration).onConnectedPaymentStartSuccess(sessionId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApi
     */
    public onPaymentStartFail(sessionId: string, options?: any) {
        return StripeControllerApiFp(this.configuration).onPaymentStartFail(sessionId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApi
     */
    public onPaymentStartSuccess(sessionId: string, options?: any) {
        return StripeControllerApiFp(this.configuration).onPaymentStartSuccess(sessionId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} body 
     * @param {string} stripeSignature 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeControllerApi
     */
    public onSuccessFinishPayment(body: string, stripeSignature: string, options?: any) {
        return StripeControllerApiFp(this.configuration).onSuccessFinishPayment(body, stripeSignature, options)(this.fetch, this.basePath);
    }

}
/**
 * TokenLoginControllerApi - fetch parameter creator
 * @export
 */
export const TokenLoginControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithToken(options: any = {}): FetchArgs {
            const localVarPath = `/api/token-login`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenLoginControllerApi - functional programming interface
 * @export
 */
export const TokenLoginControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithToken(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = TokenLoginControllerApiFetchParamCreator(configuration).loginWithToken(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TokenLoginControllerApi - factory interface
 * @export
 */
export const TokenLoginControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithToken(options?: any) {
            return TokenLoginControllerApiFp(configuration).loginWithToken(options)(fetch, basePath);
        },
    };
};

/**
 * TokenLoginControllerApi - object-oriented interface
 * @export
 * @class TokenLoginControllerApi
 * @extends {BaseAPI}
 */
export class TokenLoginControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenLoginControllerApi
     */
    public loginWithToken(options?: any) {
        return TokenLoginControllerApiFp(this.configuration).loginWithToken(options)(this.fetch, this.basePath);
    }

}
/**
 * TrackerControllerApi - fetch parameter creator
 * @export
 */
export const TrackerControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TrackerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTracker(body: TrackerBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createTracker.');
            }
            const localVarPath = `/api/tracker`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TrackerBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTracker(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteTracker.');
            }
            const localVarPath = `/api/tracker/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Trackers
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerList(sortFieldName?: string, sortOrder?: string, search?: string, advertiserId?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/tracker`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (advertiserId !== undefined) {
                localVarQueryParameter['advertiserId'] = advertiserId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrackerBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTracker(body: TrackerBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateTracker.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateTracker.');
            }
            const localVarPath = `/api/tracker/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TrackerBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrackerPriceFlagsBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackerPriceFlags(body: TrackerPriceFlagsBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateTrackerPriceFlags.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateTrackerPriceFlags.');
            }
            const localVarPath = `/api/tracker/{id}/price-flags`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TrackerPriceFlagsBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTracker(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling viewTracker.');
            }
            const localVarPath = `/api/tracker/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackerControllerApi - functional programming interface
 * @export
 */
export const TrackerControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TrackerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTracker(body: TrackerBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseTrackerBeanObject> {
            const localVarFetchArgs = TrackerControllerApiFetchParamCreator(configuration).createTracker(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTracker(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = TrackerControllerApiFetchParamCreator(configuration).deleteTracker(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all Trackers
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerList(sortFieldName?: string, sortOrder?: string, search?: string, advertiserId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseTrackerBean> {
            const localVarFetchArgs = TrackerControllerApiFetchParamCreator(configuration).trackerList(sortFieldName, sortOrder, search, advertiserId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {TrackerBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTracker(body: TrackerBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseTrackerBeanObject> {
            const localVarFetchArgs = TrackerControllerApiFetchParamCreator(configuration).updateTracker(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {TrackerPriceFlagsBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackerPriceFlags(body: TrackerPriceFlagsBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseTrackerBeanObject> {
            const localVarFetchArgs = TrackerControllerApiFetchParamCreator(configuration).updateTrackerPriceFlags(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTracker(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseTrackerBeanObject> {
            const localVarFetchArgs = TrackerControllerApiFetchParamCreator(configuration).viewTracker(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TrackerControllerApi - factory interface
 * @export
 */
export const TrackerControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {TrackerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTracker(body: TrackerBean, options?: any) {
            return TrackerControllerApiFp(configuration).createTracker(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTracker(id: number, options?: any) {
            return TrackerControllerApiFp(configuration).deleteTracker(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all Trackers
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {number} [advertiserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerList(sortFieldName?: string, sortOrder?: string, search?: string, advertiserId?: number, options?: any) {
            return TrackerControllerApiFp(configuration).trackerList(sortFieldName, sortOrder, search, advertiserId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {TrackerBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTracker(body: TrackerBean, id: number, options?: any) {
            return TrackerControllerApiFp(configuration).updateTracker(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {TrackerPriceFlagsBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackerPriceFlags(body: TrackerPriceFlagsBean, id: number, options?: any) {
            return TrackerControllerApiFp(configuration).updateTrackerPriceFlags(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewTracker(id: number, options?: any) {
            return TrackerControllerApiFp(configuration).viewTracker(id, options)(fetch, basePath);
        },
    };
};

/**
 * TrackerControllerApi - object-oriented interface
 * @export
 * @class TrackerControllerApi
 * @extends {BaseAPI}
 */
export class TrackerControllerApi extends BaseAPI {
    /**
     * 
     * @param {TrackerBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerControllerApi
     */
    public createTracker(body: TrackerBean, options?: any) {
        return TrackerControllerApiFp(this.configuration).createTracker(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerControllerApi
     */
    public deleteTracker(id: number, options?: any) {
        return TrackerControllerApiFp(this.configuration).deleteTracker(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all Trackers
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [search] 
     * @param {number} [advertiserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerControllerApi
     */
    public trackerList(sortFieldName?: string, sortOrder?: string, search?: string, advertiserId?: number, options?: any) {
        return TrackerControllerApiFp(this.configuration).trackerList(sortFieldName, sortOrder, search, advertiserId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {TrackerBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerControllerApi
     */
    public updateTracker(body: TrackerBean, id: number, options?: any) {
        return TrackerControllerApiFp(this.configuration).updateTracker(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {TrackerPriceFlagsBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerControllerApi
     */
    public updateTrackerPriceFlags(body: TrackerPriceFlagsBean, id: number, options?: any) {
        return TrackerControllerApiFp(this.configuration).updateTrackerPriceFlags(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerControllerApi
     */
    public viewTracker(id: number, options?: any) {
        return TrackerControllerApiFp(this.configuration).viewTracker(id, options)(this.fetch, this.basePath);
    }

}
/**
 * TrackerEventControllerApi - fetch parameter creator
 * @export
 */
export const TrackerEventControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEvent(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling trackerEvent.');
            }
            const localVarPath = `/api/tracker-event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrackerEventBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventCreate(body: TrackerEventBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling trackerEventCreate.');
            }
            const localVarPath = `/api/tracker-event`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TrackerEventBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventDelete(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling trackerEventDelete.');
            }
            const localVarPath = `/api/tracker-event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventPage(sortFieldName?: string, sortOrder?: string, search?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/tracker-event`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortFieldName !== undefined) {
                localVarQueryParameter['sortFieldName'] = sortFieldName;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrackerEventBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventUpdate(body: TrackerEventBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling trackerEventUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling trackerEventUpdate.');
            }
            const localVarPath = `/api/tracker-event/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TrackerEventBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackerEventControllerApi - functional programming interface
 * @export
 */
export const TrackerEventControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEvent(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseTrackerEventBeanObject> {
            const localVarFetchArgs = TrackerEventControllerApiFetchParamCreator(configuration).trackerEvent(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {TrackerEventBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventCreate(body: TrackerEventBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseTrackerEventBeanObject> {
            const localVarFetchArgs = TrackerEventControllerApiFetchParamCreator(configuration).trackerEventCreate(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventDelete(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = TrackerEventControllerApiFetchParamCreator(configuration).trackerEventDelete(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventPage(sortFieldName?: string, sortOrder?: string, search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseTrackerEventBean> {
            const localVarFetchArgs = TrackerEventControllerApiFetchParamCreator(configuration).trackerEventPage(sortFieldName, sortOrder, search, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {TrackerEventBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventUpdate(body: TrackerEventBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseTrackerEventBeanObject> {
            const localVarFetchArgs = TrackerEventControllerApiFetchParamCreator(configuration).trackerEventUpdate(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TrackerEventControllerApi - factory interface
 * @export
 */
export const TrackerEventControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEvent(id: number, options?: any) {
            return TrackerEventControllerApiFp(configuration).trackerEvent(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {TrackerEventBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventCreate(body: TrackerEventBean, options?: any) {
            return TrackerEventControllerApiFp(configuration).trackerEventCreate(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventDelete(id: number, options?: any) {
            return TrackerEventControllerApiFp(configuration).trackerEventDelete(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [sortFieldName] 
         * @param {string} [sortOrder] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventPage(sortFieldName?: string, sortOrder?: string, search?: string, options?: any) {
            return TrackerEventControllerApiFp(configuration).trackerEventPage(sortFieldName, sortOrder, search, options)(fetch, basePath);
        },
        /**
         * 
         * @param {TrackerEventBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackerEventUpdate(body: TrackerEventBean, id: number, options?: any) {
            return TrackerEventControllerApiFp(configuration).trackerEventUpdate(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * TrackerEventControllerApi - object-oriented interface
 * @export
 * @class TrackerEventControllerApi
 * @extends {BaseAPI}
 */
export class TrackerEventControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerEventControllerApi
     */
    public trackerEvent(id: number, options?: any) {
        return TrackerEventControllerApiFp(this.configuration).trackerEvent(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {TrackerEventBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerEventControllerApi
     */
    public trackerEventCreate(body: TrackerEventBean, options?: any) {
        return TrackerEventControllerApiFp(this.configuration).trackerEventCreate(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerEventControllerApi
     */
    public trackerEventDelete(id: number, options?: any) {
        return TrackerEventControllerApiFp(this.configuration).trackerEventDelete(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [sortFieldName] 
     * @param {string} [sortOrder] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerEventControllerApi
     */
    public trackerEventPage(sortFieldName?: string, sortOrder?: string, search?: string, options?: any) {
        return TrackerEventControllerApiFp(this.configuration).trackerEventPage(sortFieldName, sortOrder, search, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {TrackerEventBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackerEventControllerApi
     */
    public trackerEventUpdate(body: TrackerEventBean, id: number, options?: any) {
        return TrackerEventControllerApiFp(this.configuration).trackerEventUpdate(body, id, options)(this.fetch, this.basePath);
    }

}
